/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AuthCreateAPIKeyRequest,
  AuthCreateAPIKeyResponse,
  AuthListAPIKeysResponse,
  AuthLoginRequest,
  AuthLoginResponse,
  AuthLogoutRequest,
  AuthLogoutResponse,
  AuthMeResponse,
  AuthRefreshTokenRequest,
  AuthRefreshTokenResponse,
  AuthRevokeAPIKeyResponse,
  AuthUpdateAPIKeyRequest,
  AuthUpdateAPIKeyResponse,
  ChannelsCreateChannelRequest,
  ChannelsCreateChannelResponse,
  ChannelsDeleteChannelResponse,
  ChannelsGetChannelResponse,
  ChannelsListChannelsResponse,
  ChannelsListTwilioMessagingServicesRequest,
  ChannelsListTwilioMessagingServicesResponse,
  ChannelsTestChannelRequest,
  ChannelsTestChannelResponse,
  ChannelsUpdateChannelRequest,
  ChannelsUpdateChannelResponse,
  DashboardsCreateDashboardRequest,
  DashboardsCreateDashboardResponse,
  DashboardsDuplicateDashboardResponse,
  DashboardsExportRequest,
  DashboardsExportResponse,
  DashboardsGetDashboardResponse,
  DashboardsGetHomeDashboardResponse,
  DashboardsImportRequest,
  DashboardsImportResponse,
  DashboardsListDashboardsResponse,
  DashboardsListRevisionsResponse,
  DashboardsRenameDashboardRequest,
  DashboardsRenameDashboardResponse,
  DashboardsRollbackRequest,
  DashboardsRollbackResponse,
  DashboardsSetHomeDashboardRequest,
  DashboardsUpdateDashboardRequest,
  DashboardsUpdateDashboardResponse,
  DevicesBatchUpdateDeviceStateRequest,
  DevicesBatchUpdateDeviceStateResponse,
  DevicesDeleteDeviceResponse,
  DevicesExecuteCommandRequest,
  DevicesExecuteCommandResponse,
  DevicesGetDeviceHistoryResponse,
  DevicesGetDeviceResponse,
  DevicesListDevicesResponse,
  DevicesUpdateDeviceAvailabilityRequest,
  DevicesUpdateDeviceAvailabilityResponse,
  DevicesUpdateDeviceFavoriteRequest,
  DevicesUpdateDeviceFavoriteResponse,
  DevicesUpdateDeviceRequest,
  DevicesUpdateDeviceResponse,
  DevicesUpdateDeviceStateRequest,
  DevicesUpdateDeviceStateResponse,
  DirigeraAuthenticateHubResponse,
  DirigeraCreateHubRequest,
  DirigeraCreateHubResponse,
  DirigeraCreateSensorMappingRequest,
  DirigeraCreateSensorMappingResponse,
  DirigeraDiscoveryResponse,
  DirigeraGetAllHubsResponse,
  DirigeraGetAllSensorMappingsResponse,
  DirigeraGetHubResponse,
  DirigeraGetSensorMappingResponse,
  DirigeraPauseHubResponse,
  DirigeraResumeHubResponse,
  DirigeraUpdateHubRequest,
  DirigeraUpdateHubResponse,
  DirigeraUpdateSensorMappingRequest,
  DirigeraUpdateSensorMappingResponse,
  EosAddHouseholdRequest,
  EosAddHouseholdResponse,
  EosDeleteHouseholdResponse,
  EosDisableSTBResponse,
  EosEnableSTBRequest,
  EosEnableSTBResponse,
  EosGetHouseholdResponse,
  EosGetSTBResponse,
  EosListHouseholdsResponse,
  EosListProvidersResponse,
  EosListSTBsResponse,
  EosSyncHouseholdResponse,
  EosUpdateHouseholdRequest,
  EosUpdateHouseholdResponse,
  EosUpdateSTBRequest,
  EosUpdateSTBResponse,
  ErrorsAPIError,
  GetApiLogsParams,
  GetApiSettingsHeartbeatsIdLogsParams,
  GetApiUtilitiesCategoriesIdInsightsParams,
  GetApiUtilitiesOverviewParams,
  GetDeviceHistoryParams,
  GetMqttDevicePropertyDefinitionsParams,
  GetSensorAggregatesParams,
  GetSensorHistoryParams,
  HeartbeatsCreateHeartbeatRequest,
  HeartbeatsCreateHeartbeatResponse,
  HeartbeatsDeleteHeartbeatResponse,
  HeartbeatsListHeartbeatsResponse,
  HeartbeatsListLogsResponse,
  HeartbeatsUpdateHeartbeatRequest,
  HeartbeatsUpdateHeartbeatResponse,
  HttpCreateSensorResponse,
  HttpGetAllSensorsResponse,
  HttpGetSensorResponse,
  HttpPreviewResponseBody,
  HttpPreviewResponseRequest,
  HttpSensorRequest,
  HttpUpdateSensorResponse,
  HueAuthenticateBridgeRequest,
  HueAuthenticateBridgeResponse,
  HueCreateBridgeRequest,
  HueCreateBridgeResponse,
  HueCreateDeviceRequest,
  HueCreateDeviceResponse,
  HueDeleteBridgeResponse,
  HueDeleteDeviceResponse,
  HueDiscoverDevicesResponse,
  HueGetAllBridgesResponse,
  HueGetAllDevicesResponse,
  HueGetBridgeResponse,
  HueGetDeviceResponse,
  HueGetDevicesByBridgeResponse,
  HuePauseBridgeResponse,
  HueResumeBridgeResponse,
  HueUpdateBridgeRequest,
  HueUpdateBridgeResponse,
  HueUpdateDeviceRequest,
  HueUpdateDeviceResponse,
  InputsCreateInputBindingRequest,
  InputsCreateInputBindingResponse,
  InputsGetInputResponse,
  InputsListInputBindingsResponse,
  InputsListInputEventsResponse,
  InputsListInputsResponse,
  InputsUpdateInputBindingRequest,
  InputsUpdateInputBindingResponse,
  InputsUpdateInputNameRequest,
  InputsUpdateInputNameResponse,
  IntegrationDirigeraGetAllSensorMappingsParams,
  IntegrationMatterGetAllSensorsParams,
  IntegrationMqttGetAllInputMappingsParams,
  IntegrationMqttGetAllSensorsParams,
  IntegrationMqttGetMessageHistoryParams,
  ListInputEventsParams,
  ListNotificationsParams,
  ListSceneActivationsParams,
  LocationDeleteHomeLocationResponse,
  LocationGetHomeLocationResponse,
  LocationGetSunTimesResponse,
  LocationSetHomeLocationRequest,
  LocationSetHomeLocationResponse,
  LoggerGetLogStatsResponse,
  LoggerGetLogsResponse,
  MatterCreateSensorRequest,
  MatterCreateSensorResponse,
  MatterCreateServerRequest,
  MatterCreateServerResponse,
  MatterGetAllSensorsResponse,
  MatterGetAllServersResponse,
  MatterGetConnectionStateResponse,
  MatterGetHardwareResponse,
  MatterGetSensorResponse,
  MatterGetServerResponse,
  MatterPauseServerResponse,
  MatterResumeServerResponse,
  MatterUpdateSensorRequest,
  MatterUpdateSensorResponse,
  MatterUpdateServerRequest,
  MatterUpdateServerResponse,
  MqttCreateBrokerRequest,
  MqttCreateBrokerResponse,
  MqttCreateDeviceRequest,
  MqttCreateDeviceResponse,
  MqttCreateInputMappingRequest,
  MqttCreateInputMappingResponse,
  MqttCreateSensorRequest,
  MqttCreateSensorResponse,
  MqttGetAllBrokersResponse,
  MqttGetAllDevicesResponse,
  MqttGetAllInputMappingsResponse,
  MqttGetAllSensorsResponse,
  MqttGetBrokerResponse,
  MqttGetDeviceResponse,
  MqttGetInputMappingResponse,
  MqttGetLatestMessagesResponse,
  MqttGetMessageHistoryResponse,
  MqttGetPropertyDefinitionsResponse,
  MqttGetSensorResponse,
  MqttPauseBrokerResponse,
  MqttPreviewExtractionRequest,
  MqttPreviewExtractionResponse,
  MqttResumeBrokerResponse,
  MqttUpdateBrokerRequest,
  MqttUpdateBrokerResponse,
  MqttUpdateDeviceRequest,
  MqttUpdateDeviceResponse,
  MqttUpdateInputMappingRequest,
  MqttUpdateInputMappingResponse,
  MqttUpdateSensorRequest,
  MqttUpdateSensorResponse,
  NotificationsDeletePushDeviceResponse,
  NotificationsGetUnreadCountResponse,
  NotificationsListNotificationsResponse,
  NotificationsMarkAllAsReadResponse,
  NotificationsMarkAsReadResponse,
  NotificationsNotificationSettings,
  NotificationsRegisterPushDeviceRequest,
  NotificationsRegisterPushDeviceResponse,
  NotificationsSendNotificationRequest,
  NotificationsSendNotificationResponse,
  NotificationsUpdateNotificationSettingsRequest,
  PostApiIntegrationsShellyWebhookHardwareIdParams,
  RegionalDeleteRegionalSettingsResponse,
  RegionalGetRegionalSettingsResponse,
  RegionalSetRegionalSettingsRequest,
  RegionalSetRegionalSettingsResponse,
  ScenesActivateSceneRequest,
  ScenesActivateSceneResponse,
  ScenesCreateSceneRequestBody,
  ScenesListActivationsResponse,
  ScenesListScenesResponse,
  ScenesSceneConditionEvaluationResponse,
  ScenesSceneResponse,
  ScenesUpdatePrioritiesRequest,
  SensorsBulkUpdateSensorsRequest,
  SensorsBulkUpdateSensorsResponse,
  SensorsGetMonotonicOffsetHistoryResponse,
  SensorsGetSensorAggregatesResponse,
  SensorsGetSensorHistoryResponse,
  SensorsGetSensorResponse,
  SensorsListSensorsResponse,
  SensorsSetMonotonicOffsetRequest,
  SensorsSetMonotonicOffsetResponse,
  SensorsUpdateSensorConfigRequest,
  SensorsUpdateSensorConfigResponse,
  SensorsUpdateSensorFavoriteRequest,
  SensorsUpdateSensorFavoriteResponse,
  ServerHealthErrorResponse,
  ServerHealthResponse,
  ServerIntegrationsResponse,
  ServerShutdownResponse,
  ShellyConfigureWebhookResponse,
  ShellyCreateDeviceRequest,
  ShellyCreateDeviceResponse,
  ShellyCreateHardwareRequest,
  ShellyCreateHardwareResponse,
  ShellyDeleteDeviceResponse,
  ShellyDeleteHardwareResponse,
  ShellyDiscoverHardwareRequest,
  ShellyDiscoverHardwareResponse,
  ShellyGetAllDevicesResponse,
  ShellyGetAllHardwareResponse,
  ShellyGetDeviceResponse,
  ShellyGetDevicesByHardwareResponse,
  ShellyGetHardwareCapabilitiesResponse,
  ShellyGetHardwareResponse,
  ShellyGetSettingsResponse,
  ShellyListWebhooksResponse,
  ShellyReceiveWebhookResponse,
  ShellyRepairWebhookResponse,
  ShellyTestConnectionResponse,
  ShellyUpdateDeviceRequest,
  ShellyUpdateDeviceResponse,
  ShellyUpdateHardwareRequest,
  ShellyUpdateHardwareResponse,
  ShellyUpdateSettingsRequest,
  ShellyUpdateSettingsResponse,
  ShellyWebhookStatusResponse,
  SlideCloseDeviceResponse,
  SlideCreateDeviceRequest,
  SlideCreateDeviceResponse,
  SlideDeleteDeviceResponse,
  SlideGetAllDevicesResponse,
  SlideGetDeviceResponse,
  SlideOpenDeviceResponse,
  SlideStopDeviceResponse,
  SlideTestConnectionRequest,
  SlideTestConnectionResponse,
  SlideUpdateDeviceRequest,
  SlideUpdateDeviceResponse,
  StreamDeviceUpdatesParams,
  StreamInputEventsParams,
  StreamSensorUpdatesParams,
  UnittypesCreateUnitRequest,
  UnittypesCreateUnitTypeRequest,
  UnittypesListUnitTypesResponse,
  UnittypesUnitResponse,
  UnittypesUnitTypeResponse,
  UnittypesUpdateUnitRequest,
  UnittypesUpdateUnitTypeRequest,
  UtilitiesDeleteConfigResponse,
  UtilitiesExportRequest,
  UtilitiesExportResponse,
  UtilitiesGetConfigResponse,
  UtilitiesImportRequest,
  UtilitiesImportResponse,
  UtilitiesInsightsResponse,
  UtilitiesOverviewResponse,
  UtilitiesSaveConfigRequest,
  UtilitiesSaveConfigResponse,
  ValidationErrorResponse,
  VirtualdevicesCreateVirtualDeviceHTTPRequest,
  VirtualdevicesListVirtualDevicesResponse,
  VirtualdevicesUpdateVirtualDeviceHTTPRequest,
  VirtualdevicesVirtualDeviceResponse,
  WebosAddTVRequest,
  WebosAddTVResponse,
  WebosDeleteTVResponse,
  WebosGetTVResponse,
  WebosListTVsResponse,
  WebosPauseTVResponse,
  WebosResumeTVResponse,
  WebosUpdateTVRequest,
  WebosUpdateTVResponse,
} from '.././model';

import { customInstance } from '../../client';

export const shutdown = (signal?: AbortSignal) => {
  return customInstance<ServerShutdownResponse>({
    url: `/api/admin/shutdown`,
    method: 'POST',
    signal,
  });
};

export const getShutdownMutationOptions = <TError = ErrorsAPIError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof shutdown>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof shutdown>>, TError, void, TContext> => {
  const mutationKey = ['shutdown'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof shutdown>>, void> = () => {
    return shutdown();
  };

  return { mutationFn, ...mutationOptions };
};

export type ShutdownMutationResult = NonNullable<Awaited<ReturnType<typeof shutdown>>>;

export type ShutdownMutationError = ErrorsAPIError;

export const useShutdown = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof shutdown>>, TError, void, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof shutdown>>, TError, void, TContext> => {
  const mutationOptions = getShutdownMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiAuthApiKeys = (signal?: AbortSignal) => {
  return customInstance<AuthListAPIKeysResponse>({
    url: `/api/auth/api-keys`,
    method: 'GET',
    signal,
  });
};

export const getGetApiAuthApiKeysQueryKey = () => {
  return [`/api/auth/api-keys`] as const;
};

export const getGetApiAuthApiKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthApiKeys>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthApiKeys>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAuthApiKeysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthApiKeys>>> = ({ signal }) =>
    getApiAuthApiKeys(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthApiKeys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiAuthApiKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAuthApiKeys>>
>;
export type GetApiAuthApiKeysQueryError = ErrorsAPIError;

export function useGetApiAuthApiKeys<
  TData = Awaited<ReturnType<typeof getApiAuthApiKeys>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthApiKeys>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthApiKeys>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthApiKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiAuthApiKeys<
  TData = Awaited<ReturnType<typeof getApiAuthApiKeys>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthApiKeys>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthApiKeys>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthApiKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiAuthApiKeys<
  TData = Awaited<ReturnType<typeof getApiAuthApiKeys>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthApiKeys>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiAuthApiKeys<
  TData = Awaited<ReturnType<typeof getApiAuthApiKeys>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthApiKeys>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiAuthApiKeysQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiAuthApiKeys = (
  authCreateAPIKeyRequest: AuthCreateAPIKeyRequest,
  signal?: AbortSignal
) => {
  return customInstance<AuthCreateAPIKeyResponse>({
    url: `/api/auth/api-keys`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authCreateAPIKeyRequest,
    signal,
  });
};

export const getPostApiAuthApiKeysMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthApiKeys>>,
    TError,
    { data: AuthCreateAPIKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthApiKeys>>,
  TError,
  { data: AuthCreateAPIKeyRequest },
  TContext
> => {
  const mutationKey = ['postApiAuthApiKeys'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAuthApiKeys>>,
    { data: AuthCreateAPIKeyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiAuthApiKeys(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAuthApiKeysMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAuthApiKeys>>
>;
export type PostApiAuthApiKeysMutationBody = AuthCreateAPIKeyRequest;
export type PostApiAuthApiKeysMutationError = ValidationErrorResponse | ErrorsAPIError;

export const usePostApiAuthApiKeys = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAuthApiKeys>>,
      TError,
      { data: AuthCreateAPIKeyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthApiKeys>>,
  TError,
  { data: AuthCreateAPIKeyRequest },
  TContext
> => {
  const mutationOptions = getPostApiAuthApiKeysMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiAuthApiKeysId = (id: string) => {
  return customInstance<AuthRevokeAPIKeyResponse>({
    url: `/api/auth/api-keys/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiAuthApiKeysIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiAuthApiKeysId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiAuthApiKeysId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiAuthApiKeysId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiAuthApiKeysId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiAuthApiKeysId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiAuthApiKeysIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiAuthApiKeysId>>
>;

export type DeleteApiAuthApiKeysIdMutationError = ErrorsAPIError;

export const useDeleteApiAuthApiKeysId = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiAuthApiKeysId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiAuthApiKeysId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiAuthApiKeysIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const patchApiAuthApiKeysId = (
  id: string,
  authUpdateAPIKeyRequest: AuthUpdateAPIKeyRequest
) => {
  return customInstance<AuthUpdateAPIKeyResponse>({
    url: `/api/auth/api-keys/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: authUpdateAPIKeyRequest,
  });
};

export const getPatchApiAuthApiKeysIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchApiAuthApiKeysId>>,
    TError,
    { id: string; data: AuthUpdateAPIKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchApiAuthApiKeysId>>,
  TError,
  { id: string; data: AuthUpdateAPIKeyRequest },
  TContext
> => {
  const mutationKey = ['patchApiAuthApiKeysId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchApiAuthApiKeysId>>,
    { id: string; data: AuthUpdateAPIKeyRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchApiAuthApiKeysId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchApiAuthApiKeysIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchApiAuthApiKeysId>>
>;
export type PatchApiAuthApiKeysIdMutationBody = AuthUpdateAPIKeyRequest;
export type PatchApiAuthApiKeysIdMutationError = ValidationErrorResponse | ErrorsAPIError;

export const usePatchApiAuthApiKeysId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchApiAuthApiKeysId>>,
      TError,
      { id: string; data: AuthUpdateAPIKeyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchApiAuthApiKeysId>>,
  TError,
  { id: string; data: AuthUpdateAPIKeyRequest },
  TContext
> => {
  const mutationOptions = getPatchApiAuthApiKeysIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const login = (authLoginRequest: AuthLoginRequest, signal?: AbortSignal) => {
  return customInstance<AuthLoginResponse>({
    url: `/api/auth/login`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authLoginRequest,
    signal,
  });
};

export const getLoginMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: AuthLoginRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: AuthLoginRequest },
  TContext
> => {
  const mutationKey = ['login'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: AuthLoginRequest }
  > = (props) => {
    const { data } = props ?? {};

    return login(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>;
export type LoginMutationBody = AuthLoginRequest;
export type LoginMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useLogin = <TError = ValidationErrorResponse | ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof login>>,
      TError,
      { data: AuthLoginRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: AuthLoginRequest },
  TContext
> => {
  const mutationOptions = getLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const logout = (authLogoutRequest: AuthLogoutRequest, signal?: AbortSignal) => {
  return customInstance<AuthLogoutResponse>({
    url: `/api/auth/logout`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authLogoutRequest,
    signal,
  });
};

export const getLogoutMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    { data: AuthLogoutRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  { data: AuthLogoutRequest },
  TContext
> => {
  const mutationKey = ['logout'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    { data: AuthLogoutRequest }
  > = (props) => {
    const { data } = props ?? {};

    return logout(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>;
export type LogoutMutationBody = AuthLogoutRequest;
export type LogoutMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useLogout = <TError = ValidationErrorResponse | ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logout>>,
      TError,
      { data: AuthLogoutRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  { data: AuthLogoutRequest },
  TContext
> => {
  const mutationOptions = getLogoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const me = (signal?: AbortSignal) => {
  return customInstance<AuthMeResponse>({ url: `/api/auth/me`, method: 'GET', signal });
};

export const getMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getMeQueryOptions = <
  TData = Awaited<ReturnType<typeof me>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof me>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>;
export type MeQueryError = ErrorsAPIError;

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorsAPIError>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorsAPIError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorsAPIError>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorsAPIError>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const refreshToken = (
  authRefreshTokenRequest: AuthRefreshTokenRequest,
  signal?: AbortSignal
) => {
  return customInstance<AuthRefreshTokenResponse>({
    url: `/api/auth/refresh`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authRefreshTokenRequest,
    signal,
  });
};

export const getRefreshTokenMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    { data: AuthRefreshTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  { data: AuthRefreshTokenRequest },
  TContext
> => {
  const mutationKey = ['refreshToken'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshToken>>,
    { data: AuthRefreshTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return refreshToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshToken>>>;
export type RefreshTokenMutationBody = AuthRefreshTokenRequest;
export type RefreshTokenMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useRefreshToken = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshToken>>,
      TError,
      { data: AuthRefreshTokenRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  { data: AuthRefreshTokenRequest },
  TContext
> => {
  const mutationOptions = getRefreshTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listChannels = (signal?: AbortSignal) => {
  return customInstance<ChannelsListChannelsResponse>({
    url: `/api/channels`,
    method: 'GET',
    signal,
  });
};

export const getListChannelsQueryKey = () => {
  return [`/api/channels`] as const;
};

export const getListChannelsQueryOptions = <
  TData = Awaited<ReturnType<typeof listChannels>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListChannelsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listChannels>>> = ({ signal }) =>
    listChannels(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listChannels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof listChannels>>>;
export type ListChannelsQueryError = ErrorsAPIError;

export function useListChannels<
  TData = Awaited<ReturnType<typeof listChannels>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChannels>>,
          TError,
          Awaited<ReturnType<typeof listChannels>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChannels<
  TData = Awaited<ReturnType<typeof listChannels>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChannels>>,
          TError,
          Awaited<ReturnType<typeof listChannels>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChannels<
  TData = Awaited<ReturnType<typeof listChannels>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListChannels<
  TData = Awaited<ReturnType<typeof listChannels>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListChannelsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createChannel = (
  channelsCreateChannelRequest: ChannelsCreateChannelRequest,
  signal?: AbortSignal
) => {
  return customInstance<ChannelsCreateChannelResponse>({
    url: `/api/channels`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: channelsCreateChannelRequest,
    signal,
  });
};

export const getCreateChannelMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChannel>>,
    TError,
    { data: ChannelsCreateChannelRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChannel>>,
  TError,
  { data: ChannelsCreateChannelRequest },
  TContext
> => {
  const mutationKey = ['createChannel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChannel>>,
    { data: ChannelsCreateChannelRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createChannel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChannelMutationResult = NonNullable<Awaited<ReturnType<typeof createChannel>>>;
export type CreateChannelMutationBody = ChannelsCreateChannelRequest;
export type CreateChannelMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useCreateChannel = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createChannel>>,
      TError,
      { data: ChannelsCreateChannelRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createChannel>>,
  TError,
  { data: ChannelsCreateChannelRequest },
  TContext
> => {
  const mutationOptions = getCreateChannelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteChannel = (id: string) => {
  return customInstance<ChannelsDeleteChannelResponse>({
    url: `/api/channels/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteChannelMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChannel>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChannel>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteChannel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChannel>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return deleteChannel(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChannelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChannel>>>;

export type DeleteChannelMutationError = ErrorsAPIError;

export const useDeleteChannel = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteChannel>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteChannel>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteChannelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getChannel = (id: string, signal?: AbortSignal) => {
  return customInstance<ChannelsGetChannelResponse>({
    url: `/api/channels/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetChannelQueryKey = (id?: string) => {
  return [`/api/channels/${id}`] as const;
};

export const getGetChannelQueryOptions = <
  TData = Awaited<ReturnType<typeof getChannel>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannel>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChannelQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannel>>> = ({ signal }) =>
    getChannel(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChannel>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetChannelQueryResult = NonNullable<Awaited<ReturnType<typeof getChannel>>>;
export type GetChannelQueryError = ErrorsAPIError;

export function useGetChannel<
  TData = Awaited<ReturnType<typeof getChannel>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannel>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannel>>,
          TError,
          Awaited<ReturnType<typeof getChannel>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChannel<
  TData = Awaited<ReturnType<typeof getChannel>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannel>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannel>>,
          TError,
          Awaited<ReturnType<typeof getChannel>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChannel<
  TData = Awaited<ReturnType<typeof getChannel>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannel>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetChannel<
  TData = Awaited<ReturnType<typeof getChannel>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannel>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetChannelQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateChannel = (
  id: string,
  channelsUpdateChannelRequest: ChannelsUpdateChannelRequest
) => {
  return customInstance<ChannelsUpdateChannelResponse>({
    url: `/api/channels/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: channelsUpdateChannelRequest,
  });
};

export const getUpdateChannelMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChannel>>,
    TError,
    { id: string; data: ChannelsUpdateChannelRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChannel>>,
  TError,
  { id: string; data: ChannelsUpdateChannelRequest },
  TContext
> => {
  const mutationKey = ['updateChannel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChannel>>,
    { id: string; data: ChannelsUpdateChannelRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateChannel(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChannelMutationResult = NonNullable<Awaited<ReturnType<typeof updateChannel>>>;
export type UpdateChannelMutationBody = ChannelsUpdateChannelRequest;
export type UpdateChannelMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateChannel = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateChannel>>,
      TError,
      { id: string; data: ChannelsUpdateChannelRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateChannel>>,
  TError,
  { id: string; data: ChannelsUpdateChannelRequest },
  TContext
> => {
  const mutationOptions = getUpdateChannelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const testChannel = (
  id: string,
  channelsTestChannelRequest: ChannelsTestChannelRequest,
  signal?: AbortSignal
) => {
  return customInstance<ChannelsTestChannelResponse>({
    url: `/api/channels/${id}/test`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: channelsTestChannelRequest,
    signal,
  });
};

export const getTestChannelMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testChannel>>,
    TError,
    { id: string; data: ChannelsTestChannelRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testChannel>>,
  TError,
  { id: string; data: ChannelsTestChannelRequest },
  TContext
> => {
  const mutationKey = ['testChannel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testChannel>>,
    { id: string; data: ChannelsTestChannelRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return testChannel(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestChannelMutationResult = NonNullable<Awaited<ReturnType<typeof testChannel>>>;
export type TestChannelMutationBody = ChannelsTestChannelRequest;
export type TestChannelMutationError = ErrorsAPIError;

export const useTestChannel = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof testChannel>>,
      TError,
      { id: string; data: ChannelsTestChannelRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof testChannel>>,
  TError,
  { id: string; data: ChannelsTestChannelRequest },
  TContext
> => {
  const mutationOptions = getTestChannelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listTwilioMessagingServices = (
  channelsListTwilioMessagingServicesRequest: ChannelsListTwilioMessagingServicesRequest,
  signal?: AbortSignal
) => {
  return customInstance<ChannelsListTwilioMessagingServicesResponse>({
    url: `/api/channels/twilio/messaging-services`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: channelsListTwilioMessagingServicesRequest,
    signal,
  });
};

export const getListTwilioMessagingServicesMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listTwilioMessagingServices>>,
    TError,
    { data: ChannelsListTwilioMessagingServicesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listTwilioMessagingServices>>,
  TError,
  { data: ChannelsListTwilioMessagingServicesRequest },
  TContext
> => {
  const mutationKey = ['listTwilioMessagingServices'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listTwilioMessagingServices>>,
    { data: ChannelsListTwilioMessagingServicesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return listTwilioMessagingServices(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListTwilioMessagingServicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof listTwilioMessagingServices>>
>;
export type ListTwilioMessagingServicesMutationBody = ChannelsListTwilioMessagingServicesRequest;
export type ListTwilioMessagingServicesMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useListTwilioMessagingServices = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listTwilioMessagingServices>>,
      TError,
      { data: ChannelsListTwilioMessagingServicesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listTwilioMessagingServices>>,
  TError,
  { data: ChannelsListTwilioMessagingServicesRequest },
  TContext
> => {
  const mutationOptions = getListTwilioMessagingServicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listDashboards = (signal?: AbortSignal) => {
  return customInstance<DashboardsListDashboardsResponse>({
    url: `/api/dashboards`,
    method: 'GET',
    signal,
  });
};

export const getListDashboardsQueryKey = () => {
  return [`/api/dashboards`] as const;
};

export const getListDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDashboards>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDashboards>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDashboardsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDashboards>>> = ({ signal }) =>
    listDashboards(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDashboards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDashboardsQueryResult = NonNullable<Awaited<ReturnType<typeof listDashboards>>>;
export type ListDashboardsQueryError = ErrorsAPIError;

export function useListDashboards<
  TData = Awaited<ReturnType<typeof listDashboards>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDashboards>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDashboards>>,
          TError,
          Awaited<ReturnType<typeof listDashboards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDashboards<
  TData = Awaited<ReturnType<typeof listDashboards>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDashboards>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDashboards>>,
          TError,
          Awaited<ReturnType<typeof listDashboards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDashboards<
  TData = Awaited<ReturnType<typeof listDashboards>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDashboards>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListDashboards<
  TData = Awaited<ReturnType<typeof listDashboards>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDashboards>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListDashboardsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createDashboard = (
  dashboardsCreateDashboardRequest: DashboardsCreateDashboardRequest,
  signal?: AbortSignal
) => {
  return customInstance<DashboardsCreateDashboardResponse>({
    url: `/api/dashboards`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dashboardsCreateDashboardRequest,
    signal,
  });
};

export const getCreateDashboardMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDashboard>>,
    TError,
    { data: DashboardsCreateDashboardRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDashboard>>,
  TError,
  { data: DashboardsCreateDashboardRequest },
  TContext
> => {
  const mutationKey = ['createDashboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDashboard>>,
    { data: DashboardsCreateDashboardRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDashboard(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDashboard>>
>;
export type CreateDashboardMutationBody = DashboardsCreateDashboardRequest;
export type CreateDashboardMutationError = ErrorsAPIError;

export const useCreateDashboard = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDashboard>>,
      TError,
      { data: DashboardsCreateDashboardRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDashboard>>,
  TError,
  { data: DashboardsCreateDashboardRequest },
  TContext
> => {
  const mutationOptions = getCreateDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteDashboard = (id: string) => {
  return customInstance<void>({ url: `/api/dashboards/${id}`, method: 'DELETE' });
};

export const getDeleteDashboardMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDashboard>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDashboard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteDashboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDashboard>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDashboard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDashboard>>
>;

export type DeleteDashboardMutationError = ErrorsAPIError;

export const useDeleteDashboard = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDashboard>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDashboard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getDashboard = (id: string, signal?: AbortSignal) => {
  return customInstance<DashboardsGetDashboardResponse>({
    url: `/api/dashboards/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetDashboardQueryKey = (id?: string) => {
  return [`/api/dashboards/${id}`] as const;
};

export const getGetDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({ signal }) =>
    getDashboard(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboard>>>;
export type GetDashboardQueryError = ErrorsAPIError;

export function useGetDashboard<
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboard>>,
          TError,
          Awaited<ReturnType<typeof getDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboard<
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboard>>,
          TError,
          Awaited<ReturnType<typeof getDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboard<
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDashboard<
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDashboardQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const renameDashboard = (
  id: string,
  dashboardsRenameDashboardRequest: DashboardsRenameDashboardRequest
) => {
  return customInstance<DashboardsRenameDashboardResponse>({
    url: `/api/dashboards/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: dashboardsRenameDashboardRequest,
  });
};

export const getRenameDashboardMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameDashboard>>,
    TError,
    { id: string; data: DashboardsRenameDashboardRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameDashboard>>,
  TError,
  { id: string; data: DashboardsRenameDashboardRequest },
  TContext
> => {
  const mutationKey = ['renameDashboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameDashboard>>,
    { id: string; data: DashboardsRenameDashboardRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return renameDashboard(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameDashboard>>
>;
export type RenameDashboardMutationBody = DashboardsRenameDashboardRequest;
export type RenameDashboardMutationError = ErrorsAPIError;

export const useRenameDashboard = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameDashboard>>,
      TError,
      { id: string; data: DashboardsRenameDashboardRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof renameDashboard>>,
  TError,
  { id: string; data: DashboardsRenameDashboardRequest },
  TContext
> => {
  const mutationOptions = getRenameDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateDashboard = (
  id: string,
  dashboardsUpdateDashboardRequest: DashboardsUpdateDashboardRequest
) => {
  return customInstance<DashboardsUpdateDashboardResponse>({
    url: `/api/dashboards/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dashboardsUpdateDashboardRequest,
  });
};

export const getUpdateDashboardMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDashboard>>,
    TError,
    { id: string; data: DashboardsUpdateDashboardRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDashboard>>,
  TError,
  { id: string; data: DashboardsUpdateDashboardRequest },
  TContext
> => {
  const mutationKey = ['updateDashboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDashboard>>,
    { id: string; data: DashboardsUpdateDashboardRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDashboard(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDashboard>>
>;
export type UpdateDashboardMutationBody = DashboardsUpdateDashboardRequest;
export type UpdateDashboardMutationError = ErrorsAPIError;

export const useUpdateDashboard = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDashboard>>,
      TError,
      { id: string; data: DashboardsUpdateDashboardRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDashboard>>,
  TError,
  { id: string; data: DashboardsUpdateDashboardRequest },
  TContext
> => {
  const mutationOptions = getUpdateDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const duplicateDashboard = (id: string, signal?: AbortSignal) => {
  return customInstance<DashboardsDuplicateDashboardResponse>({
    url: `/api/dashboards/${id}/duplicate`,
    method: 'POST',
    signal,
  });
};

export const getDuplicateDashboardMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateDashboard>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateDashboard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['duplicateDashboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateDashboard>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return duplicateDashboard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateDashboard>>
>;

export type DuplicateDashboardMutationError = ErrorsAPIError;

export const useDuplicateDashboard = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateDashboard>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateDashboard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDuplicateDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listRevisions = (id: string, signal?: AbortSignal) => {
  return customInstance<DashboardsListRevisionsResponse>({
    url: `/api/dashboards/${id}/revisions`,
    method: 'GET',
    signal,
  });
};

export const getListRevisionsQueryKey = (id?: string) => {
  return [`/api/dashboards/${id}/revisions`] as const;
};

export const getListRevisionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRevisions>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRevisions>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRevisionsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRevisions>>> = ({ signal }) =>
    listRevisions(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRevisions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListRevisionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRevisions>>>;
export type ListRevisionsQueryError = ErrorsAPIError;

export function useListRevisions<
  TData = Awaited<ReturnType<typeof listRevisions>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRevisions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRevisions>>,
          TError,
          Awaited<ReturnType<typeof listRevisions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRevisions<
  TData = Awaited<ReturnType<typeof listRevisions>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRevisions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRevisions>>,
          TError,
          Awaited<ReturnType<typeof listRevisions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRevisions<
  TData = Awaited<ReturnType<typeof listRevisions>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRevisions>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListRevisions<
  TData = Awaited<ReturnType<typeof listRevisions>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRevisions>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListRevisionsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rollbackDashboard = (
  id: string,
  dashboardsRollbackRequest: DashboardsRollbackRequest,
  signal?: AbortSignal
) => {
  return customInstance<DashboardsRollbackResponse>({
    url: `/api/dashboards/${id}/rollback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dashboardsRollbackRequest,
    signal,
  });
};

export const getRollbackDashboardMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rollbackDashboard>>,
    TError,
    { id: string; data: DashboardsRollbackRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rollbackDashboard>>,
  TError,
  { id: string; data: DashboardsRollbackRequest },
  TContext
> => {
  const mutationKey = ['rollbackDashboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rollbackDashboard>>,
    { id: string; data: DashboardsRollbackRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return rollbackDashboard(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RollbackDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof rollbackDashboard>>
>;
export type RollbackDashboardMutationBody = DashboardsRollbackRequest;
export type RollbackDashboardMutationError = ErrorsAPIError;

export const useRollbackDashboard = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rollbackDashboard>>,
      TError,
      { id: string; data: DashboardsRollbackRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof rollbackDashboard>>,
  TError,
  { id: string; data: DashboardsRollbackRequest },
  TContext
> => {
  const mutationOptions = getRollbackDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const exportDashboards = (
  dashboardsExportRequest: DashboardsExportRequest,
  signal?: AbortSignal
) => {
  return customInstance<DashboardsExportResponse>({
    url: `/api/dashboards/export`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dashboardsExportRequest,
    signal,
  });
};

export const getExportDashboardsMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportDashboards>>,
    TError,
    { data: DashboardsExportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportDashboards>>,
  TError,
  { data: DashboardsExportRequest },
  TContext
> => {
  const mutationKey = ['exportDashboards'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportDashboards>>,
    { data: DashboardsExportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportDashboards(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportDashboardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportDashboards>>
>;
export type ExportDashboardsMutationBody = DashboardsExportRequest;
export type ExportDashboardsMutationError = ErrorsAPIError;

export const useExportDashboards = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof exportDashboards>>,
      TError,
      { data: DashboardsExportRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof exportDashboards>>,
  TError,
  { data: DashboardsExportRequest },
  TContext
> => {
  const mutationOptions = getExportDashboardsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getHomeDashboard = (signal?: AbortSignal) => {
  return customInstance<DashboardsGetHomeDashboardResponse>({
    url: `/api/dashboards/home`,
    method: 'GET',
    signal,
  });
};

export const getGetHomeDashboardQueryKey = () => {
  return [`/api/dashboards/home`] as const;
};

export const getGetHomeDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getHomeDashboard>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomeDashboard>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHomeDashboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomeDashboard>>> = ({ signal }) =>
    getHomeDashboard(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHomeDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetHomeDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getHomeDashboard>>>;
export type GetHomeDashboardQueryError = ErrorsAPIError;

export function useGetHomeDashboard<
  TData = Awaited<ReturnType<typeof getHomeDashboard>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomeDashboard>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomeDashboard>>,
          TError,
          Awaited<ReturnType<typeof getHomeDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHomeDashboard<
  TData = Awaited<ReturnType<typeof getHomeDashboard>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomeDashboard>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomeDashboard>>,
          TError,
          Awaited<ReturnType<typeof getHomeDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHomeDashboard<
  TData = Awaited<ReturnType<typeof getHomeDashboard>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomeDashboard>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetHomeDashboard<
  TData = Awaited<ReturnType<typeof getHomeDashboard>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomeDashboard>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetHomeDashboardQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const setHomeDashboard = (
  dashboardsSetHomeDashboardRequest: DashboardsSetHomeDashboardRequest
) => {
  return customInstance<void>({
    url: `/api/dashboards/home`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dashboardsSetHomeDashboardRequest,
  });
};

export const getSetHomeDashboardMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setHomeDashboard>>,
    TError,
    { data: DashboardsSetHomeDashboardRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setHomeDashboard>>,
  TError,
  { data: DashboardsSetHomeDashboardRequest },
  TContext
> => {
  const mutationKey = ['setHomeDashboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setHomeDashboard>>,
    { data: DashboardsSetHomeDashboardRequest }
  > = (props) => {
    const { data } = props ?? {};

    return setHomeDashboard(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetHomeDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof setHomeDashboard>>
>;
export type SetHomeDashboardMutationBody = DashboardsSetHomeDashboardRequest;
export type SetHomeDashboardMutationError = ErrorsAPIError;

export const useSetHomeDashboard = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setHomeDashboard>>,
      TError,
      { data: DashboardsSetHomeDashboardRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setHomeDashboard>>,
  TError,
  { data: DashboardsSetHomeDashboardRequest },
  TContext
> => {
  const mutationOptions = getSetHomeDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const importDashboards = (
  dashboardsImportRequest: DashboardsImportRequest,
  signal?: AbortSignal
) => {
  return customInstance<DashboardsImportResponse>({
    url: `/api/dashboards/import`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dashboardsImportRequest,
    signal,
  });
};

export const getImportDashboardsMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importDashboards>>,
    TError,
    { data: DashboardsImportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importDashboards>>,
  TError,
  { data: DashboardsImportRequest },
  TContext
> => {
  const mutationKey = ['importDashboards'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importDashboards>>,
    { data: DashboardsImportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return importDashboards(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportDashboardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importDashboards>>
>;
export type ImportDashboardsMutationBody = DashboardsImportRequest;
export type ImportDashboardsMutationError = ErrorsAPIError;

export const useImportDashboards = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importDashboards>>,
      TError,
      { data: DashboardsImportRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importDashboards>>,
  TError,
  { data: DashboardsImportRequest },
  TContext
> => {
  const mutationOptions = getImportDashboardsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listDevices = (signal?: AbortSignal) => {
  return customInstance<DevicesListDevicesResponse>({ url: `/api/devices`, method: 'GET', signal });
};

export const getListDevicesQueryKey = () => {
  return [`/api/devices`] as const;
};

export const getListDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDevices>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDevices>>> = ({ signal }) =>
    listDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof listDevices>>>;
export type ListDevicesQueryError = ErrorsAPIError;

export function useListDevices<
  TData = Awaited<ReturnType<typeof listDevices>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDevices>>,
          TError,
          Awaited<ReturnType<typeof listDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDevices<
  TData = Awaited<ReturnType<typeof listDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDevices>>,
          TError,
          Awaited<ReturnType<typeof listDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDevices<
  TData = Awaited<ReturnType<typeof listDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListDevices<
  TData = Awaited<ReturnType<typeof listDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListDevicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteDevice = (id: string) => {
  return customInstance<DevicesDeleteDeviceResponse>({
    url: `/api/devices/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteDeviceMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDevice>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDevice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteDevice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDevice>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return deleteDevice(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDevice>>>;

export type DeleteDeviceMutationError = ErrorsAPIError;

export const useDeleteDevice = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDevice>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDevice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteDeviceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getDevice = (id: string, signal?: AbortSignal) => {
  return customInstance<DevicesGetDeviceResponse>({
    url: `/api/devices/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetDeviceQueryKey = (id?: string) => {
  return [`/api/devices/${id}`] as const;
};

export const getGetDeviceQueryOptions = <
  TData = Awaited<ReturnType<typeof getDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDeviceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevice>>> = ({ signal }) =>
    getDevice(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDevice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getDevice>>>;
export type GetDeviceQueryError = ErrorsAPIError;

export function useGetDevice<
  TData = Awaited<ReturnType<typeof getDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevice>>,
          TError,
          Awaited<ReturnType<typeof getDevice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDevice<
  TData = Awaited<ReturnType<typeof getDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevice>>,
          TError,
          Awaited<ReturnType<typeof getDevice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDevice<
  TData = Awaited<ReturnType<typeof getDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDevice<
  TData = Awaited<ReturnType<typeof getDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDeviceQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateDevice = (
  id: string,
  devicesUpdateDeviceRequest: DevicesUpdateDeviceRequest
) => {
  return customInstance<DevicesUpdateDeviceResponse>({
    url: `/api/devices/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: devicesUpdateDeviceRequest,
  });
};

export const getUpdateDeviceMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDevice>>,
    TError,
    { id: string; data: DevicesUpdateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDevice>>,
  TError,
  { id: string; data: DevicesUpdateDeviceRequest },
  TContext
> => {
  const mutationKey = ['updateDevice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDevice>>,
    { id: string; data: DevicesUpdateDeviceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDevice(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof updateDevice>>>;
export type UpdateDeviceMutationBody = DevicesUpdateDeviceRequest;
export type UpdateDeviceMutationError = ErrorsAPIError;

export const useUpdateDevice = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDevice>>,
      TError,
      { id: string; data: DevicesUpdateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDevice>>,
  TError,
  { id: string; data: DevicesUpdateDeviceRequest },
  TContext
> => {
  const mutationOptions = getUpdateDeviceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateDeviceAvailability = (
  id: string,
  devicesUpdateDeviceAvailabilityRequest: DevicesUpdateDeviceAvailabilityRequest
) => {
  return customInstance<DevicesUpdateDeviceAvailabilityResponse>({
    url: `/api/devices/${id}/availability`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: devicesUpdateDeviceAvailabilityRequest,
  });
};

export const getUpdateDeviceAvailabilityMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeviceAvailability>>,
    TError,
    { id: string; data: DevicesUpdateDeviceAvailabilityRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDeviceAvailability>>,
  TError,
  { id: string; data: DevicesUpdateDeviceAvailabilityRequest },
  TContext
> => {
  const mutationKey = ['updateDeviceAvailability'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDeviceAvailability>>,
    { id: string; data: DevicesUpdateDeviceAvailabilityRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDeviceAvailability(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDeviceAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDeviceAvailability>>
>;
export type UpdateDeviceAvailabilityMutationBody = DevicesUpdateDeviceAvailabilityRequest;
export type UpdateDeviceAvailabilityMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateDeviceAvailability = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDeviceAvailability>>,
      TError,
      { id: string; data: DevicesUpdateDeviceAvailabilityRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDeviceAvailability>>,
  TError,
  { id: string; data: DevicesUpdateDeviceAvailabilityRequest },
  TContext
> => {
  const mutationOptions = getUpdateDeviceAvailabilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const executeCommand = (
  id: string,
  devicesExecuteCommandRequest: DevicesExecuteCommandRequest,
  signal?: AbortSignal
) => {
  return customInstance<DevicesExecuteCommandResponse>({
    url: `/api/devices/${id}/command`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: devicesExecuteCommandRequest,
    signal,
  });
};

export const getExecuteCommandMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeCommand>>,
    TError,
    { id: string; data: DevicesExecuteCommandRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof executeCommand>>,
  TError,
  { id: string; data: DevicesExecuteCommandRequest },
  TContext
> => {
  const mutationKey = ['executeCommand'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof executeCommand>>,
    { id: string; data: DevicesExecuteCommandRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return executeCommand(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExecuteCommandMutationResult = NonNullable<Awaited<ReturnType<typeof executeCommand>>>;
export type ExecuteCommandMutationBody = DevicesExecuteCommandRequest;
export type ExecuteCommandMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useExecuteCommand = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof executeCommand>>,
      TError,
      { id: string; data: DevicesExecuteCommandRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof executeCommand>>,
  TError,
  { id: string; data: DevicesExecuteCommandRequest },
  TContext
> => {
  const mutationOptions = getExecuteCommandMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateDeviceFavorite = (
  id: string,
  devicesUpdateDeviceFavoriteRequest: DevicesUpdateDeviceFavoriteRequest
) => {
  return customInstance<DevicesUpdateDeviceFavoriteResponse>({
    url: `/api/devices/${id}/favorite`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: devicesUpdateDeviceFavoriteRequest,
  });
};

export const getUpdateDeviceFavoriteMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeviceFavorite>>,
    TError,
    { id: string; data: DevicesUpdateDeviceFavoriteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDeviceFavorite>>,
  TError,
  { id: string; data: DevicesUpdateDeviceFavoriteRequest },
  TContext
> => {
  const mutationKey = ['updateDeviceFavorite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDeviceFavorite>>,
    { id: string; data: DevicesUpdateDeviceFavoriteRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDeviceFavorite(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDeviceFavoriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDeviceFavorite>>
>;
export type UpdateDeviceFavoriteMutationBody = DevicesUpdateDeviceFavoriteRequest;
export type UpdateDeviceFavoriteMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateDeviceFavorite = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDeviceFavorite>>,
      TError,
      { id: string; data: DevicesUpdateDeviceFavoriteRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDeviceFavorite>>,
  TError,
  { id: string; data: DevicesUpdateDeviceFavoriteRequest },
  TContext
> => {
  const mutationOptions = getUpdateDeviceFavoriteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getDeviceHistory = (
  id: string,
  params?: GetDeviceHistoryParams,
  signal?: AbortSignal
) => {
  return customInstance<DevicesGetDeviceHistoryResponse>({
    url: `/api/devices/${id}/history`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetDeviceHistoryQueryKey = (id?: string, params?: GetDeviceHistoryParams) => {
  return [`/api/devices/${id}/history`, ...(params ? [params] : [])] as const;
};

export const getGetDeviceHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeviceHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetDeviceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDeviceHistoryQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceHistory>>> = ({ signal }) =>
    getDeviceHistory(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeviceHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDeviceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceHistory>>>;
export type GetDeviceHistoryQueryError = ErrorsAPIError;

export function useGetDeviceHistory<
  TData = Awaited<ReturnType<typeof getDeviceHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: undefined | GetDeviceHistoryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceHistory>>,
          TError,
          Awaited<ReturnType<typeof getDeviceHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDeviceHistory<
  TData = Awaited<ReturnType<typeof getDeviceHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetDeviceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceHistory>>,
          TError,
          Awaited<ReturnType<typeof getDeviceHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDeviceHistory<
  TData = Awaited<ReturnType<typeof getDeviceHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetDeviceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDeviceHistory<
  TData = Awaited<ReturnType<typeof getDeviceHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetDeviceHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDeviceHistoryQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateDeviceState = (
  id: string,
  devicesUpdateDeviceStateRequest: DevicesUpdateDeviceStateRequest
) => {
  return customInstance<DevicesUpdateDeviceStateResponse>({
    url: `/api/devices/${id}/state`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: devicesUpdateDeviceStateRequest,
  });
};

export const getUpdateDeviceStateMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeviceState>>,
    TError,
    { id: string; data: DevicesUpdateDeviceStateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDeviceState>>,
  TError,
  { id: string; data: DevicesUpdateDeviceStateRequest },
  TContext
> => {
  const mutationKey = ['updateDeviceState'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDeviceState>>,
    { id: string; data: DevicesUpdateDeviceStateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDeviceState(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDeviceStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDeviceState>>
>;
export type UpdateDeviceStateMutationBody = DevicesUpdateDeviceStateRequest;
export type UpdateDeviceStateMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateDeviceState = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDeviceState>>,
      TError,
      { id: string; data: DevicesUpdateDeviceStateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDeviceState>>,
  TError,
  { id: string; data: DevicesUpdateDeviceStateRequest },
  TContext
> => {
  const mutationOptions = getUpdateDeviceStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const batchUpdateDeviceState = (
  devicesBatchUpdateDeviceStateRequest: DevicesBatchUpdateDeviceStateRequest,
  signal?: AbortSignal
) => {
  return customInstance<DevicesBatchUpdateDeviceStateResponse>({
    url: `/api/devices/batch-state`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: devicesBatchUpdateDeviceStateRequest,
    signal,
  });
};

export const getBatchUpdateDeviceStateMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchUpdateDeviceState>>,
    TError,
    { data: DevicesBatchUpdateDeviceStateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchUpdateDeviceState>>,
  TError,
  { data: DevicesBatchUpdateDeviceStateRequest },
  TContext
> => {
  const mutationKey = ['batchUpdateDeviceState'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchUpdateDeviceState>>,
    { data: DevicesBatchUpdateDeviceStateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return batchUpdateDeviceState(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchUpdateDeviceStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchUpdateDeviceState>>
>;
export type BatchUpdateDeviceStateMutationBody = DevicesBatchUpdateDeviceStateRequest;
export type BatchUpdateDeviceStateMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useBatchUpdateDeviceState = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchUpdateDeviceState>>,
      TError,
      { data: DevicesBatchUpdateDeviceStateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof batchUpdateDeviceState>>,
  TError,
  { data: DevicesBatchUpdateDeviceStateRequest },
  TContext
> => {
  const mutationOptions = getBatchUpdateDeviceStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const streamDeviceUpdates = (params?: StreamDeviceUpdatesParams, signal?: AbortSignal) => {
  return customInstance<unknown>({ url: `/api/devices/stream`, method: 'GET', params, signal });
};

export const getStreamDeviceUpdatesQueryKey = (params?: StreamDeviceUpdatesParams) => {
  return [`/api/devices/stream`, ...(params ? [params] : [])] as const;
};

export const getStreamDeviceUpdatesQueryOptions = <
  TData = Awaited<ReturnType<typeof streamDeviceUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamDeviceUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamDeviceUpdates>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamDeviceUpdatesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamDeviceUpdates>>> = ({ signal }) =>
    streamDeviceUpdates(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamDeviceUpdates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamDeviceUpdatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamDeviceUpdates>>
>;
export type StreamDeviceUpdatesQueryError = void | ErrorsAPIError;

export function useStreamDeviceUpdates<
  TData = Awaited<ReturnType<typeof streamDeviceUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params: undefined | StreamDeviceUpdatesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamDeviceUpdates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamDeviceUpdates>>,
          TError,
          Awaited<ReturnType<typeof streamDeviceUpdates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamDeviceUpdates<
  TData = Awaited<ReturnType<typeof streamDeviceUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamDeviceUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamDeviceUpdates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamDeviceUpdates>>,
          TError,
          Awaited<ReturnType<typeof streamDeviceUpdates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamDeviceUpdates<
  TData = Awaited<ReturnType<typeof streamDeviceUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamDeviceUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamDeviceUpdates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStreamDeviceUpdates<
  TData = Awaited<ReturnType<typeof streamDeviceUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamDeviceUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamDeviceUpdates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamDeviceUpdatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const health = (signal?: AbortSignal) => {
  return customInstance<ServerHealthResponse>({ url: `/api/health`, method: 'GET', signal });
};

export const getHealthQueryKey = () => {
  return [`/api/health`] as const;
};

export const getHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof health>>,
  TError = ServerHealthErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = ({ signal }) => health(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof health>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type HealthQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>;
export type HealthQueryError = ServerHealthErrorResponse;

export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = ServerHealthErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = ServerHealthErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = ServerHealthErrorResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useHealth<
  TData = Awaited<ReturnType<typeof health>>,
  TError = ServerHealthErrorResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getHealthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listInputs = (signal?: AbortSignal) => {
  return customInstance<InputsListInputsResponse>({ url: `/api/inputs`, method: 'GET', signal });
};

export const getListInputsQueryKey = () => {
  return [`/api/inputs`] as const;
};

export const getListInputsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInputs>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputs>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInputsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInputs>>> = ({ signal }) =>
    listInputs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInputs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListInputsQueryResult = NonNullable<Awaited<ReturnType<typeof listInputs>>>;
export type ListInputsQueryError = ErrorsAPIError;

export function useListInputs<
  TData = Awaited<ReturnType<typeof listInputs>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInputs>>,
          TError,
          Awaited<ReturnType<typeof listInputs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInputs<
  TData = Awaited<ReturnType<typeof listInputs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInputs>>,
          TError,
          Awaited<ReturnType<typeof listInputs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInputs<
  TData = Awaited<ReturnType<typeof listInputs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListInputs<
  TData = Awaited<ReturnType<typeof listInputs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListInputsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getInput = (id: string, signal?: AbortSignal) => {
  return customInstance<InputsGetInputResponse>({
    url: `/api/inputs/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetInputQueryKey = (id?: string) => {
  return [`/api/inputs/${id}`] as const;
};

export const getGetInputQueryOptions = <
  TData = Awaited<ReturnType<typeof getInput>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInput>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInputQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInput>>> = ({ signal }) =>
    getInput(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInput>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetInputQueryResult = NonNullable<Awaited<ReturnType<typeof getInput>>>;
export type GetInputQueryError = ErrorsAPIError;

export function useGetInput<TData = Awaited<ReturnType<typeof getInput>>, TError = ErrorsAPIError>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInput>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInput>>,
          TError,
          Awaited<ReturnType<typeof getInput>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInput<TData = Awaited<ReturnType<typeof getInput>>, TError = ErrorsAPIError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInput>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInput>>,
          TError,
          Awaited<ReturnType<typeof getInput>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInput<TData = Awaited<ReturnType<typeof getInput>>, TError = ErrorsAPIError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInput>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetInput<TData = Awaited<ReturnType<typeof getInput>>, TError = ErrorsAPIError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInput>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetInputQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateInputName = (
  id: string,
  inputsUpdateInputNameRequest: InputsUpdateInputNameRequest
) => {
  return customInstance<InputsUpdateInputNameResponse>({
    url: `/api/inputs/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: inputsUpdateInputNameRequest,
  });
};

export const getUpdateInputNameMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInputName>>,
    TError,
    { id: string; data: InputsUpdateInputNameRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInputName>>,
  TError,
  { id: string; data: InputsUpdateInputNameRequest },
  TContext
> => {
  const mutationKey = ['updateInputName'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInputName>>,
    { id: string; data: InputsUpdateInputNameRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInputName(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInputNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInputName>>
>;
export type UpdateInputNameMutationBody = InputsUpdateInputNameRequest;
export type UpdateInputNameMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateInputName = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateInputName>>,
      TError,
      { id: string; data: InputsUpdateInputNameRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateInputName>>,
  TError,
  { id: string; data: InputsUpdateInputNameRequest },
  TContext
> => {
  const mutationOptions = getUpdateInputNameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listInputBindings = (id: string, signal?: AbortSignal) => {
  return customInstance<InputsListInputBindingsResponse>({
    url: `/api/inputs/${id}/bindings`,
    method: 'GET',
    signal,
  });
};

export const getListInputBindingsQueryKey = (id?: string) => {
  return [`/api/inputs/${id}/bindings`] as const;
};

export const getListInputBindingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInputBindings>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputBindings>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInputBindingsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInputBindings>>> = ({ signal }) =>
    listInputBindings(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInputBindings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListInputBindingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInputBindings>>
>;
export type ListInputBindingsQueryError = ErrorsAPIError;

export function useListInputBindings<
  TData = Awaited<ReturnType<typeof listInputBindings>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputBindings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInputBindings>>,
          TError,
          Awaited<ReturnType<typeof listInputBindings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInputBindings<
  TData = Awaited<ReturnType<typeof listInputBindings>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputBindings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInputBindings>>,
          TError,
          Awaited<ReturnType<typeof listInputBindings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInputBindings<
  TData = Awaited<ReturnType<typeof listInputBindings>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputBindings>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListInputBindings<
  TData = Awaited<ReturnType<typeof listInputBindings>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputBindings>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListInputBindingsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createInputBinding = (
  id: string,
  inputsCreateInputBindingRequest: InputsCreateInputBindingRequest,
  signal?: AbortSignal
) => {
  return customInstance<InputsCreateInputBindingResponse>({
    url: `/api/inputs/${id}/bindings`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: inputsCreateInputBindingRequest,
    signal,
  });
};

export const getCreateInputBindingMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInputBinding>>,
    TError,
    { id: string; data: InputsCreateInputBindingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInputBinding>>,
  TError,
  { id: string; data: InputsCreateInputBindingRequest },
  TContext
> => {
  const mutationKey = ['createInputBinding'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInputBinding>>,
    { id: string; data: InputsCreateInputBindingRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return createInputBinding(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInputBindingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInputBinding>>
>;
export type CreateInputBindingMutationBody = InputsCreateInputBindingRequest;
export type CreateInputBindingMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useCreateInputBinding = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInputBinding>>,
      TError,
      { id: string; data: InputsCreateInputBindingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createInputBinding>>,
  TError,
  { id: string; data: InputsCreateInputBindingRequest },
  TContext
> => {
  const mutationOptions = getCreateInputBindingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteInputBinding = (id: string, bindingId: string) => {
  return customInstance<void>({ url: `/api/inputs/${id}/bindings/${bindingId}`, method: 'DELETE' });
};

export const getDeleteInputBindingMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInputBinding>>,
    TError,
    { id: string; bindingId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInputBinding>>,
  TError,
  { id: string; bindingId: string },
  TContext
> => {
  const mutationKey = ['deleteInputBinding'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInputBinding>>,
    { id: string; bindingId: string }
  > = (props) => {
    const { id, bindingId } = props ?? {};

    return deleteInputBinding(id, bindingId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInputBindingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInputBinding>>
>;

export type DeleteInputBindingMutationError = ErrorsAPIError;

export const useDeleteInputBinding = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteInputBinding>>,
      TError,
      { id: string; bindingId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteInputBinding>>,
  TError,
  { id: string; bindingId: string },
  TContext
> => {
  const mutationOptions = getDeleteInputBindingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateInputBinding = (
  id: string,
  bindingId: string,
  inputsUpdateInputBindingRequest: InputsUpdateInputBindingRequest
) => {
  return customInstance<InputsUpdateInputBindingResponse>({
    url: `/api/inputs/${id}/bindings/${bindingId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: inputsUpdateInputBindingRequest,
  });
};

export const getUpdateInputBindingMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInputBinding>>,
    TError,
    { id: string; bindingId: string; data: InputsUpdateInputBindingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInputBinding>>,
  TError,
  { id: string; bindingId: string; data: InputsUpdateInputBindingRequest },
  TContext
> => {
  const mutationKey = ['updateInputBinding'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInputBinding>>,
    { id: string; bindingId: string; data: InputsUpdateInputBindingRequest }
  > = (props) => {
    const { id, bindingId, data } = props ?? {};

    return updateInputBinding(id, bindingId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInputBindingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInputBinding>>
>;
export type UpdateInputBindingMutationBody = InputsUpdateInputBindingRequest;
export type UpdateInputBindingMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateInputBinding = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateInputBinding>>,
      TError,
      { id: string; bindingId: string; data: InputsUpdateInputBindingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateInputBinding>>,
  TError,
  { id: string; bindingId: string; data: InputsUpdateInputBindingRequest },
  TContext
> => {
  const mutationOptions = getUpdateInputBindingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listInputEvents = (
  id: string,
  params?: ListInputEventsParams,
  signal?: AbortSignal
) => {
  return customInstance<InputsListInputEventsResponse>({
    url: `/api/inputs/${id}/events`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListInputEventsQueryKey = (id?: string, params?: ListInputEventsParams) => {
  return [`/api/inputs/${id}/events`, ...(params ? [params] : [])] as const;
};

export const getListInputEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInputEvents>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: ListInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputEvents>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInputEventsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInputEvents>>> = ({ signal }) =>
    listInputEvents(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInputEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListInputEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listInputEvents>>>;
export type ListInputEventsQueryError = ErrorsAPIError;

export function useListInputEvents<
  TData = Awaited<ReturnType<typeof listInputEvents>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: undefined | ListInputEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInputEvents>>,
          TError,
          Awaited<ReturnType<typeof listInputEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInputEvents<
  TData = Awaited<ReturnType<typeof listInputEvents>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: ListInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInputEvents>>,
          TError,
          Awaited<ReturnType<typeof listInputEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInputEvents<
  TData = Awaited<ReturnType<typeof listInputEvents>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: ListInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListInputEvents<
  TData = Awaited<ReturnType<typeof listInputEvents>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: ListInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInputEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListInputEventsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const streamInputEvents = (params?: StreamInputEventsParams, signal?: AbortSignal) => {
  return customInstance<unknown>({ url: `/api/inputs/stream`, method: 'GET', params, signal });
};

export const getStreamInputEventsQueryKey = (params?: StreamInputEventsParams) => {
  return [`/api/inputs/stream`, ...(params ? [params] : [])] as const;
};

export const getStreamInputEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamInputEvents>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamInputEvents>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamInputEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamInputEvents>>> = ({ signal }) =>
    streamInputEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamInputEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamInputEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamInputEvents>>
>;
export type StreamInputEventsQueryError = void | ErrorsAPIError;

export function useStreamInputEvents<
  TData = Awaited<ReturnType<typeof streamInputEvents>>,
  TError = void | ErrorsAPIError,
>(
  params: undefined | StreamInputEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamInputEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamInputEvents>>,
          TError,
          Awaited<ReturnType<typeof streamInputEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamInputEvents<
  TData = Awaited<ReturnType<typeof streamInputEvents>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamInputEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamInputEvents>>,
          TError,
          Awaited<ReturnType<typeof streamInputEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamInputEvents<
  TData = Awaited<ReturnType<typeof streamInputEvents>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamInputEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStreamInputEvents<
  TData = Awaited<ReturnType<typeof streamInputEvents>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamInputEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamInputEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamInputEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listIntegrations = (signal?: AbortSignal) => {
  return customInstance<ServerIntegrationsResponse>({
    url: `/api/integrations`,
    method: 'GET',
    signal,
  });
};

export const getListIntegrationsQueryKey = () => {
  return [`/api/integrations`] as const;
};

export const getListIntegrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listIntegrations>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListIntegrationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrations>>> = ({ signal }) =>
    listIntegrations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listIntegrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrations>>>;
export type ListIntegrationsQueryError = unknown;

export function useListIntegrations<
  TData = Awaited<ReturnType<typeof listIntegrations>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIntegrations>>,
          TError,
          Awaited<ReturnType<typeof listIntegrations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListIntegrations<
  TData = Awaited<ReturnType<typeof listIntegrations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIntegrations>>,
          TError,
          Awaited<ReturnType<typeof listIntegrations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListIntegrations<
  TData = Awaited<ReturnType<typeof listIntegrations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListIntegrations<
  TData = Awaited<ReturnType<typeof listIntegrations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListIntegrationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiIntegrationsEosHouseholds = (signal?: AbortSignal) => {
  return customInstance<EosListHouseholdsResponse>({
    url: `/api/integrations/eos/households`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsEosHouseholdsQueryKey = () => {
  return [`/api/integrations/eos/households`] as const;
};

export const getGetApiIntegrationsEosHouseholdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsEosHouseholdsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>> = ({
    signal,
  }) => getApiIntegrationsEosHouseholds(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsEosHouseholdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>
>;
export type GetApiIntegrationsEosHouseholdsQueryError = ErrorsAPIError;

export function useGetApiIntegrationsEosHouseholds<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosHouseholds<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosHouseholds<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsEosHouseholds<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsEosHouseholdsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsEosHouseholds = (
  eosAddHouseholdRequest: EosAddHouseholdRequest,
  signal?: AbortSignal
) => {
  return customInstance<EosAddHouseholdResponse>({
    url: `/api/integrations/eos/households`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eosAddHouseholdRequest,
    signal,
  });
};

export const getPostApiIntegrationsEosHouseholdsMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsEosHouseholds>>,
    TError,
    { data: EosAddHouseholdRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsEosHouseholds>>,
  TError,
  { data: EosAddHouseholdRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsEosHouseholds'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsEosHouseholds>>,
    { data: EosAddHouseholdRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsEosHouseholds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsEosHouseholdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsEosHouseholds>>
>;
export type PostApiIntegrationsEosHouseholdsMutationBody = EosAddHouseholdRequest;
export type PostApiIntegrationsEosHouseholdsMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePostApiIntegrationsEosHouseholds = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsEosHouseholds>>,
      TError,
      { data: EosAddHouseholdRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsEosHouseholds>>,
  TError,
  { data: EosAddHouseholdRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsEosHouseholdsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiIntegrationsEosHouseholdsId = (id: string) => {
  return customInstance<EosDeleteHouseholdResponse>({
    url: `/api/integrations/eos/households/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiIntegrationsEosHouseholdsIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiIntegrationsEosHouseholdsId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiIntegrationsEosHouseholdsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiIntegrationsEosHouseholdsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiIntegrationsEosHouseholdsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiIntegrationsEosHouseholdsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiIntegrationsEosHouseholdsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiIntegrationsEosHouseholdsId>>
>;

export type DeleteApiIntegrationsEosHouseholdsIdMutationError = ErrorsAPIError;

export const useDeleteApiIntegrationsEosHouseholdsId = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiIntegrationsEosHouseholdsId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiIntegrationsEosHouseholdsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiIntegrationsEosHouseholdsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsEosHouseholdsId = (id: string, signal?: AbortSignal) => {
  return customInstance<EosGetHouseholdResponse>({
    url: `/api/integrations/eos/households/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsEosHouseholdsIdQueryKey = (id?: string) => {
  return [`/api/integrations/eos/households/${id}`] as const;
};

export const getGetApiIntegrationsEosHouseholdsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsEosHouseholdsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>> = ({
    signal,
  }) => getApiIntegrationsEosHouseholdsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsEosHouseholdsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>
>;
export type GetApiIntegrationsEosHouseholdsIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsEosHouseholdsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosHouseholdsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosHouseholdsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsEosHouseholdsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsEosHouseholdsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsEosHouseholdsId = (
  id: string,
  eosUpdateHouseholdRequest: EosUpdateHouseholdRequest
) => {
  return customInstance<EosUpdateHouseholdResponse>({
    url: `/api/integrations/eos/households/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: eosUpdateHouseholdRequest,
  });
};

export const getPutApiIntegrationsEosHouseholdsIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsEosHouseholdsId>>,
    TError,
    { id: string; data: EosUpdateHouseholdRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsEosHouseholdsId>>,
  TError,
  { id: string; data: EosUpdateHouseholdRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsEosHouseholdsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsEosHouseholdsId>>,
    { id: string; data: EosUpdateHouseholdRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsEosHouseholdsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsEosHouseholdsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsEosHouseholdsId>>
>;
export type PutApiIntegrationsEosHouseholdsIdMutationBody = EosUpdateHouseholdRequest;
export type PutApiIntegrationsEosHouseholdsIdMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePutApiIntegrationsEosHouseholdsId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsEosHouseholdsId>>,
      TError,
      { id: string; data: EosUpdateHouseholdRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsEosHouseholdsId>>,
  TError,
  { id: string; data: EosUpdateHouseholdRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsEosHouseholdsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsEosHouseholdsIdStbs = (id: string, signal?: AbortSignal) => {
  return customInstance<EosListSTBsResponse>({
    url: `/api/integrations/eos/households/${id}/stbs`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsEosHouseholdsIdStbsQueryKey = (id?: string) => {
  return [`/api/integrations/eos/households/${id}/stbs`] as const;
};

export const getGetApiIntegrationsEosHouseholdsIdStbsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsEosHouseholdsIdStbsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>
  > = ({ signal }) => getApiIntegrationsEosHouseholdsIdStbs(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsEosHouseholdsIdStbsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>
>;
export type GetApiIntegrationsEosHouseholdsIdStbsQueryError = ErrorsAPIError;

export function useGetApiIntegrationsEosHouseholdsIdStbs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosHouseholdsIdStbs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosHouseholdsIdStbs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsEosHouseholdsIdStbs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsEosHouseholdsIdStbs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsEosHouseholdsIdStbsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsEosHouseholdsIdSync = (id: string, signal?: AbortSignal) => {
  return customInstance<EosSyncHouseholdResponse>({
    url: `/api/integrations/eos/households/${id}/sync`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsEosHouseholdsIdSyncMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsEosHouseholdsIdSync>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsEosHouseholdsIdSync>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsEosHouseholdsIdSync'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsEosHouseholdsIdSync>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsEosHouseholdsIdSync(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsEosHouseholdsIdSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsEosHouseholdsIdSync>>
>;

export type PostApiIntegrationsEosHouseholdsIdSyncMutationError = ErrorsAPIError;

export const usePostApiIntegrationsEosHouseholdsIdSync = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsEosHouseholdsIdSync>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsEosHouseholdsIdSync>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsEosHouseholdsIdSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsEosProviders = (signal?: AbortSignal) => {
  return customInstance<EosListProvidersResponse>({
    url: `/api/integrations/eos/providers`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsEosProvidersQueryKey = () => {
  return [`/api/integrations/eos/providers`] as const;
};

export const getGetApiIntegrationsEosProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsEosProvidersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>> = ({
    signal,
  }) => getApiIntegrationsEosProviders(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsEosProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>
>;
export type GetApiIntegrationsEosProvidersQueryError = unknown;

export function useGetApiIntegrationsEosProviders<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosProviders<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosProviders<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsEosProviders<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosProviders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsEosProvidersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiIntegrationsEosStbsId = (id: string, signal?: AbortSignal) => {
  return customInstance<EosGetSTBResponse>({
    url: `/api/integrations/eos/stbs/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsEosStbsIdQueryKey = (id?: string) => {
  return [`/api/integrations/eos/stbs/${id}`] as const;
};

export const getGetApiIntegrationsEosStbsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsEosStbsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>> = ({
    signal,
  }) => getApiIntegrationsEosStbsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsEosStbsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>
>;
export type GetApiIntegrationsEosStbsIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsEosStbsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosStbsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsEosStbsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsEosStbsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsEosStbsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsEosStbsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsEosStbsId = (
  id: string,
  eosUpdateSTBRequest: EosUpdateSTBRequest
) => {
  return customInstance<EosUpdateSTBResponse>({
    url: `/api/integrations/eos/stbs/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: eosUpdateSTBRequest,
  });
};

export const getPutApiIntegrationsEosStbsIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsEosStbsId>>,
    TError,
    { id: string; data: EosUpdateSTBRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsEosStbsId>>,
  TError,
  { id: string; data: EosUpdateSTBRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsEosStbsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsEosStbsId>>,
    { id: string; data: EosUpdateSTBRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsEosStbsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsEosStbsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsEosStbsId>>
>;
export type PutApiIntegrationsEosStbsIdMutationBody = EosUpdateSTBRequest;
export type PutApiIntegrationsEosStbsIdMutationError = ValidationErrorResponse | ErrorsAPIError;

export const usePutApiIntegrationsEosStbsId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsEosStbsId>>,
      TError,
      { id: string; data: EosUpdateSTBRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsEosStbsId>>,
  TError,
  { id: string; data: EosUpdateSTBRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsEosStbsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsEosStbsIdDisable = (id: string, signal?: AbortSignal) => {
  return customInstance<EosDisableSTBResponse>({
    url: `/api/integrations/eos/stbs/${id}/disable`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsEosStbsIdDisableMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdDisable>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdDisable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsEosStbsIdDisable'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdDisable>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsEosStbsIdDisable(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsEosStbsIdDisableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdDisable>>
>;

export type PostApiIntegrationsEosStbsIdDisableMutationError = ErrorsAPIError;

export const usePostApiIntegrationsEosStbsIdDisable = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdDisable>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdDisable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsEosStbsIdDisableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsEosStbsIdEnable = (
  id: string,
  eosEnableSTBRequest: EosEnableSTBRequest,
  signal?: AbortSignal
) => {
  return customInstance<EosEnableSTBResponse>({
    url: `/api/integrations/eos/stbs/${id}/enable`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eosEnableSTBRequest,
    signal,
  });
};

export const getPostApiIntegrationsEosStbsIdEnableMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdEnable>>,
    TError,
    { id: string; data: EosEnableSTBRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdEnable>>,
  TError,
  { id: string; data: EosEnableSTBRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsEosStbsIdEnable'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdEnable>>,
    { id: string; data: EosEnableSTBRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiIntegrationsEosStbsIdEnable(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsEosStbsIdEnableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdEnable>>
>;
export type PostApiIntegrationsEosStbsIdEnableMutationBody = EosEnableSTBRequest;
export type PostApiIntegrationsEosStbsIdEnableMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePostApiIntegrationsEosStbsIdEnable = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdEnable>>,
      TError,
      { id: string; data: EosEnableSTBRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsEosStbsIdEnable>>,
  TError,
  { id: string; data: EosEnableSTBRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsEosStbsIdEnableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationHttpGetAllSensors = (signal?: AbortSignal) => {
  return customInstance<HttpGetAllSensorsResponse>({
    url: `/api/integrations/http/sensors`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationHttpGetAllSensorsQueryKey = () => {
  return [`/api/integrations/http/sensors`] as const;
};

export const getIntegrationHttpGetAllSensorsQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetAllSensors>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationHttpGetAllSensorsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationHttpGetAllSensors>>> = ({
    signal,
  }) => integrationHttpGetAllSensors(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationHttpGetAllSensorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationHttpGetAllSensors>>
>;
export type IntegrationHttpGetAllSensorsQueryError = ErrorsAPIError;

export function useIntegrationHttpGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetAllSensors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
          TError,
          Awaited<ReturnType<typeof integrationHttpGetAllSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationHttpGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetAllSensors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
          TError,
          Awaited<ReturnType<typeof integrationHttpGetAllSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationHttpGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetAllSensors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationHttpGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationHttpGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetAllSensors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationHttpGetAllSensorsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationHttpCreateSensor = (
  httpSensorRequest: HttpSensorRequest,
  signal?: AbortSignal
) => {
  return customInstance<HttpCreateSensorResponse>({
    url: `/api/integrations/http/sensors`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: httpSensorRequest,
    signal,
  });
};

export const getIntegrationHttpCreateSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationHttpCreateSensor>>,
    TError,
    { data: HttpSensorRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationHttpCreateSensor>>,
  TError,
  { data: HttpSensorRequest },
  TContext
> => {
  const mutationKey = ['integrationHttpCreateSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationHttpCreateSensor>>,
    { data: HttpSensorRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationHttpCreateSensor(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationHttpCreateSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationHttpCreateSensor>>
>;
export type IntegrationHttpCreateSensorMutationBody = HttpSensorRequest;
export type IntegrationHttpCreateSensorMutationError = ErrorsAPIError;

export const useIntegrationHttpCreateSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationHttpCreateSensor>>,
      TError,
      { data: HttpSensorRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationHttpCreateSensor>>,
  TError,
  { data: HttpSensorRequest },
  TContext
> => {
  const mutationOptions = getIntegrationHttpCreateSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationHttpDeleteSensor = (id: string) => {
  return customInstance<void>({ url: `/api/integrations/http/sensors/${id}`, method: 'DELETE' });
};

export const getIntegrationHttpDeleteSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationHttpDeleteSensor>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationHttpDeleteSensor>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationHttpDeleteSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationHttpDeleteSensor>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationHttpDeleteSensor(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationHttpDeleteSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationHttpDeleteSensor>>
>;

export type IntegrationHttpDeleteSensorMutationError = ErrorsAPIError;

export const useIntegrationHttpDeleteSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationHttpDeleteSensor>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationHttpDeleteSensor>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationHttpDeleteSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationHttpGetSensor = (id: string, signal?: AbortSignal) => {
  return customInstance<HttpGetSensorResponse>({
    url: `/api/integrations/http/sensors/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationHttpGetSensorQueryKey = (id?: string) => {
  return [`/api/integrations/http/sensors/${id}`] as const;
};

export const getIntegrationHttpGetSensorQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationHttpGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetSensor>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationHttpGetSensorQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationHttpGetSensor>>> = ({
    signal,
  }) => integrationHttpGetSensor(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationHttpGetSensor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationHttpGetSensorQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationHttpGetSensor>>
>;
export type IntegrationHttpGetSensorQueryError = ErrorsAPIError;

export function useIntegrationHttpGetSensor<
  TData = Awaited<ReturnType<typeof integrationHttpGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetSensor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationHttpGetSensor>>,
          TError,
          Awaited<ReturnType<typeof integrationHttpGetSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationHttpGetSensor<
  TData = Awaited<ReturnType<typeof integrationHttpGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetSensor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationHttpGetSensor>>,
          TError,
          Awaited<ReturnType<typeof integrationHttpGetSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationHttpGetSensor<
  TData = Awaited<ReturnType<typeof integrationHttpGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetSensor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationHttpGetSensor<
  TData = Awaited<ReturnType<typeof integrationHttpGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationHttpGetSensor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationHttpGetSensorQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationHttpUpdateSensor = (id: string, httpSensorRequest: HttpSensorRequest) => {
  return customInstance<HttpUpdateSensorResponse>({
    url: `/api/integrations/http/sensors/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: httpSensorRequest,
  });
};

export const getIntegrationHttpUpdateSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationHttpUpdateSensor>>,
    TError,
    { id: string; data: HttpSensorRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationHttpUpdateSensor>>,
  TError,
  { id: string; data: HttpSensorRequest },
  TContext
> => {
  const mutationKey = ['integrationHttpUpdateSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationHttpUpdateSensor>>,
    { id: string; data: HttpSensorRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationHttpUpdateSensor(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationHttpUpdateSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationHttpUpdateSensor>>
>;
export type IntegrationHttpUpdateSensorMutationBody = HttpSensorRequest;
export type IntegrationHttpUpdateSensorMutationError = ErrorsAPIError;

export const useIntegrationHttpUpdateSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationHttpUpdateSensor>>,
      TError,
      { id: string; data: HttpSensorRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationHttpUpdateSensor>>,
  TError,
  { id: string; data: HttpSensorRequest },
  TContext
> => {
  const mutationOptions = getIntegrationHttpUpdateSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationHttpPreviewResponse = (
  httpPreviewResponseRequest: HttpPreviewResponseRequest,
  signal?: AbortSignal
) => {
  return customInstance<HttpPreviewResponseBody>({
    url: `/api/integrations/http/sensors/preview-response`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: httpPreviewResponseRequest,
    signal,
  });
};

export const getIntegrationHttpPreviewResponseMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationHttpPreviewResponse>>,
    TError,
    { data: HttpPreviewResponseRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationHttpPreviewResponse>>,
  TError,
  { data: HttpPreviewResponseRequest },
  TContext
> => {
  const mutationKey = ['integrationHttpPreviewResponse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationHttpPreviewResponse>>,
    { data: HttpPreviewResponseRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationHttpPreviewResponse(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationHttpPreviewResponseMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationHttpPreviewResponse>>
>;
export type IntegrationHttpPreviewResponseMutationBody = HttpPreviewResponseRequest;
export type IntegrationHttpPreviewResponseMutationError = ErrorsAPIError;

export const useIntegrationHttpPreviewResponse = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationHttpPreviewResponse>>,
      TError,
      { data: HttpPreviewResponseRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationHttpPreviewResponse>>,
  TError,
  { data: HttpPreviewResponseRequest },
  TContext
> => {
  const mutationOptions = getIntegrationHttpPreviewResponseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraGetAllHubs = (signal?: AbortSignal) => {
  return customInstance<DirigeraGetAllHubsResponse>({
    url: `/api/integrations/ikea-dirigera/hubs`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationDirigeraGetAllHubsQueryKey = () => {
  return [`/api/integrations/ikea-dirigera/hubs`] as const;
};

export const getIntegrationDirigeraGetAllHubsQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationDirigeraGetAllHubsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>> = ({
    signal,
  }) => integrationDirigeraGetAllHubs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationDirigeraGetAllHubsQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>
>;
export type IntegrationDirigeraGetAllHubsQueryError = ErrorsAPIError;

export function useIntegrationDirigeraGetAllHubs<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetAllHubs<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetAllHubs<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationDirigeraGetAllHubs<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetAllHubs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationDirigeraGetAllHubsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationDirigeraCreateHub = (
  dirigeraCreateHubRequest: DirigeraCreateHubRequest,
  signal?: AbortSignal
) => {
  return customInstance<DirigeraCreateHubResponse>({
    url: `/api/integrations/ikea-dirigera/hubs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dirigeraCreateHubRequest,
    signal,
  });
};

export const getIntegrationDirigeraCreateHubMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraCreateHub>>,
    TError,
    { data: DirigeraCreateHubRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraCreateHub>>,
  TError,
  { data: DirigeraCreateHubRequest },
  TContext
> => {
  const mutationKey = ['integrationDirigeraCreateHub'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraCreateHub>>,
    { data: DirigeraCreateHubRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationDirigeraCreateHub(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraCreateHubMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraCreateHub>>
>;
export type IntegrationDirigeraCreateHubMutationBody = DirigeraCreateHubRequest;
export type IntegrationDirigeraCreateHubMutationError = ErrorsAPIError;

export const useIntegrationDirigeraCreateHub = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraCreateHub>>,
      TError,
      { data: DirigeraCreateHubRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraCreateHub>>,
  TError,
  { data: DirigeraCreateHubRequest },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraCreateHubMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraDeleteHub = (id: string) => {
  return customInstance<void>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}`,
    method: 'DELETE',
  });
};

export const getIntegrationDirigeraDeleteHubMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraDeleteHub>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraDeleteHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationDirigeraDeleteHub'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraDeleteHub>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationDirigeraDeleteHub(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraDeleteHubMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraDeleteHub>>
>;

export type IntegrationDirigeraDeleteHubMutationError = ErrorsAPIError;

export const useIntegrationDirigeraDeleteHub = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraDeleteHub>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraDeleteHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraDeleteHubMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraGetHub = (id: string, signal?: AbortSignal) => {
  return customInstance<DirigeraGetHubResponse>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationDirigeraGetHubQueryKey = (id?: string) => {
  return [`/api/integrations/ikea-dirigera/hubs/${id}`] as const;
};

export const getIntegrationDirigeraGetHubQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetHub>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationDirigeraGetHubQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationDirigeraGetHub>>> = ({
    signal,
  }) => integrationDirigeraGetHub(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationDirigeraGetHubQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraGetHub>>
>;
export type IntegrationDirigeraGetHubQueryError = ErrorsAPIError;

export function useIntegrationDirigeraGetHub<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetHub>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetHub>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetHub<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetHub>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetHub>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetHub<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetHub>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationDirigeraGetHub<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetHub>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetHub>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationDirigeraGetHubQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationDirigeraUpdateHub = (
  id: string,
  dirigeraUpdateHubRequest: DirigeraUpdateHubRequest
) => {
  return customInstance<DirigeraUpdateHubResponse>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: dirigeraUpdateHubRequest,
  });
};

export const getIntegrationDirigeraUpdateHubMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraUpdateHub>>,
    TError,
    { id: string; data: DirigeraUpdateHubRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraUpdateHub>>,
  TError,
  { id: string; data: DirigeraUpdateHubRequest },
  TContext
> => {
  const mutationKey = ['integrationDirigeraUpdateHub'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraUpdateHub>>,
    { id: string; data: DirigeraUpdateHubRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationDirigeraUpdateHub(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraUpdateHubMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraUpdateHub>>
>;
export type IntegrationDirigeraUpdateHubMutationBody = DirigeraUpdateHubRequest;
export type IntegrationDirigeraUpdateHubMutationError = ErrorsAPIError;

export const useIntegrationDirigeraUpdateHub = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraUpdateHub>>,
      TError,
      { id: string; data: DirigeraUpdateHubRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraUpdateHub>>,
  TError,
  { id: string; data: DirigeraUpdateHubRequest },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraUpdateHubMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraAuthenticateHub = (id: string, signal?: AbortSignal) => {
  return customInstance<DirigeraAuthenticateHubResponse>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}/authenticate`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationDirigeraAuthenticateHubMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraAuthenticateHub>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraAuthenticateHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationDirigeraAuthenticateHub'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraAuthenticateHub>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationDirigeraAuthenticateHub(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraAuthenticateHubMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraAuthenticateHub>>
>;

export type IntegrationDirigeraAuthenticateHubMutationError = ErrorsAPIError;

export const useIntegrationDirigeraAuthenticateHub = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraAuthenticateHub>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraAuthenticateHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraAuthenticateHubMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraDiscoverHub = (id: string, signal?: AbortSignal) => {
  return customInstance<DirigeraDiscoveryResponse>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}/discover`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationDirigeraDiscoverHubMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraDiscoverHub>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraDiscoverHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationDirigeraDiscoverHub'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraDiscoverHub>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationDirigeraDiscoverHub(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraDiscoverHubMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraDiscoverHub>>
>;

export type IntegrationDirigeraDiscoverHubMutationError = ErrorsAPIError;

export const useIntegrationDirigeraDiscoverHub = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraDiscoverHub>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraDiscoverHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraDiscoverHubMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraGetDiscovery = (id: string, signal?: AbortSignal) => {
  return customInstance<DirigeraDiscoveryResponse>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}/discovery`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationDirigeraGetDiscoveryQueryKey = (id?: string) => {
  return [`/api/integrations/ikea-dirigera/hubs/${id}/discovery`] as const;
};

export const getIntegrationDirigeraGetDiscoveryQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationDirigeraGetDiscoveryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>> = ({
    signal,
  }) => integrationDirigeraGetDiscovery(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationDirigeraGetDiscoveryQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>
>;
export type IntegrationDirigeraGetDiscoveryQueryError = ErrorsAPIError;

export function useIntegrationDirigeraGetDiscovery<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetDiscovery<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetDiscovery<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationDirigeraGetDiscovery<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationDirigeraGetDiscovery>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationDirigeraGetDiscoveryQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationDirigeraPauseHub = (id: string, signal?: AbortSignal) => {
  return customInstance<DirigeraPauseHubResponse>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationDirigeraPauseHubMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraPauseHub>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraPauseHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationDirigeraPauseHub'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraPauseHub>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationDirigeraPauseHub(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraPauseHubMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraPauseHub>>
>;

export type IntegrationDirigeraPauseHubMutationError = ErrorsAPIError;

export const useIntegrationDirigeraPauseHub = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraPauseHub>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraPauseHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraPauseHubMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraResumeHub = (id: string, signal?: AbortSignal) => {
  return customInstance<DirigeraResumeHubResponse>({
    url: `/api/integrations/ikea-dirigera/hubs/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationDirigeraResumeHubMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraResumeHub>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraResumeHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationDirigeraResumeHub'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraResumeHub>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationDirigeraResumeHub(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraResumeHubMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraResumeHub>>
>;

export type IntegrationDirigeraResumeHubMutationError = ErrorsAPIError;

export const useIntegrationDirigeraResumeHub = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraResumeHub>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraResumeHub>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraResumeHubMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraGetAllSensorMappings = (
  params?: IntegrationDirigeraGetAllSensorMappingsParams,
  signal?: AbortSignal
) => {
  return customInstance<DirigeraGetAllSensorMappingsResponse>({
    url: `/api/integrations/ikea-dirigera/sensors`,
    method: 'GET',
    params,
    signal,
  });
};

export const getIntegrationDirigeraGetAllSensorMappingsQueryKey = (
  params?: IntegrationDirigeraGetAllSensorMappingsParams
) => {
  return [`/api/integrations/ikea-dirigera/sensors`, ...(params ? [params] : [])] as const;
};

export const getIntegrationDirigeraGetAllSensorMappingsQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationDirigeraGetAllSensorMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getIntegrationDirigeraGetAllSensorMappingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>
  > = ({ signal }) => integrationDirigeraGetAllSensorMappings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationDirigeraGetAllSensorMappingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>
>;
export type IntegrationDirigeraGetAllSensorMappingsQueryError = ErrorsAPIError;

export function useIntegrationDirigeraGetAllSensorMappings<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
  TError = ErrorsAPIError,
>(
  params: undefined | IntegrationDirigeraGetAllSensorMappingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetAllSensorMappings<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationDirigeraGetAllSensorMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetAllSensorMappings<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationDirigeraGetAllSensorMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationDirigeraGetAllSensorMappings<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationDirigeraGetAllSensorMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetAllSensorMappings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationDirigeraGetAllSensorMappingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationDirigeraCreateSensorMapping = (
  dirigeraCreateSensorMappingRequest: DirigeraCreateSensorMappingRequest,
  signal?: AbortSignal
) => {
  return customInstance<DirigeraCreateSensorMappingResponse>({
    url: `/api/integrations/ikea-dirigera/sensors`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dirigeraCreateSensorMappingRequest,
    signal,
  });
};

export const getIntegrationDirigeraCreateSensorMappingMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraCreateSensorMapping>>,
    TError,
    { data: DirigeraCreateSensorMappingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraCreateSensorMapping>>,
  TError,
  { data: DirigeraCreateSensorMappingRequest },
  TContext
> => {
  const mutationKey = ['integrationDirigeraCreateSensorMapping'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraCreateSensorMapping>>,
    { data: DirigeraCreateSensorMappingRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationDirigeraCreateSensorMapping(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraCreateSensorMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraCreateSensorMapping>>
>;
export type IntegrationDirigeraCreateSensorMappingMutationBody = DirigeraCreateSensorMappingRequest;
export type IntegrationDirigeraCreateSensorMappingMutationError = ErrorsAPIError;

export const useIntegrationDirigeraCreateSensorMapping = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraCreateSensorMapping>>,
      TError,
      { data: DirigeraCreateSensorMappingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraCreateSensorMapping>>,
  TError,
  { data: DirigeraCreateSensorMappingRequest },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraCreateSensorMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraDeleteSensorMapping = (id: string) => {
  return customInstance<void>({
    url: `/api/integrations/ikea-dirigera/sensors/${id}`,
    method: 'DELETE',
  });
};

export const getIntegrationDirigeraDeleteSensorMappingMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraDeleteSensorMapping>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraDeleteSensorMapping>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationDirigeraDeleteSensorMapping'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraDeleteSensorMapping>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationDirigeraDeleteSensorMapping(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraDeleteSensorMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraDeleteSensorMapping>>
>;

export type IntegrationDirigeraDeleteSensorMappingMutationError = ErrorsAPIError;

export const useIntegrationDirigeraDeleteSensorMapping = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraDeleteSensorMapping>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraDeleteSensorMapping>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraDeleteSensorMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationDirigeraGetSensorMapping = (id: string, signal?: AbortSignal) => {
  return customInstance<DirigeraGetSensorMappingResponse>({
    url: `/api/integrations/ikea-dirigera/sensors/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationDirigeraGetSensorMappingQueryKey = (id?: string) => {
  return [`/api/integrations/ikea-dirigera/sensors/${id}`] as const;
};

export const getIntegrationDirigeraGetSensorMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationDirigeraGetSensorMappingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>> = ({
    signal,
  }) => integrationDirigeraGetSensorMapping(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationDirigeraGetSensorMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>
>;
export type IntegrationDirigeraGetSensorMappingQueryError = ErrorsAPIError;

export function useIntegrationDirigeraGetSensorMapping<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetSensorMapping<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
          TError,
          Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationDirigeraGetSensorMapping<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationDirigeraGetSensorMapping<
  TData = Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationDirigeraGetSensorMapping>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationDirigeraGetSensorMappingQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationDirigeraUpdateSensorMapping = (
  id: string,
  dirigeraUpdateSensorMappingRequest: DirigeraUpdateSensorMappingRequest
) => {
  return customInstance<DirigeraUpdateSensorMappingResponse>({
    url: `/api/integrations/ikea-dirigera/sensors/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dirigeraUpdateSensorMappingRequest,
  });
};

export const getIntegrationDirigeraUpdateSensorMappingMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationDirigeraUpdateSensorMapping>>,
    TError,
    { id: string; data: DirigeraUpdateSensorMappingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationDirigeraUpdateSensorMapping>>,
  TError,
  { id: string; data: DirigeraUpdateSensorMappingRequest },
  TContext
> => {
  const mutationKey = ['integrationDirigeraUpdateSensorMapping'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationDirigeraUpdateSensorMapping>>,
    { id: string; data: DirigeraUpdateSensorMappingRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationDirigeraUpdateSensorMapping(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationDirigeraUpdateSensorMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationDirigeraUpdateSensorMapping>>
>;
export type IntegrationDirigeraUpdateSensorMappingMutationBody = DirigeraUpdateSensorMappingRequest;
export type IntegrationDirigeraUpdateSensorMappingMutationError = ErrorsAPIError;

export const useIntegrationDirigeraUpdateSensorMapping = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationDirigeraUpdateSensorMapping>>,
      TError,
      { id: string; data: DirigeraUpdateSensorMappingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationDirigeraUpdateSensorMapping>>,
  TError,
  { id: string; data: DirigeraUpdateSensorMappingRequest },
  TContext
> => {
  const mutationOptions = getIntegrationDirigeraUpdateSensorMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterGetHardware = (signal?: AbortSignal) => {
  return customInstance<MatterGetHardwareResponse>({
    url: `/api/integrations/matter/hardware`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMatterGetHardwareQueryKey = () => {
  return [`/api/integrations/matter/hardware`] as const;
};

export const getIntegrationMatterGetHardwareQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMatterGetHardware>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetHardware>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMatterGetHardwareQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMatterGetHardware>>> = ({
    signal,
  }) => integrationMatterGetHardware(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMatterGetHardware>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMatterGetHardwareQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterGetHardware>>
>;
export type IntegrationMatterGetHardwareQueryError = unknown;

export function useIntegrationMatterGetHardware<
  TData = Awaited<ReturnType<typeof integrationMatterGetHardware>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetHardware>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetHardware>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetHardware>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetHardware<
  TData = Awaited<ReturnType<typeof integrationMatterGetHardware>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetHardware>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetHardware>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetHardware>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetHardware<
  TData = Awaited<ReturnType<typeof integrationMatterGetHardware>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetHardware>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMatterGetHardware<
  TData = Awaited<ReturnType<typeof integrationMatterGetHardware>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetHardware>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMatterGetHardwareQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMatterGetAllSensors = (
  params?: IntegrationMatterGetAllSensorsParams,
  signal?: AbortSignal
) => {
  return customInstance<MatterGetAllSensorsResponse>({
    url: `/api/integrations/matter/sensors`,
    method: 'GET',
    params,
    signal,
  });
};

export const getIntegrationMatterGetAllSensorsQueryKey = (
  params?: IntegrationMatterGetAllSensorsParams
) => {
  return [`/api/integrations/matter/sensors`, ...(params ? [params] : [])] as const;
};

export const getIntegrationMatterGetAllSensorsQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMatterGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllSensors>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMatterGetAllSensorsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMatterGetAllSensors>>> = ({
    signal,
  }) => integrationMatterGetAllSensors(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMatterGetAllSensorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterGetAllSensors>>
>;
export type IntegrationMatterGetAllSensorsQueryError = ErrorsAPIError;

export function useIntegrationMatterGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params: undefined | IntegrationMatterGetAllSensorsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllSensors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetAllSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMatterGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllSensors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetAllSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMatterGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllSensors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMatterGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMatterGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllSensors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMatterGetAllSensorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMatterCreateSensor = (
  matterCreateSensorRequest: MatterCreateSensorRequest,
  signal?: AbortSignal
) => {
  return customInstance<MatterCreateSensorResponse>({
    url: `/api/integrations/matter/sensors`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: matterCreateSensorRequest,
    signal,
  });
};

export const getIntegrationMatterCreateSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterCreateSensor>>,
    TError,
    { data: MatterCreateSensorRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterCreateSensor>>,
  TError,
  { data: MatterCreateSensorRequest },
  TContext
> => {
  const mutationKey = ['integrationMatterCreateSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterCreateSensor>>,
    { data: MatterCreateSensorRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationMatterCreateSensor(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterCreateSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterCreateSensor>>
>;
export type IntegrationMatterCreateSensorMutationBody = MatterCreateSensorRequest;
export type IntegrationMatterCreateSensorMutationError = ErrorsAPIError;

export const useIntegrationMatterCreateSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterCreateSensor>>,
      TError,
      { data: MatterCreateSensorRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterCreateSensor>>,
  TError,
  { data: MatterCreateSensorRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMatterCreateSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterDeleteSensor = (id: string) => {
  return customInstance<void>({ url: `/api/integrations/matter/sensors/${id}`, method: 'DELETE' });
};

export const getIntegrationMatterDeleteSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterDeleteSensor>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterDeleteSensor>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMatterDeleteSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterDeleteSensor>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMatterDeleteSensor(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterDeleteSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterDeleteSensor>>
>;

export type IntegrationMatterDeleteSensorMutationError = ErrorsAPIError;

export const useIntegrationMatterDeleteSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterDeleteSensor>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterDeleteSensor>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMatterDeleteSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterGetSensor = (id: string, signal?: AbortSignal) => {
  return customInstance<MatterGetSensorResponse>({
    url: `/api/integrations/matter/sensors/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMatterGetSensorQueryKey = (id?: string) => {
  return [`/api/integrations/matter/sensors/${id}`] as const;
};

export const getIntegrationMatterGetSensorQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMatterGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetSensor>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMatterGetSensorQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMatterGetSensor>>> = ({
    signal,
  }) => integrationMatterGetSensor(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMatterGetSensor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMatterGetSensorQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterGetSensor>>
>;
export type IntegrationMatterGetSensorQueryError = ErrorsAPIError;

export function useIntegrationMatterGetSensor<
  TData = Awaited<ReturnType<typeof integrationMatterGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetSensor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetSensor>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetSensor<
  TData = Awaited<ReturnType<typeof integrationMatterGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetSensor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetSensor>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetSensor<
  TData = Awaited<ReturnType<typeof integrationMatterGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetSensor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMatterGetSensor<
  TData = Awaited<ReturnType<typeof integrationMatterGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetSensor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMatterGetSensorQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMatterUpdateSensor = (
  id: string,
  matterUpdateSensorRequest: MatterUpdateSensorRequest
) => {
  return customInstance<MatterUpdateSensorResponse>({
    url: `/api/integrations/matter/sensors/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: matterUpdateSensorRequest,
  });
};

export const getIntegrationMatterUpdateSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterUpdateSensor>>,
    TError,
    { id: string; data: MatterUpdateSensorRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterUpdateSensor>>,
  TError,
  { id: string; data: MatterUpdateSensorRequest },
  TContext
> => {
  const mutationKey = ['integrationMatterUpdateSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterUpdateSensor>>,
    { id: string; data: MatterUpdateSensorRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationMatterUpdateSensor(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterUpdateSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterUpdateSensor>>
>;
export type IntegrationMatterUpdateSensorMutationBody = MatterUpdateSensorRequest;
export type IntegrationMatterUpdateSensorMutationError = ErrorsAPIError;

export const useIntegrationMatterUpdateSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterUpdateSensor>>,
      TError,
      { id: string; data: MatterUpdateSensorRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterUpdateSensor>>,
  TError,
  { id: string; data: MatterUpdateSensorRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMatterUpdateSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterGetAllServers = (signal?: AbortSignal) => {
  return customInstance<MatterGetAllServersResponse>({
    url: `/api/integrations/matter/servers`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMatterGetAllServersQueryKey = () => {
  return [`/api/integrations/matter/servers`] as const;
};

export const getIntegrationMatterGetAllServersQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllServers>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMatterGetAllServersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMatterGetAllServers>>> = ({
    signal,
  }) => integrationMatterGetAllServers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMatterGetAllServersQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterGetAllServers>>
>;
export type IntegrationMatterGetAllServersQueryError = ErrorsAPIError;

export function useIntegrationMatterGetAllServers<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllServers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetAllServers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetAllServers<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllServers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetAllServers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetAllServers<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllServers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMatterGetAllServers<
  TData = Awaited<ReturnType<typeof integrationMatterGetAllServers>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetAllServers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMatterGetAllServersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMatterCreateServer = (
  matterCreateServerRequest: MatterCreateServerRequest,
  signal?: AbortSignal
) => {
  return customInstance<MatterCreateServerResponse>({
    url: `/api/integrations/matter/servers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: matterCreateServerRequest,
    signal,
  });
};

export const getIntegrationMatterCreateServerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterCreateServer>>,
    TError,
    { data: MatterCreateServerRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterCreateServer>>,
  TError,
  { data: MatterCreateServerRequest },
  TContext
> => {
  const mutationKey = ['integrationMatterCreateServer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterCreateServer>>,
    { data: MatterCreateServerRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationMatterCreateServer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterCreateServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterCreateServer>>
>;
export type IntegrationMatterCreateServerMutationBody = MatterCreateServerRequest;
export type IntegrationMatterCreateServerMutationError = ErrorsAPIError;

export const useIntegrationMatterCreateServer = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterCreateServer>>,
      TError,
      { data: MatterCreateServerRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterCreateServer>>,
  TError,
  { data: MatterCreateServerRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMatterCreateServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterDeleteServer = (id: string) => {
  return customInstance<void>({ url: `/api/integrations/matter/servers/${id}`, method: 'DELETE' });
};

export const getIntegrationMatterDeleteServerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterDeleteServer>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterDeleteServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMatterDeleteServer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterDeleteServer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMatterDeleteServer(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterDeleteServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterDeleteServer>>
>;

export type IntegrationMatterDeleteServerMutationError = ErrorsAPIError;

export const useIntegrationMatterDeleteServer = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterDeleteServer>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterDeleteServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMatterDeleteServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterGetServer = (id: string, signal?: AbortSignal) => {
  return customInstance<MatterGetServerResponse>({
    url: `/api/integrations/matter/servers/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMatterGetServerQueryKey = (id?: string) => {
  return [`/api/integrations/matter/servers/${id}`] as const;
};

export const getIntegrationMatterGetServerQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMatterGetServer>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetServer>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMatterGetServerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMatterGetServer>>> = ({
    signal,
  }) => integrationMatterGetServer(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMatterGetServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMatterGetServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterGetServer>>
>;
export type IntegrationMatterGetServerQueryError = ErrorsAPIError;

export function useIntegrationMatterGetServer<
  TData = Awaited<ReturnType<typeof integrationMatterGetServer>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetServer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetServer>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetServer>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetServer<
  TData = Awaited<ReturnType<typeof integrationMatterGetServer>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetServer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetServer>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetServer>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetServer<
  TData = Awaited<ReturnType<typeof integrationMatterGetServer>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetServer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMatterGetServer<
  TData = Awaited<ReturnType<typeof integrationMatterGetServer>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMatterGetServer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMatterGetServerQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMatterUpdateServer = (
  id: string,
  matterUpdateServerRequest: MatterUpdateServerRequest
) => {
  return customInstance<MatterUpdateServerResponse>({
    url: `/api/integrations/matter/servers/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: matterUpdateServerRequest,
  });
};

export const getIntegrationMatterUpdateServerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterUpdateServer>>,
    TError,
    { id: string; data: MatterUpdateServerRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterUpdateServer>>,
  TError,
  { id: string; data: MatterUpdateServerRequest },
  TContext
> => {
  const mutationKey = ['integrationMatterUpdateServer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterUpdateServer>>,
    { id: string; data: MatterUpdateServerRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationMatterUpdateServer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterUpdateServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterUpdateServer>>
>;
export type IntegrationMatterUpdateServerMutationBody = MatterUpdateServerRequest;
export type IntegrationMatterUpdateServerMutationError = ErrorsAPIError;

export const useIntegrationMatterUpdateServer = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterUpdateServer>>,
      TError,
      { id: string; data: MatterUpdateServerRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterUpdateServer>>,
  TError,
  { id: string; data: MatterUpdateServerRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMatterUpdateServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterPauseServer = (id: string, signal?: AbortSignal) => {
  return customInstance<MatterPauseServerResponse>({
    url: `/api/integrations/matter/servers/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationMatterPauseServerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterPauseServer>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterPauseServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMatterPauseServer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterPauseServer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMatterPauseServer(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterPauseServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterPauseServer>>
>;

export type IntegrationMatterPauseServerMutationError = ErrorsAPIError;

export const useIntegrationMatterPauseServer = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterPauseServer>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterPauseServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMatterPauseServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterResumeServer = (id: string, signal?: AbortSignal) => {
  return customInstance<MatterResumeServerResponse>({
    url: `/api/integrations/matter/servers/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationMatterResumeServerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMatterResumeServer>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMatterResumeServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMatterResumeServer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMatterResumeServer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMatterResumeServer(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMatterResumeServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterResumeServer>>
>;

export type IntegrationMatterResumeServerMutationError = ErrorsAPIError;

export const useIntegrationMatterResumeServer = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMatterResumeServer>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMatterResumeServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMatterResumeServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMatterGetConnectionState = (id: string, signal?: AbortSignal) => {
  return customInstance<MatterGetConnectionStateResponse>({
    url: `/api/integrations/matter/servers/${id}/state`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMatterGetConnectionStateQueryKey = (id?: string) => {
  return [`/api/integrations/matter/servers/${id}/state`] as const;
};

export const getIntegrationMatterGetConnectionStateQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMatterGetConnectionStateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMatterGetConnectionState>>> = ({
    signal,
  }) => integrationMatterGetConnectionState(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMatterGetConnectionStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMatterGetConnectionState>>
>;
export type IntegrationMatterGetConnectionStateQueryError = ErrorsAPIError;

export function useIntegrationMatterGetConnectionState<
  TData = Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetConnectionState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetConnectionState<
  TData = Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
          TError,
          Awaited<ReturnType<typeof integrationMatterGetConnectionState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMatterGetConnectionState<
  TData = Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMatterGetConnectionState<
  TData = Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof integrationMatterGetConnectionState>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMatterGetConnectionStateQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttGetAllBrokers = (signal?: AbortSignal) => {
  return customInstance<MqttGetAllBrokersResponse>({
    url: `/api/integrations/mqtt/brokers`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMqttGetAllBrokersQueryKey = () => {
  return [`/api/integrations/mqtt/brokers`] as const;
};

export const getIntegrationMqttGetAllBrokersQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttGetAllBrokersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>> = ({
    signal,
  }) => integrationMqttGetAllBrokers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetAllBrokersQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>
>;
export type IntegrationMqttGetAllBrokersQueryError = ErrorsAPIError;

export function useIntegrationMqttGetAllBrokers<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetAllBrokers<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetAllBrokers<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetAllBrokers<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllBrokers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetAllBrokersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttCreateBroker = (
  mqttCreateBrokerRequest: MqttCreateBrokerRequest,
  signal?: AbortSignal
) => {
  return customInstance<MqttCreateBrokerResponse>({
    url: `/api/integrations/mqtt/brokers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mqttCreateBrokerRequest,
    signal,
  });
};

export const getIntegrationMqttCreateBrokerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttCreateBroker>>,
    TError,
    { data: MqttCreateBrokerRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttCreateBroker>>,
  TError,
  { data: MqttCreateBrokerRequest },
  TContext
> => {
  const mutationKey = ['integrationMqttCreateBroker'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttCreateBroker>>,
    { data: MqttCreateBrokerRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationMqttCreateBroker(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttCreateBrokerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttCreateBroker>>
>;
export type IntegrationMqttCreateBrokerMutationBody = MqttCreateBrokerRequest;
export type IntegrationMqttCreateBrokerMutationError = ErrorsAPIError;

export const useIntegrationMqttCreateBroker = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttCreateBroker>>,
      TError,
      { data: MqttCreateBrokerRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttCreateBroker>>,
  TError,
  { data: MqttCreateBrokerRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMqttCreateBrokerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttDeleteBroker = (id: string) => {
  return customInstance<void>({ url: `/api/integrations/mqtt/brokers/${id}`, method: 'DELETE' });
};

export const getIntegrationMqttDeleteBrokerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttDeleteBroker>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttDeleteBroker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMqttDeleteBroker'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttDeleteBroker>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMqttDeleteBroker(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttDeleteBrokerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttDeleteBroker>>
>;

export type IntegrationMqttDeleteBrokerMutationError = ErrorsAPIError;

export const useIntegrationMqttDeleteBroker = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttDeleteBroker>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttDeleteBroker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMqttDeleteBrokerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttGetBroker = (id: string, signal?: AbortSignal) => {
  return customInstance<MqttGetBrokerResponse>({
    url: `/api/integrations/mqtt/brokers/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMqttGetBrokerQueryKey = (id?: string) => {
  return [`/api/integrations/mqtt/brokers/${id}`] as const;
};

export const getIntegrationMqttGetBrokerQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetBroker>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetBroker>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttGetBrokerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetBroker>>> = ({
    signal,
  }) => integrationMqttGetBroker(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetBroker>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetBrokerQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetBroker>>
>;
export type IntegrationMqttGetBrokerQueryError = ErrorsAPIError;

export function useIntegrationMqttGetBroker<
  TData = Awaited<ReturnType<typeof integrationMqttGetBroker>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetBroker>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetBroker>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetBroker>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetBroker<
  TData = Awaited<ReturnType<typeof integrationMqttGetBroker>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetBroker>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetBroker>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetBroker>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetBroker<
  TData = Awaited<ReturnType<typeof integrationMqttGetBroker>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetBroker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetBroker<
  TData = Awaited<ReturnType<typeof integrationMqttGetBroker>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetBroker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetBrokerQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttUpdateBroker = (
  id: string,
  mqttUpdateBrokerRequest: MqttUpdateBrokerRequest
) => {
  return customInstance<MqttUpdateBrokerResponse>({
    url: `/api/integrations/mqtt/brokers/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: mqttUpdateBrokerRequest,
  });
};

export const getIntegrationMqttUpdateBrokerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttUpdateBroker>>,
    TError,
    { id: string; data: MqttUpdateBrokerRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttUpdateBroker>>,
  TError,
  { id: string; data: MqttUpdateBrokerRequest },
  TContext
> => {
  const mutationKey = ['integrationMqttUpdateBroker'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttUpdateBroker>>,
    { id: string; data: MqttUpdateBrokerRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationMqttUpdateBroker(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttUpdateBrokerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttUpdateBroker>>
>;
export type IntegrationMqttUpdateBrokerMutationBody = MqttUpdateBrokerRequest;
export type IntegrationMqttUpdateBrokerMutationError = ErrorsAPIError;

export const useIntegrationMqttUpdateBroker = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttUpdateBroker>>,
      TError,
      { id: string; data: MqttUpdateBrokerRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttUpdateBroker>>,
  TError,
  { id: string; data: MqttUpdateBrokerRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMqttUpdateBrokerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttGetMessageHistory = (
  id: string,
  params?: IntegrationMqttGetMessageHistoryParams,
  signal?: AbortSignal
) => {
  return customInstance<MqttGetMessageHistoryResponse>({
    url: `/api/integrations/mqtt/brokers/${id}/messages`,
    method: 'GET',
    params,
    signal,
  });
};

export const getIntegrationMqttGetMessageHistoryQueryKey = (
  id?: string,
  params?: IntegrationMqttGetMessageHistoryParams
) => {
  return [`/api/integrations/mqtt/brokers/${id}/messages`, ...(params ? [params] : [])] as const;
};

export const getIntegrationMqttGetMessageHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: IntegrationMqttGetMessageHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getIntegrationMqttGetMessageHistoryQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>> = ({
    signal,
  }) => integrationMqttGetMessageHistory(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetMessageHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>
>;
export type IntegrationMqttGetMessageHistoryQueryError = ErrorsAPIError;

export function useIntegrationMqttGetMessageHistory<
  TData = Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: undefined | IntegrationMqttGetMessageHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetMessageHistory<
  TData = Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: IntegrationMqttGetMessageHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetMessageHistory<
  TData = Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: IntegrationMqttGetMessageHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetMessageHistory<
  TData = Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: IntegrationMqttGetMessageHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetMessageHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetMessageHistoryQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttGetLatestMessages = (id: string, signal?: AbortSignal) => {
  return customInstance<MqttGetLatestMessagesResponse>({
    url: `/api/integrations/mqtt/brokers/${id}/messages/latest`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMqttGetLatestMessagesQueryKey = (id?: string) => {
  return [`/api/integrations/mqtt/brokers/${id}/messages/latest`] as const;
};

export const getIntegrationMqttGetLatestMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttGetLatestMessagesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>> = ({
    signal,
  }) => integrationMqttGetLatestMessages(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetLatestMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>
>;
export type IntegrationMqttGetLatestMessagesQueryError = ErrorsAPIError;

export function useIntegrationMqttGetLatestMessages<
  TData = Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetLatestMessages<
  TData = Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetLatestMessages<
  TData = Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetLatestMessages<
  TData = Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetLatestMessages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetLatestMessagesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttStreamMessages = (id: string, signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/integrations/mqtt/brokers/${id}/messages/stream`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMqttStreamMessagesQueryKey = (id?: string) => {
  return [`/api/integrations/mqtt/brokers/${id}/messages/stream`] as const;
};

export const getIntegrationMqttStreamMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
  TError = void | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttStreamMessages>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttStreamMessagesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttStreamMessages>>> = ({
    signal,
  }) => integrationMqttStreamMessages(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttStreamMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttStreamMessages>>
>;
export type IntegrationMqttStreamMessagesQueryError = void | ErrorsAPIError;

export function useIntegrationMqttStreamMessages<
  TData = Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
  TError = void | ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttStreamMessages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttStreamMessages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttStreamMessages<
  TData = Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
  TError = void | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttStreamMessages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttStreamMessages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttStreamMessages<
  TData = Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
  TError = void | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttStreamMessages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttStreamMessages<
  TData = Awaited<ReturnType<typeof integrationMqttStreamMessages>>,
  TError = void | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttStreamMessages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttStreamMessagesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttPauseBroker = (id: string, signal?: AbortSignal) => {
  return customInstance<MqttPauseBrokerResponse>({
    url: `/api/integrations/mqtt/brokers/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationMqttPauseBrokerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttPauseBroker>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttPauseBroker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMqttPauseBroker'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttPauseBroker>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMqttPauseBroker(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttPauseBrokerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttPauseBroker>>
>;

export type IntegrationMqttPauseBrokerMutationError = ErrorsAPIError;

export const useIntegrationMqttPauseBroker = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttPauseBroker>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttPauseBroker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMqttPauseBrokerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttResumeBroker = (id: string, signal?: AbortSignal) => {
  return customInstance<MqttResumeBrokerResponse>({
    url: `/api/integrations/mqtt/brokers/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getIntegrationMqttResumeBrokerMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttResumeBroker>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttResumeBroker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMqttResumeBroker'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttResumeBroker>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMqttResumeBroker(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttResumeBrokerMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttResumeBroker>>
>;

export type IntegrationMqttResumeBrokerMutationError = ErrorsAPIError;

export const useIntegrationMqttResumeBroker = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttResumeBroker>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttResumeBroker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMqttResumeBrokerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getAllMqttDevices = (signal?: AbortSignal) => {
  return customInstance<MqttGetAllDevicesResponse>({
    url: `/api/integrations/mqtt/devices`,
    method: 'GET',
    signal,
  });
};

export const getGetAllMqttDevicesQueryKey = () => {
  return [`/api/integrations/mqtt/devices`] as const;
};

export const getGetAllMqttDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllMqttDevices>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllMqttDevices>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllMqttDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllMqttDevices>>> = ({ signal }) =>
    getAllMqttDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllMqttDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllMqttDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllMqttDevices>>
>;
export type GetAllMqttDevicesQueryError = ErrorsAPIError;

export function useGetAllMqttDevices<
  TData = Awaited<ReturnType<typeof getAllMqttDevices>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllMqttDevices>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllMqttDevices>>,
          TError,
          Awaited<ReturnType<typeof getAllMqttDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllMqttDevices<
  TData = Awaited<ReturnType<typeof getAllMqttDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllMqttDevices>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllMqttDevices>>,
          TError,
          Awaited<ReturnType<typeof getAllMqttDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllMqttDevices<
  TData = Awaited<ReturnType<typeof getAllMqttDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllMqttDevices>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAllMqttDevices<
  TData = Awaited<ReturnType<typeof getAllMqttDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllMqttDevices>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllMqttDevicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createMqttDevice = (
  mqttCreateDeviceRequest: MqttCreateDeviceRequest,
  signal?: AbortSignal
) => {
  return customInstance<MqttCreateDeviceResponse>({
    url: `/api/integrations/mqtt/devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mqttCreateDeviceRequest,
    signal,
  });
};

export const getCreateMqttDeviceMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMqttDevice>>,
    TError,
    { data: MqttCreateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMqttDevice>>,
  TError,
  { data: MqttCreateDeviceRequest },
  TContext
> => {
  const mutationKey = ['createMqttDevice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMqttDevice>>,
    { data: MqttCreateDeviceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createMqttDevice(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMqttDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMqttDevice>>
>;
export type CreateMqttDeviceMutationBody = MqttCreateDeviceRequest;
export type CreateMqttDeviceMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useCreateMqttDevice = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMqttDevice>>,
      TError,
      { data: MqttCreateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createMqttDevice>>,
  TError,
  { data: MqttCreateDeviceRequest },
  TContext
> => {
  const mutationOptions = getCreateMqttDeviceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteMqttDevice = (id: string) => {
  return customInstance<void>({ url: `/api/integrations/mqtt/devices/${id}`, method: 'DELETE' });
};

export const getDeleteMqttDeviceMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMqttDevice>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMqttDevice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMqttDevice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMqttDevice>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMqttDevice(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMqttDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMqttDevice>>
>;

export type DeleteMqttDeviceMutationError = ErrorsAPIError;

export const useDeleteMqttDevice = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMqttDevice>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMqttDevice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMqttDeviceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getMqttDevice = (id: string, signal?: AbortSignal) => {
  return customInstance<MqttGetDeviceResponse>({
    url: `/api/integrations/mqtt/devices/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetMqttDeviceQueryKey = (id?: string) => {
  return [`/api/integrations/mqtt/devices/${id}`] as const;
};

export const getGetMqttDeviceQueryOptions = <
  TData = Awaited<ReturnType<typeof getMqttDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMqttDevice>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMqttDeviceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMqttDevice>>> = ({ signal }) =>
    getMqttDevice(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMqttDevice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMqttDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getMqttDevice>>>;
export type GetMqttDeviceQueryError = ErrorsAPIError;

export function useGetMqttDevice<
  TData = Awaited<ReturnType<typeof getMqttDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMqttDevice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMqttDevice>>,
          TError,
          Awaited<ReturnType<typeof getMqttDevice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMqttDevice<
  TData = Awaited<ReturnType<typeof getMqttDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMqttDevice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMqttDevice>>,
          TError,
          Awaited<ReturnType<typeof getMqttDevice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMqttDevice<
  TData = Awaited<ReturnType<typeof getMqttDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMqttDevice>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMqttDevice<
  TData = Awaited<ReturnType<typeof getMqttDevice>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMqttDevice>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMqttDeviceQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateMqttDevice = (id: string, mqttUpdateDeviceRequest: MqttUpdateDeviceRequest) => {
  return customInstance<MqttUpdateDeviceResponse>({
    url: `/api/integrations/mqtt/devices/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: mqttUpdateDeviceRequest,
  });
};

export const getUpdateMqttDeviceMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMqttDevice>>,
    TError,
    { id: string; data: MqttUpdateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMqttDevice>>,
  TError,
  { id: string; data: MqttUpdateDeviceRequest },
  TContext
> => {
  const mutationKey = ['updateMqttDevice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMqttDevice>>,
    { id: string; data: MqttUpdateDeviceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMqttDevice(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMqttDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMqttDevice>>
>;
export type UpdateMqttDeviceMutationBody = MqttUpdateDeviceRequest;
export type UpdateMqttDeviceMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateMqttDevice = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMqttDevice>>,
      TError,
      { id: string; data: MqttUpdateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateMqttDevice>>,
  TError,
  { id: string; data: MqttUpdateDeviceRequest },
  TContext
> => {
  const mutationOptions = getUpdateMqttDeviceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getMqttDevicePropertyDefinitions = (
  params: GetMqttDevicePropertyDefinitionsParams,
  signal?: AbortSignal
) => {
  return customInstance<MqttGetPropertyDefinitionsResponse>({
    url: `/api/integrations/mqtt/devices/property-definitions`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMqttDevicePropertyDefinitionsQueryKey = (
  params?: GetMqttDevicePropertyDefinitionsParams
) => {
  return [
    `/api/integrations/mqtt/devices/property-definitions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMqttDevicePropertyDefinitionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
  TError = ErrorsAPIError,
>(
  params: GetMqttDevicePropertyDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMqttDevicePropertyDefinitionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>> = ({
    signal,
  }) => getMqttDevicePropertyDefinitions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMqttDevicePropertyDefinitionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>
>;
export type GetMqttDevicePropertyDefinitionsQueryError = ErrorsAPIError;

export function useGetMqttDevicePropertyDefinitions<
  TData = Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
  TError = ErrorsAPIError,
>(
  params: GetMqttDevicePropertyDefinitionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMqttDevicePropertyDefinitions<
  TData = Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
  TError = ErrorsAPIError,
>(
  params: GetMqttDevicePropertyDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMqttDevicePropertyDefinitions<
  TData = Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
  TError = ErrorsAPIError,
>(
  params: GetMqttDevicePropertyDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMqttDevicePropertyDefinitions<
  TData = Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>,
  TError = ErrorsAPIError,
>(
  params: GetMqttDevicePropertyDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMqttDevicePropertyDefinitions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMqttDevicePropertyDefinitionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttGetAllInputMappings = (
  params?: IntegrationMqttGetAllInputMappingsParams,
  signal?: AbortSignal
) => {
  return customInstance<MqttGetAllInputMappingsResponse>({
    url: `/api/integrations/mqtt/inputs`,
    method: 'GET',
    params,
    signal,
  });
};

export const getIntegrationMqttGetAllInputMappingsQueryKey = (
  params?: IntegrationMqttGetAllInputMappingsParams
) => {
  return [`/api/integrations/mqtt/inputs`, ...(params ? [params] : [])] as const;
};

export const getIntegrationMqttGetAllInputMappingsQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllInputMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttGetAllInputMappingsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>> = ({
    signal,
  }) => integrationMqttGetAllInputMappings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetAllInputMappingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>
>;
export type IntegrationMqttGetAllInputMappingsQueryError = ErrorsAPIError;

export function useIntegrationMqttGetAllInputMappings<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
  TError = ErrorsAPIError,
>(
  params: undefined | IntegrationMqttGetAllInputMappingsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetAllInputMappings<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllInputMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetAllInputMappings<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllInputMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetAllInputMappings<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllInputMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllInputMappings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetAllInputMappingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttCreateInputMapping = (
  mqttCreateInputMappingRequest: MqttCreateInputMappingRequest,
  signal?: AbortSignal
) => {
  return customInstance<MqttCreateInputMappingResponse>({
    url: `/api/integrations/mqtt/inputs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mqttCreateInputMappingRequest,
    signal,
  });
};

export const getIntegrationMqttCreateInputMappingMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttCreateInputMapping>>,
    TError,
    { data: MqttCreateInputMappingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttCreateInputMapping>>,
  TError,
  { data: MqttCreateInputMappingRequest },
  TContext
> => {
  const mutationKey = ['integrationMqttCreateInputMapping'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttCreateInputMapping>>,
    { data: MqttCreateInputMappingRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationMqttCreateInputMapping(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttCreateInputMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttCreateInputMapping>>
>;
export type IntegrationMqttCreateInputMappingMutationBody = MqttCreateInputMappingRequest;
export type IntegrationMqttCreateInputMappingMutationError = ErrorsAPIError;

export const useIntegrationMqttCreateInputMapping = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttCreateInputMapping>>,
      TError,
      { data: MqttCreateInputMappingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttCreateInputMapping>>,
  TError,
  { data: MqttCreateInputMappingRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMqttCreateInputMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttDeleteInputMapping = (id: string) => {
  return customInstance<void>({ url: `/api/integrations/mqtt/inputs/${id}`, method: 'DELETE' });
};

export const getIntegrationMqttDeleteInputMappingMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttDeleteInputMapping>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttDeleteInputMapping>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMqttDeleteInputMapping'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttDeleteInputMapping>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMqttDeleteInputMapping(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttDeleteInputMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttDeleteInputMapping>>
>;

export type IntegrationMqttDeleteInputMappingMutationError = ErrorsAPIError;

export const useIntegrationMqttDeleteInputMapping = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttDeleteInputMapping>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttDeleteInputMapping>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMqttDeleteInputMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttGetInputMapping = (id: string, signal?: AbortSignal) => {
  return customInstance<MqttGetInputMappingResponse>({
    url: `/api/integrations/mqtt/inputs/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMqttGetInputMappingQueryKey = (id?: string) => {
  return [`/api/integrations/mqtt/inputs/${id}`] as const;
};

export const getIntegrationMqttGetInputMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetInputMapping>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttGetInputMappingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetInputMapping>>> = ({
    signal,
  }) => integrationMqttGetInputMapping(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetInputMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetInputMapping>>
>;
export type IntegrationMqttGetInputMappingQueryError = ErrorsAPIError;

export function useIntegrationMqttGetInputMapping<
  TData = Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetInputMapping>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetInputMapping>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetInputMapping<
  TData = Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetInputMapping>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetInputMapping>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetInputMapping<
  TData = Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetInputMapping>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetInputMapping<
  TData = Awaited<ReturnType<typeof integrationMqttGetInputMapping>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetInputMapping>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetInputMappingQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttUpdateInputMapping = (
  id: string,
  mqttUpdateInputMappingRequest: MqttUpdateInputMappingRequest
) => {
  return customInstance<MqttUpdateInputMappingResponse>({
    url: `/api/integrations/mqtt/inputs/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: mqttUpdateInputMappingRequest,
  });
};

export const getIntegrationMqttUpdateInputMappingMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttUpdateInputMapping>>,
    TError,
    { id: string; data: MqttUpdateInputMappingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttUpdateInputMapping>>,
  TError,
  { id: string; data: MqttUpdateInputMappingRequest },
  TContext
> => {
  const mutationKey = ['integrationMqttUpdateInputMapping'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttUpdateInputMapping>>,
    { id: string; data: MqttUpdateInputMappingRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationMqttUpdateInputMapping(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttUpdateInputMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttUpdateInputMapping>>
>;
export type IntegrationMqttUpdateInputMappingMutationBody = MqttUpdateInputMappingRequest;
export type IntegrationMqttUpdateInputMappingMutationError = ErrorsAPIError;

export const useIntegrationMqttUpdateInputMapping = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttUpdateInputMapping>>,
      TError,
      { id: string; data: MqttUpdateInputMappingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttUpdateInputMapping>>,
  TError,
  { id: string; data: MqttUpdateInputMappingRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMqttUpdateInputMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttGetAllSensors = (
  params?: IntegrationMqttGetAllSensorsParams,
  signal?: AbortSignal
) => {
  return customInstance<MqttGetAllSensorsResponse>({
    url: `/api/integrations/mqtt/sensors`,
    method: 'GET',
    params,
    signal,
  });
};

export const getIntegrationMqttGetAllSensorsQueryKey = (
  params?: IntegrationMqttGetAllSensorsParams
) => {
  return [`/api/integrations/mqtt/sensors`, ...(params ? [params] : [])] as const;
};

export const getIntegrationMqttGetAllSensorsQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllSensors>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttGetAllSensorsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetAllSensors>>> = ({
    signal,
  }) => integrationMqttGetAllSensors(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetAllSensorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetAllSensors>>
>;
export type IntegrationMqttGetAllSensorsQueryError = ErrorsAPIError;

export function useIntegrationMqttGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params: undefined | IntegrationMqttGetAllSensorsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllSensors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetAllSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllSensors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetAllSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllSensors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetAllSensors<
  TData = Awaited<ReturnType<typeof integrationMqttGetAllSensors>>,
  TError = ErrorsAPIError,
>(
  params?: IntegrationMqttGetAllSensorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetAllSensors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetAllSensorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttCreateSensor = (
  mqttCreateSensorRequest: MqttCreateSensorRequest,
  signal?: AbortSignal
) => {
  return customInstance<MqttCreateSensorResponse>({
    url: `/api/integrations/mqtt/sensors`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mqttCreateSensorRequest,
    signal,
  });
};

export const getIntegrationMqttCreateSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttCreateSensor>>,
    TError,
    { data: MqttCreateSensorRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttCreateSensor>>,
  TError,
  { data: MqttCreateSensorRequest },
  TContext
> => {
  const mutationKey = ['integrationMqttCreateSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttCreateSensor>>,
    { data: MqttCreateSensorRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationMqttCreateSensor(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttCreateSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttCreateSensor>>
>;
export type IntegrationMqttCreateSensorMutationBody = MqttCreateSensorRequest;
export type IntegrationMqttCreateSensorMutationError = ErrorsAPIError;

export const useIntegrationMqttCreateSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttCreateSensor>>,
      TError,
      { data: MqttCreateSensorRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttCreateSensor>>,
  TError,
  { data: MqttCreateSensorRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMqttCreateSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttDeleteSensor = (id: string) => {
  return customInstance<void>({ url: `/api/integrations/mqtt/sensors/${id}`, method: 'DELETE' });
};

export const getIntegrationMqttDeleteSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttDeleteSensor>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttDeleteSensor>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['integrationMqttDeleteSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttDeleteSensor>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return integrationMqttDeleteSensor(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttDeleteSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttDeleteSensor>>
>;

export type IntegrationMqttDeleteSensorMutationError = ErrorsAPIError;

export const useIntegrationMqttDeleteSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttDeleteSensor>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttDeleteSensor>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIntegrationMqttDeleteSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttGetSensor = (id: string, signal?: AbortSignal) => {
  return customInstance<MqttGetSensorResponse>({
    url: `/api/integrations/mqtt/sensors/${id}`,
    method: 'GET',
    signal,
  });
};

export const getIntegrationMqttGetSensorQueryKey = (id?: string) => {
  return [`/api/integrations/mqtt/sensors/${id}`] as const;
};

export const getIntegrationMqttGetSensorQueryOptions = <
  TData = Awaited<ReturnType<typeof integrationMqttGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetSensor>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntegrationMqttGetSensorQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof integrationMqttGetSensor>>> = ({
    signal,
  }) => integrationMqttGetSensor(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof integrationMqttGetSensor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type IntegrationMqttGetSensorQueryResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttGetSensor>>
>;
export type IntegrationMqttGetSensorQueryError = ErrorsAPIError;

export function useIntegrationMqttGetSensor<
  TData = Awaited<ReturnType<typeof integrationMqttGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetSensor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetSensor>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetSensor<
  TData = Awaited<ReturnType<typeof integrationMqttGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetSensor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof integrationMqttGetSensor>>,
          TError,
          Awaited<ReturnType<typeof integrationMqttGetSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIntegrationMqttGetSensor<
  TData = Awaited<ReturnType<typeof integrationMqttGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetSensor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useIntegrationMqttGetSensor<
  TData = Awaited<ReturnType<typeof integrationMqttGetSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof integrationMqttGetSensor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIntegrationMqttGetSensorQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const integrationMqttUpdateSensor = (
  id: string,
  mqttUpdateSensorRequest: MqttUpdateSensorRequest
) => {
  return customInstance<MqttUpdateSensorResponse>({
    url: `/api/integrations/mqtt/sensors/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: mqttUpdateSensorRequest,
  });
};

export const getIntegrationMqttUpdateSensorMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttUpdateSensor>>,
    TError,
    { id: string; data: MqttUpdateSensorRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttUpdateSensor>>,
  TError,
  { id: string; data: MqttUpdateSensorRequest },
  TContext
> => {
  const mutationKey = ['integrationMqttUpdateSensor'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttUpdateSensor>>,
    { id: string; data: MqttUpdateSensorRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return integrationMqttUpdateSensor(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttUpdateSensorMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttUpdateSensor>>
>;
export type IntegrationMqttUpdateSensorMutationBody = MqttUpdateSensorRequest;
export type IntegrationMqttUpdateSensorMutationError = ErrorsAPIError;

export const useIntegrationMqttUpdateSensor = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttUpdateSensor>>,
      TError,
      { id: string; data: MqttUpdateSensorRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttUpdateSensor>>,
  TError,
  { id: string; data: MqttUpdateSensorRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMqttUpdateSensorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const integrationMqttPreviewExtraction = (
  mqttPreviewExtractionRequest: MqttPreviewExtractionRequest,
  signal?: AbortSignal
) => {
  return customInstance<MqttPreviewExtractionResponse>({
    url: `/api/integrations/mqtt/sensors/preview-extraction`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mqttPreviewExtractionRequest,
    signal,
  });
};

export const getIntegrationMqttPreviewExtractionMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof integrationMqttPreviewExtraction>>,
    TError,
    { data: MqttPreviewExtractionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof integrationMqttPreviewExtraction>>,
  TError,
  { data: MqttPreviewExtractionRequest },
  TContext
> => {
  const mutationKey = ['integrationMqttPreviewExtraction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof integrationMqttPreviewExtraction>>,
    { data: MqttPreviewExtractionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return integrationMqttPreviewExtraction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntegrationMqttPreviewExtractionMutationResult = NonNullable<
  Awaited<ReturnType<typeof integrationMqttPreviewExtraction>>
>;
export type IntegrationMqttPreviewExtractionMutationBody = MqttPreviewExtractionRequest;
export type IntegrationMqttPreviewExtractionMutationError = ErrorsAPIError;

export const useIntegrationMqttPreviewExtraction = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof integrationMqttPreviewExtraction>>,
      TError,
      { data: MqttPreviewExtractionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof integrationMqttPreviewExtraction>>,
  TError,
  { data: MqttPreviewExtractionRequest },
  TContext
> => {
  const mutationOptions = getIntegrationMqttPreviewExtractionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsPhilipsHueBridges = (signal?: AbortSignal) => {
  return customInstance<HueGetAllBridgesResponse>({
    url: `/api/integrations/philips-hue/bridges`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsPhilipsHueBridgesQueryKey = () => {
  return [`/api/integrations/philips-hue/bridges`] as const;
};

export const getGetApiIntegrationsPhilipsHueBridgesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsPhilipsHueBridgesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>> = ({
    signal,
  }) => getApiIntegrationsPhilipsHueBridges(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsPhilipsHueBridgesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>
>;
export type GetApiIntegrationsPhilipsHueBridgesQueryError = ErrorsAPIError;

export function useGetApiIntegrationsPhilipsHueBridges<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueBridges<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueBridges<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsPhilipsHueBridges<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridges>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsPhilipsHueBridgesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsPhilipsHueBridges = (
  hueCreateBridgeRequest: HueCreateBridgeRequest,
  signal?: AbortSignal
) => {
  return customInstance<HueCreateBridgeResponse | HueCreateBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: hueCreateBridgeRequest,
    signal,
  });
};

export const getPostApiIntegrationsPhilipsHueBridgesMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridges>>,
    TError,
    { data: HueCreateBridgeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridges>>,
  TError,
  { data: HueCreateBridgeRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsPhilipsHueBridges'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridges>>,
    { data: HueCreateBridgeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsPhilipsHueBridges(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsPhilipsHueBridgesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridges>>
>;
export type PostApiIntegrationsPhilipsHueBridgesMutationBody = HueCreateBridgeRequest;
export type PostApiIntegrationsPhilipsHueBridgesMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePostApiIntegrationsPhilipsHueBridges = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridges>>,
      TError,
      { data: HueCreateBridgeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridges>>,
  TError,
  { data: HueCreateBridgeRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsPhilipsHueBridgesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiIntegrationsPhilipsHueBridgesId = (id: string) => {
  return customInstance<HueDeleteBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiIntegrationsPhilipsHueBridgesIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueBridgesId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueBridgesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiIntegrationsPhilipsHueBridgesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueBridgesId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiIntegrationsPhilipsHueBridgesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiIntegrationsPhilipsHueBridgesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueBridgesId>>
>;

export type DeleteApiIntegrationsPhilipsHueBridgesIdMutationError = ErrorsAPIError;

export const useDeleteApiIntegrationsPhilipsHueBridgesId = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueBridgesId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueBridgesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiIntegrationsPhilipsHueBridgesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsPhilipsHueBridgesId = (id: string, signal?: AbortSignal) => {
  return customInstance<HueGetBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsPhilipsHueBridgesIdQueryKey = (id?: string) => {
  return [`/api/integrations/philips-hue/bridges/${id}`] as const;
};

export const getGetApiIntegrationsPhilipsHueBridgesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsPhilipsHueBridgesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>
  > = ({ signal }) => getApiIntegrationsPhilipsHueBridgesId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsPhilipsHueBridgesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>
>;
export type GetApiIntegrationsPhilipsHueBridgesIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsPhilipsHueBridgesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueBridgesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueBridgesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsPhilipsHueBridgesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsPhilipsHueBridgesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsPhilipsHueBridgesId = (
  id: string,
  hueUpdateBridgeRequest: HueUpdateBridgeRequest
) => {
  return customInstance<HueUpdateBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: hueUpdateBridgeRequest,
  });
};

export const getPutApiIntegrationsPhilipsHueBridgesIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueBridgesId>>,
    TError,
    { id: string; data: HueUpdateBridgeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueBridgesId>>,
  TError,
  { id: string; data: HueUpdateBridgeRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsPhilipsHueBridgesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueBridgesId>>,
    { id: string; data: HueUpdateBridgeRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsPhilipsHueBridgesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsPhilipsHueBridgesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueBridgesId>>
>;
export type PutApiIntegrationsPhilipsHueBridgesIdMutationBody = HueUpdateBridgeRequest;
export type PutApiIntegrationsPhilipsHueBridgesIdMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePutApiIntegrationsPhilipsHueBridgesId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueBridgesId>>,
      TError,
      { id: string; data: HueUpdateBridgeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueBridgesId>>,
  TError,
  { id: string; data: HueUpdateBridgeRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsPhilipsHueBridgesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsPhilipsHueBridgesIdAuthenticate = (
  id: string,
  hueAuthenticateBridgeRequest: HueAuthenticateBridgeRequest,
  signal?: AbortSignal
) => {
  return customInstance<HueAuthenticateBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}/authenticate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: hueAuthenticateBridgeRequest,
    signal,
  });
};

export const getPostApiIntegrationsPhilipsHueBridgesIdAuthenticateMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdAuthenticate>>,
    TError,
    { id: string; data: HueAuthenticateBridgeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdAuthenticate>>,
  TError,
  { id: string; data: HueAuthenticateBridgeRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsPhilipsHueBridgesIdAuthenticate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdAuthenticate>>,
    { id: string; data: HueAuthenticateBridgeRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiIntegrationsPhilipsHueBridgesIdAuthenticate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsPhilipsHueBridgesIdAuthenticateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdAuthenticate>>
>;
export type PostApiIntegrationsPhilipsHueBridgesIdAuthenticateMutationBody =
  HueAuthenticateBridgeRequest;
export type PostApiIntegrationsPhilipsHueBridgesIdAuthenticateMutationError = ErrorsAPIError;

export const usePostApiIntegrationsPhilipsHueBridgesIdAuthenticate = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdAuthenticate>>,
      TError,
      { id: string; data: HueAuthenticateBridgeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdAuthenticate>>,
  TError,
  { id: string; data: HueAuthenticateBridgeRequest },
  TContext
> => {
  const mutationOptions =
    getPostApiIntegrationsPhilipsHueBridgesIdAuthenticateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsPhilipsHueBridgesIdDevices = (id: string, signal?: AbortSignal) => {
  return customInstance<HueGetDevicesByBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}/devices`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsPhilipsHueBridgesIdDevicesQueryKey = (id?: string) => {
  return [`/api/integrations/philips-hue/bridges/${id}/devices`] as const;
};

export const getGetApiIntegrationsPhilipsHueBridgesIdDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiIntegrationsPhilipsHueBridgesIdDevicesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>
  > = ({ signal }) => getApiIntegrationsPhilipsHueBridgesIdDevices(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsPhilipsHueBridgesIdDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>
>;
export type GetApiIntegrationsPhilipsHueBridgesIdDevicesQueryError = ErrorsAPIError;

export function useGetApiIntegrationsPhilipsHueBridgesIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueBridgesIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueBridgesIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsPhilipsHueBridgesIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueBridgesIdDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsPhilipsHueBridgesIdDevicesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsPhilipsHueBridgesIdDiscover = (
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<HueDiscoverDevicesResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}/discover`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsPhilipsHueBridgesIdDiscoverMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdDiscover>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdDiscover>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsPhilipsHueBridgesIdDiscover'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdDiscover>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsPhilipsHueBridgesIdDiscover(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsPhilipsHueBridgesIdDiscoverMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdDiscover>>
>;

export type PostApiIntegrationsPhilipsHueBridgesIdDiscoverMutationError = ErrorsAPIError;

export const usePostApiIntegrationsPhilipsHueBridgesIdDiscover = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdDiscover>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdDiscover>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsPhilipsHueBridgesIdDiscoverMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsPhilipsHueBridgesIdPause = (id: string, signal?: AbortSignal) => {
  return customInstance<HuePauseBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsPhilipsHueBridgesIdPauseMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdPause>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsPhilipsHueBridgesIdPause'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdPause>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsPhilipsHueBridgesIdPause(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsPhilipsHueBridgesIdPauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdPause>>
>;

export type PostApiIntegrationsPhilipsHueBridgesIdPauseMutationError = ErrorsAPIError;

export const usePostApiIntegrationsPhilipsHueBridgesIdPause = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdPause>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsPhilipsHueBridgesIdPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsPhilipsHueBridgesIdResume = (id: string, signal?: AbortSignal) => {
  return customInstance<HueResumeBridgeResponse>({
    url: `/api/integrations/philips-hue/bridges/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsPhilipsHueBridgesIdResumeMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdResume>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsPhilipsHueBridgesIdResume'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdResume>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsPhilipsHueBridgesIdResume(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsPhilipsHueBridgesIdResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdResume>>
>;

export type PostApiIntegrationsPhilipsHueBridgesIdResumeMutationError = ErrorsAPIError;

export const usePostApiIntegrationsPhilipsHueBridgesIdResume = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdResume>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueBridgesIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsPhilipsHueBridgesIdResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsPhilipsHueDevices = (signal?: AbortSignal) => {
  return customInstance<HueGetAllDevicesResponse>({
    url: `/api/integrations/philips-hue/devices`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsPhilipsHueDevicesQueryKey = () => {
  return [`/api/integrations/philips-hue/devices`] as const;
};

export const getGetApiIntegrationsPhilipsHueDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsPhilipsHueDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>> = ({
    signal,
  }) => getApiIntegrationsPhilipsHueDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsPhilipsHueDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>
>;
export type GetApiIntegrationsPhilipsHueDevicesQueryError = ErrorsAPIError;

export function useGetApiIntegrationsPhilipsHueDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsPhilipsHueDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsPhilipsHueDevicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsPhilipsHueDevices = (
  hueCreateDeviceRequest: HueCreateDeviceRequest,
  signal?: AbortSignal
) => {
  return customInstance<HueCreateDeviceResponse>({
    url: `/api/integrations/philips-hue/devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: hueCreateDeviceRequest,
    signal,
  });
};

export const getPostApiIntegrationsPhilipsHueDevicesMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueDevices>>,
    TError,
    { data: HueCreateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueDevices>>,
  TError,
  { data: HueCreateDeviceRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsPhilipsHueDevices'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueDevices>>,
    { data: HueCreateDeviceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsPhilipsHueDevices(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsPhilipsHueDevicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueDevices>>
>;
export type PostApiIntegrationsPhilipsHueDevicesMutationBody = HueCreateDeviceRequest;
export type PostApiIntegrationsPhilipsHueDevicesMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePostApiIntegrationsPhilipsHueDevices = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueDevices>>,
      TError,
      { data: HueCreateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsPhilipsHueDevices>>,
  TError,
  { data: HueCreateDeviceRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsPhilipsHueDevicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiIntegrationsPhilipsHueDevicesId = (id: string) => {
  return customInstance<HueDeleteDeviceResponse>({
    url: `/api/integrations/philips-hue/devices/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiIntegrationsPhilipsHueDevicesIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueDevicesId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiIntegrationsPhilipsHueDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueDevicesId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiIntegrationsPhilipsHueDevicesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiIntegrationsPhilipsHueDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueDevicesId>>
>;

export type DeleteApiIntegrationsPhilipsHueDevicesIdMutationError = ErrorsAPIError;

export const useDeleteApiIntegrationsPhilipsHueDevicesId = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueDevicesId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiIntegrationsPhilipsHueDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiIntegrationsPhilipsHueDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsPhilipsHueDevicesId = (id: string, signal?: AbortSignal) => {
  return customInstance<HueGetDeviceResponse>({
    url: `/api/integrations/philips-hue/devices/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsPhilipsHueDevicesIdQueryKey = (id?: string) => {
  return [`/api/integrations/philips-hue/devices/${id}`] as const;
};

export const getGetApiIntegrationsPhilipsHueDevicesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsPhilipsHueDevicesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>
  > = ({ signal }) => getApiIntegrationsPhilipsHueDevicesId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsPhilipsHueDevicesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>
>;
export type GetApiIntegrationsPhilipsHueDevicesIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsPhilipsHueDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsPhilipsHueDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsPhilipsHueDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsPhilipsHueDevicesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsPhilipsHueDevicesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsPhilipsHueDevicesId = (
  id: string,
  hueUpdateDeviceRequest: HueUpdateDeviceRequest
) => {
  return customInstance<HueUpdateDeviceResponse>({
    url: `/api/integrations/philips-hue/devices/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: hueUpdateDeviceRequest,
  });
};

export const getPutApiIntegrationsPhilipsHueDevicesIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueDevicesId>>,
    TError,
    { id: string; data: HueUpdateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueDevicesId>>,
  TError,
  { id: string; data: HueUpdateDeviceRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsPhilipsHueDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueDevicesId>>,
    { id: string; data: HueUpdateDeviceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsPhilipsHueDevicesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsPhilipsHueDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueDevicesId>>
>;
export type PutApiIntegrationsPhilipsHueDevicesIdMutationBody = HueUpdateDeviceRequest;
export type PutApiIntegrationsPhilipsHueDevicesIdMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePutApiIntegrationsPhilipsHueDevicesId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueDevicesId>>,
      TError,
      { id: string; data: HueUpdateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsPhilipsHueDevicesId>>,
  TError,
  { id: string; data: HueUpdateDeviceRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsPhilipsHueDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellyDevices = (signal?: AbortSignal) => {
  return customInstance<ShellyGetAllDevicesResponse>({
    url: `/api/integrations/shelly/devices`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyDevicesQueryKey = () => {
  return [`/api/integrations/shelly/devices`] as const;
};

export const getGetApiIntegrationsShellyDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsShellyDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>> = ({
    signal,
  }) => getApiIntegrationsShellyDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>
>;
export type GetApiIntegrationsShellyDevicesQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyDevicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsShellyDevices = (
  shellyCreateDeviceRequest: ShellyCreateDeviceRequest,
  signal?: AbortSignal
) => {
  return customInstance<ShellyCreateDeviceResponse>({
    url: `/api/integrations/shelly/devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shellyCreateDeviceRequest,
    signal,
  });
};

export const getPostApiIntegrationsShellyDevicesMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsShellyDevices>>,
    TError,
    { data: ShellyCreateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsShellyDevices>>,
  TError,
  { data: ShellyCreateDeviceRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsShellyDevices'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsShellyDevices>>,
    { data: ShellyCreateDeviceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsShellyDevices(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsShellyDevicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsShellyDevices>>
>;
export type PostApiIntegrationsShellyDevicesMutationBody = ShellyCreateDeviceRequest;
export type PostApiIntegrationsShellyDevicesMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePostApiIntegrationsShellyDevices = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsShellyDevices>>,
      TError,
      { data: ShellyCreateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsShellyDevices>>,
  TError,
  { data: ShellyCreateDeviceRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsShellyDevicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiIntegrationsShellyDevicesId = (id: string) => {
  return customInstance<ShellyDeleteDeviceResponse>({
    url: `/api/integrations/shelly/devices/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiIntegrationsShellyDevicesIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiIntegrationsShellyDevicesId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiIntegrationsShellyDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiIntegrationsShellyDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiIntegrationsShellyDevicesId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiIntegrationsShellyDevicesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiIntegrationsShellyDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiIntegrationsShellyDevicesId>>
>;

export type DeleteApiIntegrationsShellyDevicesIdMutationError = ErrorsAPIError;

export const useDeleteApiIntegrationsShellyDevicesId = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiIntegrationsShellyDevicesId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiIntegrationsShellyDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiIntegrationsShellyDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellyDevicesId = (id: string, signal?: AbortSignal) => {
  return customInstance<ShellyGetDeviceResponse>({
    url: `/api/integrations/shelly/devices/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyDevicesIdQueryKey = (id?: string) => {
  return [`/api/integrations/shelly/devices/${id}`] as const;
};

export const getGetApiIntegrationsShellyDevicesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsShellyDevicesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>> = ({
    signal,
  }) => getApiIntegrationsShellyDevicesId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyDevicesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>
>;
export type GetApiIntegrationsShellyDevicesIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyDevicesId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyDevicesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsShellyDevicesId = (
  id: string,
  shellyUpdateDeviceRequest: ShellyUpdateDeviceRequest
) => {
  return customInstance<ShellyUpdateDeviceResponse>({
    url: `/api/integrations/shelly/devices/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: shellyUpdateDeviceRequest,
  });
};

export const getPutApiIntegrationsShellyDevicesIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsShellyDevicesId>>,
    TError,
    { id: string; data: ShellyUpdateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsShellyDevicesId>>,
  TError,
  { id: string; data: ShellyUpdateDeviceRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsShellyDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsShellyDevicesId>>,
    { id: string; data: ShellyUpdateDeviceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsShellyDevicesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsShellyDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsShellyDevicesId>>
>;
export type PutApiIntegrationsShellyDevicesIdMutationBody = ShellyUpdateDeviceRequest;
export type PutApiIntegrationsShellyDevicesIdMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePutApiIntegrationsShellyDevicesId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsShellyDevicesId>>,
      TError,
      { id: string; data: ShellyUpdateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsShellyDevicesId>>,
  TError,
  { id: string; data: ShellyUpdateDeviceRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsShellyDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellyHardware = (signal?: AbortSignal) => {
  return customInstance<ShellyGetAllHardwareResponse>({
    url: `/api/integrations/shelly/hardware`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyHardwareQueryKey = () => {
  return [`/api/integrations/shelly/hardware`] as const;
};

export const getGetApiIntegrationsShellyHardwareQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsShellyHardwareQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>> = ({
    signal,
  }) => getApiIntegrationsShellyHardware(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyHardwareQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>
>;
export type GetApiIntegrationsShellyHardwareQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyHardware<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardware<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardware<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyHardware<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardware>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyHardwareQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsShellyHardware = (
  shellyCreateHardwareRequest: ShellyCreateHardwareRequest,
  signal?: AbortSignal
) => {
  return customInstance<ShellyCreateHardwareResponse>({
    url: `/api/integrations/shelly/hardware`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shellyCreateHardwareRequest,
    signal,
  });
};

export const getPostApiIntegrationsShellyHardwareMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardware>>,
    TError,
    { data: ShellyCreateHardwareRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardware>>,
  TError,
  { data: ShellyCreateHardwareRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsShellyHardware'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardware>>,
    { data: ShellyCreateHardwareRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsShellyHardware(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsShellyHardwareMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardware>>
>;
export type PostApiIntegrationsShellyHardwareMutationBody = ShellyCreateHardwareRequest;
export type PostApiIntegrationsShellyHardwareMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePostApiIntegrationsShellyHardware = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsShellyHardware>>,
      TError,
      { data: ShellyCreateHardwareRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardware>>,
  TError,
  { data: ShellyCreateHardwareRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsShellyHardwareMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiIntegrationsShellyHardwareId = (id: string) => {
  return customInstance<ShellyDeleteHardwareResponse>({
    url: `/api/integrations/shelly/hardware/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiIntegrationsShellyHardwareIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiIntegrationsShellyHardwareId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiIntegrationsShellyHardwareId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiIntegrationsShellyHardwareId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiIntegrationsShellyHardwareId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiIntegrationsShellyHardwareId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiIntegrationsShellyHardwareIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiIntegrationsShellyHardwareId>>
>;

export type DeleteApiIntegrationsShellyHardwareIdMutationError = ErrorsAPIError;

export const useDeleteApiIntegrationsShellyHardwareId = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiIntegrationsShellyHardwareId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiIntegrationsShellyHardwareId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiIntegrationsShellyHardwareIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellyHardwareId = (id: string, signal?: AbortSignal) => {
  return customInstance<ShellyGetHardwareResponse>({
    url: `/api/integrations/shelly/hardware/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyHardwareIdQueryKey = (id?: string) => {
  return [`/api/integrations/shelly/hardware/${id}`] as const;
};

export const getGetApiIntegrationsShellyHardwareIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsShellyHardwareIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>> = ({
    signal,
  }) => getApiIntegrationsShellyHardwareId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyHardwareIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>
>;
export type GetApiIntegrationsShellyHardwareIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyHardwareId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyHardwareId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyHardwareIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsShellyHardwareId = (
  id: string,
  shellyUpdateHardwareRequest: ShellyUpdateHardwareRequest
) => {
  return customInstance<ShellyUpdateHardwareResponse>({
    url: `/api/integrations/shelly/hardware/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: shellyUpdateHardwareRequest,
  });
};

export const getPutApiIntegrationsShellyHardwareIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsShellyHardwareId>>,
    TError,
    { id: string; data: ShellyUpdateHardwareRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsShellyHardwareId>>,
  TError,
  { id: string; data: ShellyUpdateHardwareRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsShellyHardwareId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsShellyHardwareId>>,
    { id: string; data: ShellyUpdateHardwareRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsShellyHardwareId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsShellyHardwareIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsShellyHardwareId>>
>;
export type PutApiIntegrationsShellyHardwareIdMutationBody = ShellyUpdateHardwareRequest;
export type PutApiIntegrationsShellyHardwareIdMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePutApiIntegrationsShellyHardwareId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsShellyHardwareId>>,
      TError,
      { id: string; data: ShellyUpdateHardwareRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsShellyHardwareId>>,
  TError,
  { id: string; data: ShellyUpdateHardwareRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsShellyHardwareIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellyHardwareIdCapabilities = (
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<ShellyGetHardwareCapabilitiesResponse>({
    url: `/api/integrations/shelly/hardware/${id}/capabilities`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyHardwareIdCapabilitiesQueryKey = (id?: string) => {
  return [`/api/integrations/shelly/hardware/${id}/capabilities`] as const;
};

export const getGetApiIntegrationsShellyHardwareIdCapabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiIntegrationsShellyHardwareIdCapabilitiesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>
  > = ({ signal }) => getApiIntegrationsShellyHardwareIdCapabilities(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyHardwareIdCapabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>
>;
export type GetApiIntegrationsShellyHardwareIdCapabilitiesQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyHardwareIdCapabilities<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdCapabilities<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdCapabilities<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyHardwareIdCapabilities<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdCapabilities>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyHardwareIdCapabilitiesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiIntegrationsShellyHardwareIdDevices = (id: string, signal?: AbortSignal) => {
  return customInstance<ShellyGetDevicesByHardwareResponse>({
    url: `/api/integrations/shelly/hardware/${id}/devices`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyHardwareIdDevicesQueryKey = (id?: string) => {
  return [`/api/integrations/shelly/hardware/${id}/devices`] as const;
};

export const getGetApiIntegrationsShellyHardwareIdDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiIntegrationsShellyHardwareIdDevicesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>
  > = ({ signal }) => getApiIntegrationsShellyHardwareIdDevices(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyHardwareIdDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>
>;
export type GetApiIntegrationsShellyHardwareIdDevicesQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyHardwareIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyHardwareIdDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyHardwareIdDevicesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsShellyHardwareIdTest = (id: string, signal?: AbortSignal) => {
  return customInstance<ShellyTestConnectionResponse>({
    url: `/api/integrations/shelly/hardware/${id}/test`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsShellyHardwareIdTestMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdTest>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdTest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsShellyHardwareIdTest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdTest>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsShellyHardwareIdTest(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsShellyHardwareIdTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdTest>>
>;

export type PostApiIntegrationsShellyHardwareIdTestMutationError = ErrorsAPIError;

export const usePostApiIntegrationsShellyHardwareIdTest = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdTest>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdTest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsShellyHardwareIdTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellyHardwareIdWebhookStatus = (
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<ShellyWebhookStatusResponse>({
    url: `/api/integrations/shelly/hardware/${id}/webhook-status`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyHardwareIdWebhookStatusQueryKey = (id?: string) => {
  return [`/api/integrations/shelly/hardware/${id}/webhook-status`] as const;
};

export const getGetApiIntegrationsShellyHardwareIdWebhookStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiIntegrationsShellyHardwareIdWebhookStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>
  > = ({ signal }) => getApiIntegrationsShellyHardwareIdWebhookStatus(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyHardwareIdWebhookStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>
>;
export type GetApiIntegrationsShellyHardwareIdWebhookStatusQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyHardwareIdWebhookStatus<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdWebhookStatus<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdWebhookStatus<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyHardwareIdWebhookStatus<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhookStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyHardwareIdWebhookStatusQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsShellyHardwareIdWebhookConfigure = (
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<ShellyConfigureWebhookResponse>({
    url: `/api/integrations/shelly/hardware/${id}/webhook/configure`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsShellyHardwareIdWebhookConfigureMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookConfigure>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookConfigure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsShellyHardwareIdWebhookConfigure'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookConfigure>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsShellyHardwareIdWebhookConfigure(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsShellyHardwareIdWebhookConfigureMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookConfigure>>
>;

export type PostApiIntegrationsShellyHardwareIdWebhookConfigureMutationError = ErrorsAPIError;

export const usePostApiIntegrationsShellyHardwareIdWebhookConfigure = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookConfigure>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookConfigure>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPostApiIntegrationsShellyHardwareIdWebhookConfigureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsShellyHardwareIdWebhookRepair = (
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<ShellyRepairWebhookResponse>({
    url: `/api/integrations/shelly/hardware/${id}/webhook/repair`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsShellyHardwareIdWebhookRepairMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookRepair>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookRepair>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsShellyHardwareIdWebhookRepair'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookRepair>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsShellyHardwareIdWebhookRepair(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsShellyHardwareIdWebhookRepairMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookRepair>>
>;

export type PostApiIntegrationsShellyHardwareIdWebhookRepairMutationError = ErrorsAPIError;

export const usePostApiIntegrationsShellyHardwareIdWebhookRepair = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookRepair>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareIdWebhookRepair>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPostApiIntegrationsShellyHardwareIdWebhookRepairMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellyHardwareIdWebhooks = (id: string, signal?: AbortSignal) => {
  return customInstance<ShellyListWebhooksResponse>({
    url: `/api/integrations/shelly/hardware/${id}/webhooks`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellyHardwareIdWebhooksQueryKey = (id?: string) => {
  return [`/api/integrations/shelly/hardware/${id}/webhooks`] as const;
};

export const getGetApiIntegrationsShellyHardwareIdWebhooksQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiIntegrationsShellyHardwareIdWebhooksQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>
  > = ({ signal }) => getApiIntegrationsShellyHardwareIdWebhooks(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellyHardwareIdWebhooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>
>;
export type GetApiIntegrationsShellyHardwareIdWebhooksQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellyHardwareIdWebhooks<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdWebhooks<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellyHardwareIdWebhooks<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellyHardwareIdWebhooks<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiIntegrationsShellyHardwareIdWebhooks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellyHardwareIdWebhooksQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsShellyHardwareDiscover = (
  shellyDiscoverHardwareRequest: ShellyDiscoverHardwareRequest,
  signal?: AbortSignal
) => {
  return customInstance<ShellyDiscoverHardwareResponse>({
    url: `/api/integrations/shelly/hardware/discover`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shellyDiscoverHardwareRequest,
    signal,
  });
};

export const getPostApiIntegrationsShellyHardwareDiscoverMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareDiscover>>,
    TError,
    { data: ShellyDiscoverHardwareRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareDiscover>>,
  TError,
  { data: ShellyDiscoverHardwareRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsShellyHardwareDiscover'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareDiscover>>,
    { data: ShellyDiscoverHardwareRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsShellyHardwareDiscover(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsShellyHardwareDiscoverMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareDiscover>>
>;
export type PostApiIntegrationsShellyHardwareDiscoverMutationBody = ShellyDiscoverHardwareRequest;
export type PostApiIntegrationsShellyHardwareDiscoverMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePostApiIntegrationsShellyHardwareDiscover = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareDiscover>>,
      TError,
      { data: ShellyDiscoverHardwareRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsShellyHardwareDiscover>>,
  TError,
  { data: ShellyDiscoverHardwareRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsShellyHardwareDiscoverMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsShellySettings = (signal?: AbortSignal) => {
  return customInstance<ShellyGetSettingsResponse>({
    url: `/api/integrations/shelly/settings`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsShellySettingsQueryKey = () => {
  return [`/api/integrations/shelly/settings`] as const;
};

export const getGetApiIntegrationsShellySettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsShellySettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>> = ({
    signal,
  }) => getApiIntegrationsShellySettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsShellySettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>
>;
export type GetApiIntegrationsShellySettingsQueryError = ErrorsAPIError;

export function useGetApiIntegrationsShellySettings<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellySettings<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsShellySettings<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsShellySettings<
  TData = Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsShellySettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsShellySettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsShellySettings = (
  shellyUpdateSettingsRequest: ShellyUpdateSettingsRequest
) => {
  return customInstance<ShellyUpdateSettingsResponse>({
    url: `/api/integrations/shelly/settings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: shellyUpdateSettingsRequest,
  });
};

export const getPutApiIntegrationsShellySettingsMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsShellySettings>>,
    TError,
    { data: ShellyUpdateSettingsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsShellySettings>>,
  TError,
  { data: ShellyUpdateSettingsRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsShellySettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsShellySettings>>,
    { data: ShellyUpdateSettingsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return putApiIntegrationsShellySettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsShellySettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsShellySettings>>
>;
export type PutApiIntegrationsShellySettingsMutationBody = ShellyUpdateSettingsRequest;
export type PutApiIntegrationsShellySettingsMutationError = ErrorsAPIError;

export const usePutApiIntegrationsShellySettings = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsShellySettings>>,
      TError,
      { data: ShellyUpdateSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsShellySettings>>,
  TError,
  { data: ShellyUpdateSettingsRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsShellySettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsShellyWebhookHardwareId = (
  hardwareId: string,
  params?: PostApiIntegrationsShellyWebhookHardwareIdParams,
  signal?: AbortSignal
) => {
  return customInstance<ShellyReceiveWebhookResponse>({
    url: `/api/integrations/shelly/webhook/${hardwareId}`,
    method: 'POST',
    params,
    signal,
  });
};

export const getPostApiIntegrationsShellyWebhookHardwareIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsShellyWebhookHardwareId>>,
    TError,
    { hardwareId: string; params?: PostApiIntegrationsShellyWebhookHardwareIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsShellyWebhookHardwareId>>,
  TError,
  { hardwareId: string; params?: PostApiIntegrationsShellyWebhookHardwareIdParams },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsShellyWebhookHardwareId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsShellyWebhookHardwareId>>,
    { hardwareId: string; params?: PostApiIntegrationsShellyWebhookHardwareIdParams }
  > = (props) => {
    const { hardwareId, params } = props ?? {};

    return postApiIntegrationsShellyWebhookHardwareId(hardwareId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsShellyWebhookHardwareIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsShellyWebhookHardwareId>>
>;

export type PostApiIntegrationsShellyWebhookHardwareIdMutationError = ErrorsAPIError;

export const usePostApiIntegrationsShellyWebhookHardwareId = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsShellyWebhookHardwareId>>,
      TError,
      { hardwareId: string; params?: PostApiIntegrationsShellyWebhookHardwareIdParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsShellyWebhookHardwareId>>,
  TError,
  { hardwareId: string; params?: PostApiIntegrationsShellyWebhookHardwareIdParams },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsShellyWebhookHardwareIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsSlideDevices = (signal?: AbortSignal) => {
  return customInstance<SlideGetAllDevicesResponse>({
    url: `/api/integrations/slide/devices`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsSlideDevicesQueryKey = () => {
  return [`/api/integrations/slide/devices`] as const;
};

export const getGetApiIntegrationsSlideDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsSlideDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>> = ({
    signal,
  }) => getApiIntegrationsSlideDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsSlideDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>
>;
export type GetApiIntegrationsSlideDevicesQueryError = ErrorsAPIError;

export function useGetApiIntegrationsSlideDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsSlideDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsSlideDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsSlideDevices<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsSlideDevicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsSlideDevices = (
  slideCreateDeviceRequest: SlideCreateDeviceRequest,
  signal?: AbortSignal
) => {
  return customInstance<SlideCreateDeviceResponse>({
    url: `/api/integrations/slide/devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slideCreateDeviceRequest,
    signal,
  });
};

export const getPostApiIntegrationsSlideDevicesMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevices>>,
    TError,
    { data: SlideCreateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevices>>,
  TError,
  { data: SlideCreateDeviceRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsSlideDevices'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevices>>,
    { data: SlideCreateDeviceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsSlideDevices(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsSlideDevicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevices>>
>;
export type PostApiIntegrationsSlideDevicesMutationBody = SlideCreateDeviceRequest;
export type PostApiIntegrationsSlideDevicesMutationError = ValidationErrorResponse | ErrorsAPIError;

export const usePostApiIntegrationsSlideDevices = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsSlideDevices>>,
      TError,
      { data: SlideCreateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevices>>,
  TError,
  { data: SlideCreateDeviceRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsSlideDevicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiIntegrationsSlideDevicesId = (id: string) => {
  return customInstance<SlideDeleteDeviceResponse>({
    url: `/api/integrations/slide/devices/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiIntegrationsSlideDevicesIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiIntegrationsSlideDevicesId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiIntegrationsSlideDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiIntegrationsSlideDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiIntegrationsSlideDevicesId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiIntegrationsSlideDevicesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiIntegrationsSlideDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiIntegrationsSlideDevicesId>>
>;

export type DeleteApiIntegrationsSlideDevicesIdMutationError = ErrorsAPIError;

export const useDeleteApiIntegrationsSlideDevicesId = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiIntegrationsSlideDevicesId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiIntegrationsSlideDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiIntegrationsSlideDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsSlideDevicesId = (id: string, signal?: AbortSignal) => {
  return customInstance<SlideGetDeviceResponse>({
    url: `/api/integrations/slide/devices/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsSlideDevicesIdQueryKey = (id?: string) => {
  return [`/api/integrations/slide/devices/${id}`] as const;
};

export const getGetApiIntegrationsSlideDevicesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsSlideDevicesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>> = ({
    signal,
  }) => getApiIntegrationsSlideDevicesId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsSlideDevicesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>
>;
export type GetApiIntegrationsSlideDevicesIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsSlideDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsSlideDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsSlideDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsSlideDevicesId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsSlideDevicesId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsSlideDevicesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsSlideDevicesId = (
  id: string,
  slideUpdateDeviceRequest: SlideUpdateDeviceRequest
) => {
  return customInstance<SlideUpdateDeviceResponse>({
    url: `/api/integrations/slide/devices/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: slideUpdateDeviceRequest,
  });
};

export const getPutApiIntegrationsSlideDevicesIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsSlideDevicesId>>,
    TError,
    { id: string; data: SlideUpdateDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsSlideDevicesId>>,
  TError,
  { id: string; data: SlideUpdateDeviceRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsSlideDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsSlideDevicesId>>,
    { id: string; data: SlideUpdateDeviceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsSlideDevicesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsSlideDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsSlideDevicesId>>
>;
export type PutApiIntegrationsSlideDevicesIdMutationBody = SlideUpdateDeviceRequest;
export type PutApiIntegrationsSlideDevicesIdMutationError =
  | ValidationErrorResponse
  | ErrorsAPIError;

export const usePutApiIntegrationsSlideDevicesId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsSlideDevicesId>>,
      TError,
      { id: string; data: SlideUpdateDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsSlideDevicesId>>,
  TError,
  { id: string; data: SlideUpdateDeviceRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsSlideDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsSlideDevicesIdClose = (id: string, signal?: AbortSignal) => {
  return customInstance<SlideCloseDeviceResponse>({
    url: `/api/integrations/slide/devices/${id}/close`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsSlideDevicesIdCloseMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdClose>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdClose>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsSlideDevicesIdClose'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdClose>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsSlideDevicesIdClose(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsSlideDevicesIdCloseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdClose>>
>;

export type PostApiIntegrationsSlideDevicesIdCloseMutationError = ErrorsAPIError;

export const usePostApiIntegrationsSlideDevicesIdClose = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdClose>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdClose>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsSlideDevicesIdCloseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsSlideDevicesIdOpen = (id: string, signal?: AbortSignal) => {
  return customInstance<SlideOpenDeviceResponse>({
    url: `/api/integrations/slide/devices/${id}/open`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsSlideDevicesIdOpenMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdOpen>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdOpen>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsSlideDevicesIdOpen'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdOpen>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsSlideDevicesIdOpen(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsSlideDevicesIdOpenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdOpen>>
>;

export type PostApiIntegrationsSlideDevicesIdOpenMutationError = ErrorsAPIError;

export const usePostApiIntegrationsSlideDevicesIdOpen = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdOpen>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdOpen>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsSlideDevicesIdOpenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsSlideDevicesIdStop = (id: string, signal?: AbortSignal) => {
  return customInstance<SlideStopDeviceResponse>({
    url: `/api/integrations/slide/devices/${id}/stop`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsSlideDevicesIdStopMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdStop>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdStop>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsSlideDevicesIdStop'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdStop>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsSlideDevicesIdStop(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsSlideDevicesIdStopMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdStop>>
>;

export type PostApiIntegrationsSlideDevicesIdStopMutationError = ErrorsAPIError;

export const usePostApiIntegrationsSlideDevicesIdStop = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdStop>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsSlideDevicesIdStop>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsSlideDevicesIdStopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsSlideTest = (
  slideTestConnectionRequest: SlideTestConnectionRequest,
  signal?: AbortSignal
) => {
  return customInstance<SlideTestConnectionResponse>({
    url: `/api/integrations/slide/test`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slideTestConnectionRequest,
    signal,
  });
};

export const getPostApiIntegrationsSlideTestMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsSlideTest>>,
    TError,
    { data: SlideTestConnectionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsSlideTest>>,
  TError,
  { data: SlideTestConnectionRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsSlideTest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsSlideTest>>,
    { data: SlideTestConnectionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsSlideTest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsSlideTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsSlideTest>>
>;
export type PostApiIntegrationsSlideTestMutationBody = SlideTestConnectionRequest;
export type PostApiIntegrationsSlideTestMutationError = ValidationErrorResponse | ErrorsAPIError;

export const usePostApiIntegrationsSlideTest = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsSlideTest>>,
      TError,
      { data: SlideTestConnectionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsSlideTest>>,
  TError,
  { data: SlideTestConnectionRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsSlideTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsWebosTvs = (signal?: AbortSignal) => {
  return customInstance<WebosListTVsResponse>({
    url: `/api/integrations/webos/tvs`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsWebosTvsQueryKey = () => {
  return [`/api/integrations/webos/tvs`] as const;
};

export const getGetApiIntegrationsWebosTvsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsWebosTvsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>> = ({
    signal,
  }) => getApiIntegrationsWebosTvs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsWebosTvsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>
>;
export type GetApiIntegrationsWebosTvsQueryError = ErrorsAPIError;

export function useGetApiIntegrationsWebosTvs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsWebosTvs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsWebosTvs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsWebosTvs<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsWebosTvsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiIntegrationsWebosTvs = (
  webosAddTVRequest: WebosAddTVRequest,
  signal?: AbortSignal
) => {
  return customInstance<WebosAddTVResponse>({
    url: `/api/integrations/webos/tvs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: webosAddTVRequest,
    signal,
  });
};

export const getPostApiIntegrationsWebosTvsMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsWebosTvs>>,
    TError,
    { data: WebosAddTVRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvs>>,
  TError,
  { data: WebosAddTVRequest },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsWebosTvs'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsWebosTvs>>,
    { data: WebosAddTVRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiIntegrationsWebosTvs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsWebosTvsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvs>>
>;
export type PostApiIntegrationsWebosTvsMutationBody = WebosAddTVRequest;
export type PostApiIntegrationsWebosTvsMutationError = ValidationErrorResponse | ErrorsAPIError;

export const usePostApiIntegrationsWebosTvs = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsWebosTvs>>,
      TError,
      { data: WebosAddTVRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvs>>,
  TError,
  { data: WebosAddTVRequest },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsWebosTvsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiIntegrationsWebosTvsId = (id: string) => {
  return customInstance<WebosDeleteTVResponse>({
    url: `/api/integrations/webos/tvs/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiIntegrationsWebosTvsIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiIntegrationsWebosTvsId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiIntegrationsWebosTvsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiIntegrationsWebosTvsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiIntegrationsWebosTvsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiIntegrationsWebosTvsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiIntegrationsWebosTvsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiIntegrationsWebosTvsId>>
>;

export type DeleteApiIntegrationsWebosTvsIdMutationError = ErrorsAPIError;

export const useDeleteApiIntegrationsWebosTvsId = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiIntegrationsWebosTvsId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiIntegrationsWebosTvsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiIntegrationsWebosTvsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiIntegrationsWebosTvsId = (id: string, signal?: AbortSignal) => {
  return customInstance<WebosGetTVResponse>({
    url: `/api/integrations/webos/tvs/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiIntegrationsWebosTvsIdQueryKey = (id?: string) => {
  return [`/api/integrations/webos/tvs/${id}`] as const;
};

export const getGetApiIntegrationsWebosTvsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiIntegrationsWebosTvsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>> = ({
    signal,
  }) => getApiIntegrationsWebosTvsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiIntegrationsWebosTvsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>
>;
export type GetApiIntegrationsWebosTvsIdQueryError = ErrorsAPIError;

export function useGetApiIntegrationsWebosTvsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsWebosTvsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
          TError,
          Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiIntegrationsWebosTvsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiIntegrationsWebosTvsId<
  TData = Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiIntegrationsWebosTvsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiIntegrationsWebosTvsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiIntegrationsWebosTvsId = (
  id: string,
  webosUpdateTVRequest: WebosUpdateTVRequest
) => {
  return customInstance<WebosUpdateTVResponse>({
    url: `/api/integrations/webos/tvs/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: webosUpdateTVRequest,
  });
};

export const getPutApiIntegrationsWebosTvsIdMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiIntegrationsWebosTvsId>>,
    TError,
    { id: string; data: WebosUpdateTVRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiIntegrationsWebosTvsId>>,
  TError,
  { id: string; data: WebosUpdateTVRequest },
  TContext
> => {
  const mutationKey = ['putApiIntegrationsWebosTvsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiIntegrationsWebosTvsId>>,
    { id: string; data: WebosUpdateTVRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiIntegrationsWebosTvsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiIntegrationsWebosTvsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiIntegrationsWebosTvsId>>
>;
export type PutApiIntegrationsWebosTvsIdMutationBody = WebosUpdateTVRequest;
export type PutApiIntegrationsWebosTvsIdMutationError = ValidationErrorResponse | ErrorsAPIError;

export const usePutApiIntegrationsWebosTvsId = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiIntegrationsWebosTvsId>>,
      TError,
      { id: string; data: WebosUpdateTVRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiIntegrationsWebosTvsId>>,
  TError,
  { id: string; data: WebosUpdateTVRequest },
  TContext
> => {
  const mutationOptions = getPutApiIntegrationsWebosTvsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsWebosTvsIdPause = (id: string, signal?: AbortSignal) => {
  return customInstance<WebosPauseTVResponse>({
    url: `/api/integrations/webos/tvs/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsWebosTvsIdPauseMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdPause>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsWebosTvsIdPause'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdPause>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsWebosTvsIdPause(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsWebosTvsIdPauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdPause>>
>;

export type PostApiIntegrationsWebosTvsIdPauseMutationError = ErrorsAPIError;

export const usePostApiIntegrationsWebosTvsIdPause = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdPause>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsWebosTvsIdPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiIntegrationsWebosTvsIdResume = (id: string, signal?: AbortSignal) => {
  return customInstance<WebosResumeTVResponse>({
    url: `/api/integrations/webos/tvs/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getPostApiIntegrationsWebosTvsIdResumeMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdResume>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postApiIntegrationsWebosTvsIdResume'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdResume>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postApiIntegrationsWebosTvsIdResume(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiIntegrationsWebosTvsIdResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdResume>>
>;

export type PostApiIntegrationsWebosTvsIdResumeMutationError = ErrorsAPIError;

export const usePostApiIntegrationsWebosTvsIdResume = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdResume>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiIntegrationsWebosTvsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostApiIntegrationsWebosTvsIdResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiLogs = (params?: GetApiLogsParams, signal?: AbortSignal) => {
  return customInstance<LoggerGetLogsResponse>({ url: `/api/logs`, method: 'GET', params, signal });
};

export const getGetApiLogsQueryKey = (params?: GetApiLogsParams) => {
  return [`/api/logs`, ...(params ? [params] : [])] as const;
};

export const getGetApiLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLogs>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  params?: GetApiLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogs>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLogs>>> = ({ signal }) =>
    getApiLogs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLogs>>>;
export type GetApiLogsQueryError = ValidationErrorResponse | ErrorsAPIError;

export function useGetApiLogs<
  TData = Awaited<ReturnType<typeof getApiLogs>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  params: undefined | GetApiLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiLogs<
  TData = Awaited<ReturnType<typeof getApiLogs>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  params?: GetApiLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiLogs<
  TData = Awaited<ReturnType<typeof getApiLogs>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  params?: GetApiLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiLogs<
  TData = Awaited<ReturnType<typeof getApiLogs>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  params?: GetApiLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiLogsStats = (signal?: AbortSignal) => {
  return customInstance<LoggerGetLogStatsResponse>({
    url: `/api/logs/stats`,
    method: 'GET',
    signal,
  });
};

export const getGetApiLogsStatsQueryKey = () => {
  return [`/api/logs/stats`] as const;
};

export const getGetApiLogsStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLogsStats>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogsStats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLogsStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLogsStats>>> = ({ signal }) =>
    getApiLogsStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLogsStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiLogsStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLogsStats>>>;
export type GetApiLogsStatsQueryError = ErrorsAPIError;

export function useGetApiLogsStats<
  TData = Awaited<ReturnType<typeof getApiLogsStats>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogsStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLogsStats>>,
          TError,
          Awaited<ReturnType<typeof getApiLogsStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiLogsStats<
  TData = Awaited<ReturnType<typeof getApiLogsStats>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogsStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLogsStats>>,
          TError,
          Awaited<ReturnType<typeof getApiLogsStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiLogsStats<
  TData = Awaited<ReturnType<typeof getApiLogsStats>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogsStats>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiLogsStats<
  TData = Awaited<ReturnType<typeof getApiLogsStats>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLogsStats>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiLogsStatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listNotifications = (params?: ListNotificationsParams, signal?: AbortSignal) => {
  return customInstance<NotificationsListNotificationsResponse>({
    url: `/api/notifications`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListNotificationsQueryKey = (params?: ListNotificationsParams) => {
  return [`/api/notifications`, ...(params ? [params] : [])] as const;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorsAPIError,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) =>
    listNotifications(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsQueryError = ErrorsAPIError;

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorsAPIError,
>(
  params: undefined | ListNotificationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorsAPIError,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorsAPIError,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorsAPIError,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const markAsRead = (id: string, signal?: AbortSignal) => {
  return customInstance<NotificationsMarkAsReadResponse>({
    url: `/api/notifications/${id}/read`,
    method: 'POST',
    signal,
  });
};

export const getMarkAsReadMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAsRead>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAsRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['markAsRead'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAsRead>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return markAsRead(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAsRead>>>;

export type MarkAsReadMutationError = ErrorsAPIError;

export const useMarkAsRead = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAsRead>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof markAsRead>>, TError, { id: string }, TContext> => {
  const mutationOptions = getMarkAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const registerPushDevice = (
  notificationsRegisterPushDeviceRequest: NotificationsRegisterPushDeviceRequest,
  signal?: AbortSignal
) => {
  return customInstance<NotificationsRegisterPushDeviceResponse>({
    url: `/api/notifications/push-devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: notificationsRegisterPushDeviceRequest,
    signal,
  });
};

export const getRegisterPushDeviceMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPushDevice>>,
    TError,
    { data: NotificationsRegisterPushDeviceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerPushDevice>>,
  TError,
  { data: NotificationsRegisterPushDeviceRequest },
  TContext
> => {
  const mutationKey = ['registerPushDevice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerPushDevice>>,
    { data: NotificationsRegisterPushDeviceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return registerPushDevice(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterPushDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerPushDevice>>
>;
export type RegisterPushDeviceMutationBody = NotificationsRegisterPushDeviceRequest;
export type RegisterPushDeviceMutationError = ErrorsAPIError;

export const useRegisterPushDevice = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerPushDevice>>,
      TError,
      { data: NotificationsRegisterPushDeviceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof registerPushDevice>>,
  TError,
  { data: NotificationsRegisterPushDeviceRequest },
  TContext
> => {
  const mutationOptions = getRegisterPushDeviceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deletePushDevice = (token: string) => {
  return customInstance<NotificationsDeletePushDeviceResponse>({
    url: `/api/notifications/push-devices/${token}`,
    method: 'DELETE',
  });
};

export const getDeletePushDeviceMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePushDevice>>,
    TError,
    { token: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePushDevice>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ['deletePushDevice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePushDevice>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return deletePushDevice(token);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePushDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePushDevice>>
>;

export type DeletePushDeviceMutationError = ErrorsAPIError;

export const useDeletePushDevice = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePushDevice>>,
      TError,
      { token: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deletePushDevice>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationOptions = getDeletePushDeviceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const markAllAsRead = (signal?: AbortSignal) => {
  return customInstance<NotificationsMarkAllAsReadResponse>({
    url: `/api/notifications/read-all`,
    method: 'POST',
    signal,
  });
};

export const getMarkAllAsReadMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof markAllAsRead>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof markAllAsRead>>, TError, void, TContext> => {
  const mutationKey = ['markAllAsRead'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllAsRead>>, void> = () => {
    return markAllAsRead();
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllAsRead>>>;

export type MarkAllAsReadMutationError = ErrorsAPIError;

export const useMarkAllAsRead = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAllAsRead>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof markAllAsRead>>, TError, void, TContext> => {
  const mutationOptions = getMarkAllAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const sendNotification = (
  notificationsSendNotificationRequest: NotificationsSendNotificationRequest,
  signal?: AbortSignal
) => {
  return customInstance<NotificationsSendNotificationResponse>({
    url: `/api/notifications/send`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: notificationsSendNotificationRequest,
    signal,
  });
};

export const getSendNotificationMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendNotification>>,
    TError,
    { data: NotificationsSendNotificationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendNotification>>,
  TError,
  { data: NotificationsSendNotificationRequest },
  TContext
> => {
  const mutationKey = ['sendNotification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendNotification>>,
    { data: NotificationsSendNotificationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return sendNotification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendNotification>>
>;
export type SendNotificationMutationBody = NotificationsSendNotificationRequest;
export type SendNotificationMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useSendNotification = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendNotification>>,
      TError,
      { data: NotificationsSendNotificationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sendNotification>>,
  TError,
  { data: NotificationsSendNotificationRequest },
  TContext
> => {
  const mutationOptions = getSendNotificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const streamNotifications = (signal?: AbortSignal) => {
  return customInstance<unknown>({ url: `/api/notifications/stream`, method: 'GET', signal });
};

export const getStreamNotificationsQueryKey = () => {
  return [`/api/notifications/stream`] as const;
};

export const getStreamNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamNotifications>>,
  TError = void | ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamNotificationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamNotifications>>> = ({ signal }) =>
    streamNotifications(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamNotifications>>
>;
export type StreamNotificationsQueryError = void | ErrorsAPIError;

export function useStreamNotifications<
  TData = Awaited<ReturnType<typeof streamNotifications>>,
  TError = void | ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamNotifications>>,
          TError,
          Awaited<ReturnType<typeof streamNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamNotifications<
  TData = Awaited<ReturnType<typeof streamNotifications>>,
  TError = void | ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamNotifications>>,
          TError,
          Awaited<ReturnType<typeof streamNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamNotifications<
  TData = Awaited<ReturnType<typeof streamNotifications>>,
  TError = void | ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStreamNotifications<
  TData = Awaited<ReturnType<typeof streamNotifications>>,
  TError = void | ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamNotificationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUnreadCount = (signal?: AbortSignal) => {
  return customInstance<NotificationsGetUnreadCountResponse>({
    url: `/api/notifications/unread-count`,
    method: 'GET',
    signal,
  });
};

export const getGetUnreadCountQueryKey = () => {
  return [`/api/notifications/unread-count`] as const;
};

export const getGetUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnreadCount>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUnreadCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) =>
    getUnreadCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnreadCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>;
export type GetUnreadCountQueryError = ErrorsAPIError;

export function useGetUnreadCount<
  TData = Awaited<ReturnType<typeof getUnreadCount>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUnreadCount<
  TData = Awaited<ReturnType<typeof getUnreadCount>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUnreadCount<
  TData = Awaited<ReturnType<typeof getUnreadCount>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUnreadCount<
  TData = Awaited<ReturnType<typeof getUnreadCount>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUnreadCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listScenes = (signal?: AbortSignal) => {
  return customInstance<ScenesListScenesResponse>({ url: `/api/scenes`, method: 'GET', signal });
};

export const getListScenesQueryKey = () => {
  return [`/api/scenes`] as const;
};

export const getListScenesQueryOptions = <
  TData = Awaited<ReturnType<typeof listScenes>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScenes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScenesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScenes>>> = ({ signal }) =>
    listScenes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listScenes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListScenesQueryResult = NonNullable<Awaited<ReturnType<typeof listScenes>>>;
export type ListScenesQueryError = ErrorsAPIError;

export function useListScenes<
  TData = Awaited<ReturnType<typeof listScenes>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScenes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScenes>>,
          TError,
          Awaited<ReturnType<typeof listScenes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListScenes<
  TData = Awaited<ReturnType<typeof listScenes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScenes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScenes>>,
          TError,
          Awaited<ReturnType<typeof listScenes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListScenes<
  TData = Awaited<ReturnType<typeof listScenes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScenes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListScenes<
  TData = Awaited<ReturnType<typeof listScenes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listScenes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListScenesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createScene = (
  scenesCreateSceneRequestBody: ScenesCreateSceneRequestBody,
  signal?: AbortSignal
) => {
  return customInstance<ScenesSceneResponse>({
    url: `/api/scenes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scenesCreateSceneRequestBody,
    signal,
  });
};

export const getCreateSceneMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScene>>,
    TError,
    { data: ScenesCreateSceneRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createScene>>,
  TError,
  { data: ScenesCreateSceneRequestBody },
  TContext
> => {
  const mutationKey = ['createScene'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createScene>>,
    { data: ScenesCreateSceneRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return createScene(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSceneMutationResult = NonNullable<Awaited<ReturnType<typeof createScene>>>;
export type CreateSceneMutationBody = ScenesCreateSceneRequestBody;
export type CreateSceneMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useCreateScene = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createScene>>,
      TError,
      { data: ScenesCreateSceneRequestBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createScene>>,
  TError,
  { data: ScenesCreateSceneRequestBody },
  TContext
> => {
  const mutationOptions = getCreateSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteScene = (id: string) => {
  return customInstance<void>({ url: `/api/scenes/${id}`, method: 'DELETE' });
};

export const getDeleteSceneMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScene>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteScene>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteScene'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScene>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return deleteScene(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSceneMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScene>>>;

export type DeleteSceneMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useDeleteScene = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteScene>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteScene>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getScene = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenesSceneResponse>({ url: `/api/scenes/${id}`, method: 'GET', signal });
};

export const getGetSceneQueryKey = (id?: string) => {
  return [`/api/scenes/${id}`] as const;
};

export const getGetSceneQueryOptions = <
  TData = Awaited<ReturnType<typeof getScene>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScene>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSceneQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScene>>> = ({ signal }) =>
    getScene(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getScene>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSceneQueryResult = NonNullable<Awaited<ReturnType<typeof getScene>>>;
export type GetSceneQueryError = ValidationErrorResponse | ErrorsAPIError;

export function useGetScene<
  TData = Awaited<ReturnType<typeof getScene>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScene>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScene>>,
          TError,
          Awaited<ReturnType<typeof getScene>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetScene<
  TData = Awaited<ReturnType<typeof getScene>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScene>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScene>>,
          TError,
          Awaited<ReturnType<typeof getScene>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetScene<
  TData = Awaited<ReturnType<typeof getScene>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScene>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetScene<
  TData = Awaited<ReturnType<typeof getScene>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getScene>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSceneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateScene = (
  id: string,
  scenesCreateSceneRequestBody: ScenesCreateSceneRequestBody
) => {
  return customInstance<ScenesSceneResponse>({
    url: `/api/scenes/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: scenesCreateSceneRequestBody,
  });
};

export const getUpdateSceneMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScene>>,
    TError,
    { id: string; data: ScenesCreateSceneRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateScene>>,
  TError,
  { id: string; data: ScenesCreateSceneRequestBody },
  TContext
> => {
  const mutationKey = ['updateScene'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateScene>>,
    { id: string; data: ScenesCreateSceneRequestBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateScene(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSceneMutationResult = NonNullable<Awaited<ReturnType<typeof updateScene>>>;
export type UpdateSceneMutationBody = ScenesCreateSceneRequestBody;
export type UpdateSceneMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateScene = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateScene>>,
      TError,
      { id: string; data: ScenesCreateSceneRequestBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateScene>>,
  TError,
  { id: string; data: ScenesCreateSceneRequestBody },
  TContext
> => {
  const mutationOptions = getUpdateSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const activateScene = (
  id: string,
  scenesActivateSceneRequest: ScenesActivateSceneRequest,
  signal?: AbortSignal
) => {
  return customInstance<ScenesActivateSceneResponse>({
    url: `/api/scenes/${id}/activate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scenesActivateSceneRequest,
    signal,
  });
};

export const getActivateSceneMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateScene>>,
    TError,
    { id: string; data: ScenesActivateSceneRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateScene>>,
  TError,
  { id: string; data: ScenesActivateSceneRequest },
  TContext
> => {
  const mutationKey = ['activateScene'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateScene>>,
    { id: string; data: ScenesActivateSceneRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return activateScene(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateSceneMutationResult = NonNullable<Awaited<ReturnType<typeof activateScene>>>;
export type ActivateSceneMutationBody = ScenesActivateSceneRequest;
export type ActivateSceneMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useActivateScene = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateScene>>,
      TError,
      { id: string; data: ScenesActivateSceneRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof activateScene>>,
  TError,
  { id: string; data: ScenesActivateSceneRequest },
  TContext
> => {
  const mutationOptions = getActivateSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listSceneActivations = (
  id: string,
  params?: ListSceneActivationsParams,
  signal?: AbortSignal
) => {
  return customInstance<ScenesListActivationsResponse>({
    url: `/api/scenes/${id}/activations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSceneActivationsQueryKey = (
  id?: string,
  params?: ListSceneActivationsParams
) => {
  return [`/api/scenes/${id}/activations`, ...(params ? [params] : [])] as const;
};

export const getListSceneActivationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSceneActivations>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  params?: ListSceneActivationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSceneActivations>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSceneActivationsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSceneActivations>>> = ({ signal }) =>
    listSceneActivations(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSceneActivations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListSceneActivationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSceneActivations>>
>;
export type ListSceneActivationsQueryError = ValidationErrorResponse | ErrorsAPIError;

export function useListSceneActivations<
  TData = Awaited<ReturnType<typeof listSceneActivations>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  params: undefined | ListSceneActivationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSceneActivations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSceneActivations>>,
          TError,
          Awaited<ReturnType<typeof listSceneActivations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSceneActivations<
  TData = Awaited<ReturnType<typeof listSceneActivations>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  params?: ListSceneActivationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSceneActivations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSceneActivations>>,
          TError,
          Awaited<ReturnType<typeof listSceneActivations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSceneActivations<
  TData = Awaited<ReturnType<typeof listSceneActivations>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  params?: ListSceneActivationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSceneActivations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListSceneActivations<
  TData = Awaited<ReturnType<typeof listSceneActivations>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  params?: ListSceneActivationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSceneActivations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListSceneActivationsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deactivateScene = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/api/scenes/${id}/deactivate`, method: 'POST', signal });
};

export const getDeactivateSceneMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateScene>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateScene>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deactivateScene'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateScene>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deactivateScene(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateSceneMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateScene>>
>;

export type DeactivateSceneMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useDeactivateScene = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateScene>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateScene>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeactivateSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getSceneEvaluation = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenesSceneConditionEvaluationResponse>({
    url: `/api/scenes/${id}/evaluation`,
    method: 'GET',
    signal,
  });
};

export const getGetSceneEvaluationQueryKey = (id?: string) => {
  return [`/api/scenes/${id}/evaluation`] as const;
};

export const getGetSceneEvaluationQueryOptions = <
  TData = Awaited<ReturnType<typeof getSceneEvaluation>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSceneEvaluation>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSceneEvaluationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSceneEvaluation>>> = ({ signal }) =>
    getSceneEvaluation(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSceneEvaluation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSceneEvaluationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSceneEvaluation>>
>;
export type GetSceneEvaluationQueryError = ValidationErrorResponse | ErrorsAPIError;

export function useGetSceneEvaluation<
  TData = Awaited<ReturnType<typeof getSceneEvaluation>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSceneEvaluation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSceneEvaluation>>,
          TError,
          Awaited<ReturnType<typeof getSceneEvaluation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSceneEvaluation<
  TData = Awaited<ReturnType<typeof getSceneEvaluation>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSceneEvaluation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSceneEvaluation>>,
          TError,
          Awaited<ReturnType<typeof getSceneEvaluation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSceneEvaluation<
  TData = Awaited<ReturnType<typeof getSceneEvaluation>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSceneEvaluation>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSceneEvaluation<
  TData = Awaited<ReturnType<typeof getSceneEvaluation>>,
  TError = ValidationErrorResponse | ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSceneEvaluation>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSceneEvaluationQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateScenePriorities = (
  scenesUpdatePrioritiesRequest: ScenesUpdatePrioritiesRequest
) => {
  return customInstance<void>({
    url: `/api/scenes/priorities`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: scenesUpdatePrioritiesRequest,
  });
};

export const getUpdateScenePrioritiesMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScenePriorities>>,
    TError,
    { data: ScenesUpdatePrioritiesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateScenePriorities>>,
  TError,
  { data: ScenesUpdatePrioritiesRequest },
  TContext
> => {
  const mutationKey = ['updateScenePriorities'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateScenePriorities>>,
    { data: ScenesUpdatePrioritiesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateScenePriorities(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateScenePrioritiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateScenePriorities>>
>;
export type UpdateScenePrioritiesMutationBody = ScenesUpdatePrioritiesRequest;
export type UpdateScenePrioritiesMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateScenePriorities = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateScenePriorities>>,
      TError,
      { data: ScenesUpdatePrioritiesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateScenePriorities>>,
  TError,
  { data: ScenesUpdatePrioritiesRequest },
  TContext
> => {
  const mutationOptions = getUpdateScenePrioritiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const streamSceneEvents = (signal?: AbortSignal) => {
  return customInstance<unknown>({ url: `/api/scenes/stream`, method: 'GET', signal });
};

export const getStreamSceneEventsQueryKey = () => {
  return [`/api/scenes/stream`] as const;
};

export const getStreamSceneEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamSceneEvents>>,
  TError = void | ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSceneEvents>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamSceneEventsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamSceneEvents>>> = ({ signal }) =>
    streamSceneEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamSceneEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamSceneEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamSceneEvents>>
>;
export type StreamSceneEventsQueryError = void | ErrorsAPIError;

export function useStreamSceneEvents<
  TData = Awaited<ReturnType<typeof streamSceneEvents>>,
  TError = void | ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSceneEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamSceneEvents>>,
          TError,
          Awaited<ReturnType<typeof streamSceneEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamSceneEvents<
  TData = Awaited<ReturnType<typeof streamSceneEvents>>,
  TError = void | ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSceneEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamSceneEvents>>,
          TError,
          Awaited<ReturnType<typeof streamSceneEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamSceneEvents<
  TData = Awaited<ReturnType<typeof streamSceneEvents>>,
  TError = void | ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSceneEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStreamSceneEvents<
  TData = Awaited<ReturnType<typeof streamSceneEvents>>,
  TError = void | ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSceneEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamSceneEventsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listSensors = (signal?: AbortSignal) => {
  return customInstance<SensorsListSensorsResponse>({ url: `/api/sensors`, method: 'GET', signal });
};

export const getListSensorsQueryKey = () => {
  return [`/api/sensors`] as const;
};

export const getListSensorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSensors>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSensors>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSensorsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSensors>>> = ({ signal }) =>
    listSensors(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSensors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListSensorsQueryResult = NonNullable<Awaited<ReturnType<typeof listSensors>>>;
export type ListSensorsQueryError = ErrorsAPIError;

export function useListSensors<
  TData = Awaited<ReturnType<typeof listSensors>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSensors>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSensors>>,
          TError,
          Awaited<ReturnType<typeof listSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSensors<
  TData = Awaited<ReturnType<typeof listSensors>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSensors>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSensors>>,
          TError,
          Awaited<ReturnType<typeof listSensors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSensors<
  TData = Awaited<ReturnType<typeof listSensors>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSensors>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListSensors<
  TData = Awaited<ReturnType<typeof listSensors>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSensors>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListSensorsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSensor = (id: string, signal?: AbortSignal) => {
  return customInstance<SensorsGetSensorResponse>({
    url: `/api/sensors/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetSensorQueryKey = (id?: string) => {
  return [`/api/sensors/${id}`] as const;
};

export const getGetSensorQueryOptions = <
  TData = Awaited<ReturnType<typeof getSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensor>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSensorQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSensor>>> = ({ signal }) =>
    getSensor(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSensor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSensorQueryResult = NonNullable<Awaited<ReturnType<typeof getSensor>>>;
export type GetSensorQueryError = ErrorsAPIError;

export function useGetSensor<
  TData = Awaited<ReturnType<typeof getSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensor>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSensor>>,
          TError,
          Awaited<ReturnType<typeof getSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSensor<
  TData = Awaited<ReturnType<typeof getSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensor>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSensor>>,
          TError,
          Awaited<ReturnType<typeof getSensor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSensor<
  TData = Awaited<ReturnType<typeof getSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensor>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSensor<
  TData = Awaited<ReturnType<typeof getSensor>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensor>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSensorQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSensorAggregates = (
  id: string,
  params: GetSensorAggregatesParams,
  signal?: AbortSignal
) => {
  return customInstance<SensorsGetSensorAggregatesResponse>({
    url: `/api/sensors/${id}/aggregates`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetSensorAggregatesQueryKey = (id?: string, params?: GetSensorAggregatesParams) => {
  return [`/api/sensors/${id}/aggregates`, ...(params ? [params] : [])] as const;
};

export const getGetSensorAggregatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSensorAggregates>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSensorAggregates>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSensorAggregatesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSensorAggregates>>> = ({ signal }) =>
    getSensorAggregates(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSensorAggregates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSensorAggregatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSensorAggregates>>
>;
export type GetSensorAggregatesQueryError = ErrorsAPIError;

export function useGetSensorAggregates<
  TData = Awaited<ReturnType<typeof getSensorAggregates>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorAggregatesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSensorAggregates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSensorAggregates>>,
          TError,
          Awaited<ReturnType<typeof getSensorAggregates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSensorAggregates<
  TData = Awaited<ReturnType<typeof getSensorAggregates>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSensorAggregates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSensorAggregates>>,
          TError,
          Awaited<ReturnType<typeof getSensorAggregates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSensorAggregates<
  TData = Awaited<ReturnType<typeof getSensorAggregates>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSensorAggregates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSensorAggregates<
  TData = Awaited<ReturnType<typeof getSensorAggregates>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSensorAggregates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSensorAggregatesQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateSensorConfig = (
  id: string,
  sensorsUpdateSensorConfigRequest: SensorsUpdateSensorConfigRequest
) => {
  return customInstance<SensorsUpdateSensorConfigResponse>({
    url: `/api/sensors/${id}/config`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: sensorsUpdateSensorConfigRequest,
  });
};

export const getUpdateSensorConfigMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSensorConfig>>,
    TError,
    { id: string; data: SensorsUpdateSensorConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSensorConfig>>,
  TError,
  { id: string; data: SensorsUpdateSensorConfigRequest },
  TContext
> => {
  const mutationKey = ['updateSensorConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSensorConfig>>,
    { id: string; data: SensorsUpdateSensorConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSensorConfig(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSensorConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSensorConfig>>
>;
export type UpdateSensorConfigMutationBody = SensorsUpdateSensorConfigRequest;
export type UpdateSensorConfigMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateSensorConfig = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSensorConfig>>,
      TError,
      { id: string; data: SensorsUpdateSensorConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSensorConfig>>,
  TError,
  { id: string; data: SensorsUpdateSensorConfigRequest },
  TContext
> => {
  const mutationOptions = getUpdateSensorConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateSensorFavorite = (
  id: string,
  sensorsUpdateSensorFavoriteRequest: SensorsUpdateSensorFavoriteRequest
) => {
  return customInstance<SensorsUpdateSensorFavoriteResponse>({
    url: `/api/sensors/${id}/favorite`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: sensorsUpdateSensorFavoriteRequest,
  });
};

export const getUpdateSensorFavoriteMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSensorFavorite>>,
    TError,
    { id: string; data: SensorsUpdateSensorFavoriteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSensorFavorite>>,
  TError,
  { id: string; data: SensorsUpdateSensorFavoriteRequest },
  TContext
> => {
  const mutationKey = ['updateSensorFavorite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSensorFavorite>>,
    { id: string; data: SensorsUpdateSensorFavoriteRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSensorFavorite(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSensorFavoriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSensorFavorite>>
>;
export type UpdateSensorFavoriteMutationBody = SensorsUpdateSensorFavoriteRequest;
export type UpdateSensorFavoriteMutationError = ErrorsAPIError;

export const useUpdateSensorFavorite = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSensorFavorite>>,
      TError,
      { id: string; data: SensorsUpdateSensorFavoriteRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSensorFavorite>>,
  TError,
  { id: string; data: SensorsUpdateSensorFavoriteRequest },
  TContext
> => {
  const mutationOptions = getUpdateSensorFavoriteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getSensorHistory = (
  id: string,
  params: GetSensorHistoryParams,
  signal?: AbortSignal
) => {
  return customInstance<SensorsGetSensorHistoryResponse>({
    url: `/api/sensors/${id}/history`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetSensorHistoryQueryKey = (id?: string, params?: GetSensorHistoryParams) => {
  return [`/api/sensors/${id}/history`, ...(params ? [params] : [])] as const;
};

export const getGetSensorHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSensorHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensorHistory>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSensorHistoryQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSensorHistory>>> = ({ signal }) =>
    getSensorHistory(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSensorHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSensorHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getSensorHistory>>>;
export type GetSensorHistoryQueryError = ErrorsAPIError;

export function useGetSensorHistory<
  TData = Awaited<ReturnType<typeof getSensorHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorHistoryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensorHistory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSensorHistory>>,
          TError,
          Awaited<ReturnType<typeof getSensorHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSensorHistory<
  TData = Awaited<ReturnType<typeof getSensorHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensorHistory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSensorHistory>>,
          TError,
          Awaited<ReturnType<typeof getSensorHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSensorHistory<
  TData = Awaited<ReturnType<typeof getSensorHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensorHistory>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSensorHistory<
  TData = Awaited<ReturnType<typeof getSensorHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: GetSensorHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSensorHistory>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSensorHistoryQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMonotonicOffsetHistory = (id: string, signal?: AbortSignal) => {
  return customInstance<SensorsGetMonotonicOffsetHistoryResponse>({
    url: `/api/sensors/${id}/monotonic-history`,
    method: 'GET',
    signal,
  });
};

export const getGetMonotonicOffsetHistoryQueryKey = (id?: string) => {
  return [`/api/sensors/${id}/monotonic-history`] as const;
};

export const getGetMonotonicOffsetHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMonotonicOffsetHistory>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMonotonicOffsetHistoryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonotonicOffsetHistory>>> = ({
    signal,
  }) => getMonotonicOffsetHistory(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMonotonicOffsetHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMonotonicOffsetHistory>>
>;
export type GetMonotonicOffsetHistoryQueryError = ErrorsAPIError;

export function useGetMonotonicOffsetHistory<
  TData = Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMonotonicOffsetHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
          TError,
          Awaited<ReturnType<typeof getMonotonicOffsetHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMonotonicOffsetHistory<
  TData = Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMonotonicOffsetHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
          TError,
          Awaited<ReturnType<typeof getMonotonicOffsetHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMonotonicOffsetHistory<
  TData = Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMonotonicOffsetHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMonotonicOffsetHistory<
  TData = Awaited<ReturnType<typeof getMonotonicOffsetHistory>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMonotonicOffsetHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMonotonicOffsetHistoryQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const setMonotonicOffset = (
  id: string,
  sensorsSetMonotonicOffsetRequest: SensorsSetMonotonicOffsetRequest,
  signal?: AbortSignal
) => {
  return customInstance<SensorsSetMonotonicOffsetResponse>({
    url: `/api/sensors/${id}/monotonic-offset`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sensorsSetMonotonicOffsetRequest,
    signal,
  });
};

export const getSetMonotonicOffsetMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMonotonicOffset>>,
    TError,
    { id: string; data: SensorsSetMonotonicOffsetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setMonotonicOffset>>,
  TError,
  { id: string; data: SensorsSetMonotonicOffsetRequest },
  TContext
> => {
  const mutationKey = ['setMonotonicOffset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMonotonicOffset>>,
    { id: string; data: SensorsSetMonotonicOffsetRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return setMonotonicOffset(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMonotonicOffsetMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMonotonicOffset>>
>;
export type SetMonotonicOffsetMutationBody = SensorsSetMonotonicOffsetRequest;
export type SetMonotonicOffsetMutationError = ErrorsAPIError;

export const useSetMonotonicOffset = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setMonotonicOffset>>,
      TError,
      { id: string; data: SensorsSetMonotonicOffsetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setMonotonicOffset>>,
  TError,
  { id: string; data: SensorsSetMonotonicOffsetRequest },
  TContext
> => {
  const mutationOptions = getSetMonotonicOffsetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const bulkUpdateSensors = (
  sensorsBulkUpdateSensorsRequest: SensorsBulkUpdateSensorsRequest
) => {
  return customInstance<SensorsBulkUpdateSensorsResponse>({
    url: `/api/sensors/bulk`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: sensorsBulkUpdateSensorsRequest,
  });
};

export const getBulkUpdateSensorsMutationOptions = <
  TError = SensorsBulkUpdateSensorsResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateSensors>>,
    TError,
    { data: SensorsBulkUpdateSensorsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateSensors>>,
  TError,
  { data: SensorsBulkUpdateSensorsRequest },
  TContext
> => {
  const mutationKey = ['bulkUpdateSensors'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateSensors>>,
    { data: SensorsBulkUpdateSensorsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkUpdateSensors(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateSensorsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpdateSensors>>
>;
export type BulkUpdateSensorsMutationBody = SensorsBulkUpdateSensorsRequest;
export type BulkUpdateSensorsMutationError = SensorsBulkUpdateSensorsResponse | ErrorsAPIError;

export const useBulkUpdateSensors = <
  TError = SensorsBulkUpdateSensorsResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkUpdateSensors>>,
      TError,
      { data: SensorsBulkUpdateSensorsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpdateSensors>>,
  TError,
  { data: SensorsBulkUpdateSensorsRequest },
  TContext
> => {
  const mutationOptions = getBulkUpdateSensorsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const streamSensorUpdates = (params?: StreamSensorUpdatesParams, signal?: AbortSignal) => {
  return customInstance<unknown>({ url: `/api/sensors/stream`, method: 'GET', params, signal });
};

export const getStreamSensorUpdatesQueryKey = (params?: StreamSensorUpdatesParams) => {
  return [`/api/sensors/stream`, ...(params ? [params] : [])] as const;
};

export const getStreamSensorUpdatesQueryOptions = <
  TData = Awaited<ReturnType<typeof streamSensorUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamSensorUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamSensorUpdates>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamSensorUpdatesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamSensorUpdates>>> = ({ signal }) =>
    streamSensorUpdates(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamSensorUpdates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamSensorUpdatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamSensorUpdates>>
>;
export type StreamSensorUpdatesQueryError = void | ErrorsAPIError;

export function useStreamSensorUpdates<
  TData = Awaited<ReturnType<typeof streamSensorUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params: undefined | StreamSensorUpdatesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamSensorUpdates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamSensorUpdates>>,
          TError,
          Awaited<ReturnType<typeof streamSensorUpdates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamSensorUpdates<
  TData = Awaited<ReturnType<typeof streamSensorUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamSensorUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamSensorUpdates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamSensorUpdates>>,
          TError,
          Awaited<ReturnType<typeof streamSensorUpdates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamSensorUpdates<
  TData = Awaited<ReturnType<typeof streamSensorUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamSensorUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamSensorUpdates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStreamSensorUpdates<
  TData = Awaited<ReturnType<typeof streamSensorUpdates>>,
  TError = void | ErrorsAPIError,
>(
  params?: StreamSensorUpdatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamSensorUpdates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamSensorUpdatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSettingsHeartbeats = (signal?: AbortSignal) => {
  return customInstance<HeartbeatsListHeartbeatsResponse>({
    url: `/api/settings/heartbeats`,
    method: 'GET',
    signal,
  });
};

export const getGetApiSettingsHeartbeatsQueryKey = () => {
  return [`/api/settings/heartbeats`] as const;
};

export const getGetApiSettingsHeartbeatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeats>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiSettingsHeartbeatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSettingsHeartbeats>>> = ({
    signal,
  }) => getApiSettingsHeartbeats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiSettingsHeartbeatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSettingsHeartbeats>>
>;
export type GetApiSettingsHeartbeatsQueryError = ErrorsAPIError;

export function useGetApiSettingsHeartbeats<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHeartbeats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHeartbeats<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHeartbeats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHeartbeats<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiSettingsHeartbeats<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeats>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiSettingsHeartbeatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiSettingsHeartbeats = (
  heartbeatsCreateHeartbeatRequest: HeartbeatsCreateHeartbeatRequest,
  signal?: AbortSignal
) => {
  return customInstance<HeartbeatsCreateHeartbeatResponse>({
    url: `/api/settings/heartbeats`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: heartbeatsCreateHeartbeatRequest,
    signal,
  });
};

export const getPostApiSettingsHeartbeatsMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSettingsHeartbeats>>,
    TError,
    { data: HeartbeatsCreateHeartbeatRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSettingsHeartbeats>>,
  TError,
  { data: HeartbeatsCreateHeartbeatRequest },
  TContext
> => {
  const mutationKey = ['postApiSettingsHeartbeats'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiSettingsHeartbeats>>,
    { data: HeartbeatsCreateHeartbeatRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiSettingsHeartbeats(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiSettingsHeartbeatsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiSettingsHeartbeats>>
>;
export type PostApiSettingsHeartbeatsMutationBody = HeartbeatsCreateHeartbeatRequest;
export type PostApiSettingsHeartbeatsMutationError = ErrorsAPIError;

export const usePostApiSettingsHeartbeats = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiSettingsHeartbeats>>,
      TError,
      { data: HeartbeatsCreateHeartbeatRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiSettingsHeartbeats>>,
  TError,
  { data: HeartbeatsCreateHeartbeatRequest },
  TContext
> => {
  const mutationOptions = getPostApiSettingsHeartbeatsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiSettingsHeartbeatsId = (id: string) => {
  return customInstance<HeartbeatsDeleteHeartbeatResponse>({
    url: `/api/settings/heartbeats/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteApiSettingsHeartbeatsIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiSettingsHeartbeatsId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiSettingsHeartbeatsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiSettingsHeartbeatsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiSettingsHeartbeatsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiSettingsHeartbeatsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiSettingsHeartbeatsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiSettingsHeartbeatsId>>
>;

export type DeleteApiSettingsHeartbeatsIdMutationError = ErrorsAPIError;

export const useDeleteApiSettingsHeartbeatsId = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiSettingsHeartbeatsId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiSettingsHeartbeatsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiSettingsHeartbeatsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const putApiSettingsHeartbeatsId = (
  id: string,
  heartbeatsUpdateHeartbeatRequest: HeartbeatsUpdateHeartbeatRequest
) => {
  return customInstance<HeartbeatsUpdateHeartbeatResponse>({
    url: `/api/settings/heartbeats/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: heartbeatsUpdateHeartbeatRequest,
  });
};

export const getPutApiSettingsHeartbeatsIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSettingsHeartbeatsId>>,
    TError,
    { id: string; data: HeartbeatsUpdateHeartbeatRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSettingsHeartbeatsId>>,
  TError,
  { id: string; data: HeartbeatsUpdateHeartbeatRequest },
  TContext
> => {
  const mutationKey = ['putApiSettingsHeartbeatsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSettingsHeartbeatsId>>,
    { id: string; data: HeartbeatsUpdateHeartbeatRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiSettingsHeartbeatsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSettingsHeartbeatsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSettingsHeartbeatsId>>
>;
export type PutApiSettingsHeartbeatsIdMutationBody = HeartbeatsUpdateHeartbeatRequest;
export type PutApiSettingsHeartbeatsIdMutationError = ErrorsAPIError;

export const usePutApiSettingsHeartbeatsId = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSettingsHeartbeatsId>>,
      TError,
      { id: string; data: HeartbeatsUpdateHeartbeatRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSettingsHeartbeatsId>>,
  TError,
  { id: string; data: HeartbeatsUpdateHeartbeatRequest },
  TContext
> => {
  const mutationOptions = getPutApiSettingsHeartbeatsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiSettingsHeartbeatsIdLogs = (
  id: string,
  params?: GetApiSettingsHeartbeatsIdLogsParams,
  signal?: AbortSignal
) => {
  return customInstance<HeartbeatsListLogsResponse>({
    url: `/api/settings/heartbeats/${id}/logs`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetApiSettingsHeartbeatsIdLogsQueryKey = (
  id?: string,
  params?: GetApiSettingsHeartbeatsIdLogsParams
) => {
  return [`/api/settings/heartbeats/${id}/logs`, ...(params ? [params] : [])] as const;
};

export const getGetApiSettingsHeartbeatsIdLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiSettingsHeartbeatsIdLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiSettingsHeartbeatsIdLogsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>> = ({
    signal,
  }) => getApiSettingsHeartbeatsIdLogs(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiSettingsHeartbeatsIdLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>
>;
export type GetApiSettingsHeartbeatsIdLogsQueryError = ErrorsAPIError;

export function useGetApiSettingsHeartbeatsIdLogs<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: undefined | GetApiSettingsHeartbeatsIdLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHeartbeatsIdLogs<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiSettingsHeartbeatsIdLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHeartbeatsIdLogs<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiSettingsHeartbeatsIdLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiSettingsHeartbeatsIdLogs<
  TData = Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiSettingsHeartbeatsIdLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHeartbeatsIdLogs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiSettingsHeartbeatsIdLogsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiSettingsHomeLocation = () => {
  return customInstance<LocationDeleteHomeLocationResponse>({
    url: `/api/settings/home-location`,
    method: 'DELETE',
  });
};

export const getDeleteApiSettingsHomeLocationMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiSettingsHomeLocation>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiSettingsHomeLocation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteApiSettingsHomeLocation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiSettingsHomeLocation>>,
    void
  > = () => {
    return deleteApiSettingsHomeLocation();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiSettingsHomeLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiSettingsHomeLocation>>
>;

export type DeleteApiSettingsHomeLocationMutationError = ErrorsAPIError;

export const useDeleteApiSettingsHomeLocation = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiSettingsHomeLocation>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiSettingsHomeLocation>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteApiSettingsHomeLocationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiSettingsHomeLocation = (signal?: AbortSignal) => {
  return customInstance<LocationGetHomeLocationResponse>({
    url: `/api/settings/home-location`,
    method: 'GET',
    signal,
  });
};

export const getGetApiSettingsHomeLocationQueryKey = () => {
  return [`/api/settings/home-location`] as const;
};

export const getGetApiSettingsHomeLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocation>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiSettingsHomeLocationQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSettingsHomeLocation>>> = ({
    signal,
  }) => getApiSettingsHomeLocation(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiSettingsHomeLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSettingsHomeLocation>>
>;
export type GetApiSettingsHomeLocationQueryError = ErrorsAPIError;

export function useGetApiSettingsHomeLocation<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHomeLocation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHomeLocation<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHomeLocation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHomeLocation<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocation>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiSettingsHomeLocation<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocation>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocation>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiSettingsHomeLocationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiSettingsHomeLocation = (
  locationSetHomeLocationRequest: LocationSetHomeLocationRequest
) => {
  return customInstance<LocationSetHomeLocationResponse>({
    url: `/api/settings/home-location`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: locationSetHomeLocationRequest,
  });
};

export const getPutApiSettingsHomeLocationMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSettingsHomeLocation>>,
    TError,
    { data: LocationSetHomeLocationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSettingsHomeLocation>>,
  TError,
  { data: LocationSetHomeLocationRequest },
  TContext
> => {
  const mutationKey = ['putApiSettingsHomeLocation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSettingsHomeLocation>>,
    { data: LocationSetHomeLocationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSettingsHomeLocation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSettingsHomeLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSettingsHomeLocation>>
>;
export type PutApiSettingsHomeLocationMutationBody = LocationSetHomeLocationRequest;
export type PutApiSettingsHomeLocationMutationError = ErrorsAPIError;

export const usePutApiSettingsHomeLocation = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSettingsHomeLocation>>,
      TError,
      { data: LocationSetHomeLocationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSettingsHomeLocation>>,
  TError,
  { data: LocationSetHomeLocationRequest },
  TContext
> => {
  const mutationOptions = getPutApiSettingsHomeLocationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiSettingsHomeLocationSunTimes = (signal?: AbortSignal) => {
  return customInstance<LocationGetSunTimesResponse>({
    url: `/api/settings/home-location/sun-times`,
    method: 'GET',
    signal,
  });
};

export const getGetApiSettingsHomeLocationSunTimesQueryKey = () => {
  return [`/api/settings/home-location/sun-times`] as const;
};

export const getGetApiSettingsHomeLocationSunTimesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiSettingsHomeLocationSunTimesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>> = ({
    signal,
  }) => getApiSettingsHomeLocationSunTimes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiSettingsHomeLocationSunTimesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>
>;
export type GetApiSettingsHomeLocationSunTimesQueryError = ErrorsAPIError;

export function useGetApiSettingsHomeLocationSunTimes<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHomeLocationSunTimes<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsHomeLocationSunTimes<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiSettingsHomeLocationSunTimes<
  TData = Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsHomeLocationSunTimes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiSettingsHomeLocationSunTimesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNotificationSettings = (signal?: AbortSignal) => {
  return customInstance<NotificationsNotificationSettings>({
    url: `/api/settings/notifications`,
    method: 'GET',
    signal,
  });
};

export const getGetNotificationSettingsQueryKey = () => {
  return [`/api/settings/notifications`] as const;
};

export const getGetNotificationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationSettings>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationSettings>>> = ({
    signal,
  }) => getNotificationSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetNotificationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationSettings>>
>;
export type GetNotificationSettingsQueryError = ErrorsAPIError;

export function useGetNotificationSettings<
  TData = Awaited<ReturnType<typeof getNotificationSettings>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getNotificationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetNotificationSettings<
  TData = Awaited<ReturnType<typeof getNotificationSettings>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getNotificationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetNotificationSettings<
  TData = Awaited<ReturnType<typeof getNotificationSettings>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetNotificationSettings<
  TData = Awaited<ReturnType<typeof getNotificationSettings>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetNotificationSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateNotificationSettings = (
  notificationsUpdateNotificationSettingsRequest: NotificationsUpdateNotificationSettingsRequest
) => {
  return customInstance<NotificationsNotificationSettings>({
    url: `/api/settings/notifications`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: notificationsUpdateNotificationSettingsRequest,
  });
};

export const getUpdateNotificationSettingsMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationSettings>>,
    TError,
    { data: NotificationsUpdateNotificationSettingsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationSettings>>,
  TError,
  { data: NotificationsUpdateNotificationSettingsRequest },
  TContext
> => {
  const mutationKey = ['updateNotificationSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationSettings>>,
    { data: NotificationsUpdateNotificationSettingsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateNotificationSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationSettings>>
>;
export type UpdateNotificationSettingsMutationBody = NotificationsUpdateNotificationSettingsRequest;
export type UpdateNotificationSettingsMutationError = ErrorsAPIError;

export const useUpdateNotificationSettings = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateNotificationSettings>>,
      TError,
      { data: NotificationsUpdateNotificationSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationSettings>>,
  TError,
  { data: NotificationsUpdateNotificationSettingsRequest },
  TContext
> => {
  const mutationOptions = getUpdateNotificationSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiSettingsRegional = () => {
  return customInstance<RegionalDeleteRegionalSettingsResponse>({
    url: `/api/settings/regional`,
    method: 'DELETE',
  });
};

export const getDeleteApiSettingsRegionalMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiSettingsRegional>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiSettingsRegional>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteApiSettingsRegional'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiSettingsRegional>>,
    void
  > = () => {
    return deleteApiSettingsRegional();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiSettingsRegionalMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiSettingsRegional>>
>;

export type DeleteApiSettingsRegionalMutationError = ErrorsAPIError;

export const useDeleteApiSettingsRegional = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiSettingsRegional>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiSettingsRegional>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteApiSettingsRegionalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiSettingsRegional = (signal?: AbortSignal) => {
  return customInstance<RegionalGetRegionalSettingsResponse>({
    url: `/api/settings/regional`,
    method: 'GET',
    signal,
  });
};

export const getGetApiSettingsRegionalQueryKey = () => {
  return [`/api/settings/regional`] as const;
};

export const getGetApiSettingsRegionalQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSettingsRegional>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsRegional>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiSettingsRegionalQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSettingsRegional>>> = ({ signal }) =>
    getApiSettingsRegional(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSettingsRegional>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiSettingsRegionalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSettingsRegional>>
>;
export type GetApiSettingsRegionalQueryError = ErrorsAPIError;

export function useGetApiSettingsRegional<
  TData = Awaited<ReturnType<typeof getApiSettingsRegional>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsRegional>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsRegional>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsRegional>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsRegional<
  TData = Awaited<ReturnType<typeof getApiSettingsRegional>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsRegional>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsRegional>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsRegional>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiSettingsRegional<
  TData = Awaited<ReturnType<typeof getApiSettingsRegional>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsRegional>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiSettingsRegional<
  TData = Awaited<ReturnType<typeof getApiSettingsRegional>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsRegional>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiSettingsRegionalQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiSettingsRegional = (
  regionalSetRegionalSettingsRequest: RegionalSetRegionalSettingsRequest
) => {
  return customInstance<RegionalSetRegionalSettingsResponse>({
    url: `/api/settings/regional`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: regionalSetRegionalSettingsRequest,
  });
};

export const getPutApiSettingsRegionalMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSettingsRegional>>,
    TError,
    { data: RegionalSetRegionalSettingsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSettingsRegional>>,
  TError,
  { data: RegionalSetRegionalSettingsRequest },
  TContext
> => {
  const mutationKey = ['putApiSettingsRegional'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSettingsRegional>>,
    { data: RegionalSetRegionalSettingsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSettingsRegional(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSettingsRegionalMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSettingsRegional>>
>;
export type PutApiSettingsRegionalMutationBody = RegionalSetRegionalSettingsRequest;
export type PutApiSettingsRegionalMutationError = ErrorsAPIError;

export const usePutApiSettingsRegional = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSettingsRegional>>,
      TError,
      { data: RegionalSetRegionalSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSettingsRegional>>,
  TError,
  { data: RegionalSetRegionalSettingsRequest },
  TContext
> => {
  const mutationOptions = getPutApiSettingsRegionalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const listUnitTypes = (signal?: AbortSignal) => {
  return customInstance<UnittypesListUnitTypesResponse>({
    url: `/api/unit-types`,
    method: 'GET',
    signal,
  });
};

export const getListUnitTypesQueryKey = () => {
  return [`/api/unit-types`] as const;
};

export const getListUnitTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listUnitTypes>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnitTypes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUnitTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnitTypes>>> = ({ signal }) =>
    listUnitTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUnitTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListUnitTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listUnitTypes>>>;
export type ListUnitTypesQueryError = ErrorsAPIError;

export function useListUnitTypes<
  TData = Awaited<ReturnType<typeof listUnitTypes>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnitTypes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUnitTypes>>,
          TError,
          Awaited<ReturnType<typeof listUnitTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUnitTypes<
  TData = Awaited<ReturnType<typeof listUnitTypes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnitTypes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUnitTypes>>,
          TError,
          Awaited<ReturnType<typeof listUnitTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUnitTypes<
  TData = Awaited<ReturnType<typeof listUnitTypes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnitTypes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListUnitTypes<
  TData = Awaited<ReturnType<typeof listUnitTypes>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnitTypes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListUnitTypesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createUnitType = (
  unittypesCreateUnitTypeRequest: UnittypesCreateUnitTypeRequest,
  signal?: AbortSignal
) => {
  return customInstance<UnittypesUnitTypeResponse>({
    url: `/api/unit-types`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unittypesCreateUnitTypeRequest,
    signal,
  });
};

export const getCreateUnitTypeMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUnitType>>,
    TError,
    { data: UnittypesCreateUnitTypeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUnitType>>,
  TError,
  { data: UnittypesCreateUnitTypeRequest },
  TContext
> => {
  const mutationKey = ['createUnitType'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUnitType>>,
    { data: UnittypesCreateUnitTypeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createUnitType(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUnitTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createUnitType>>>;
export type CreateUnitTypeMutationBody = UnittypesCreateUnitTypeRequest;
export type CreateUnitTypeMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useCreateUnitType = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUnitType>>,
      TError,
      { data: UnittypesCreateUnitTypeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createUnitType>>,
  TError,
  { data: UnittypesCreateUnitTypeRequest },
  TContext
> => {
  const mutationOptions = getCreateUnitTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteUnitType = (id: string) => {
  return customInstance<void>({ url: `/api/unit-types/${id}`, method: 'DELETE' });
};

export const getDeleteUnitTypeMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUnitType>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUnitType>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteUnitType'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUnitType>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return deleteUnitType(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUnitTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUnitType>>>;

export type DeleteUnitTypeMutationError = ErrorsAPIError;

export const useDeleteUnitType = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUnitType>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUnitType>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteUnitTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getUnitType = (id: string, signal?: AbortSignal) => {
  return customInstance<UnittypesUnitTypeResponse>({
    url: `/api/unit-types/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetUnitTypeQueryKey = (id?: string) => {
  return [`/api/unit-types/${id}`] as const;
};

export const getGetUnitTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnitType>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnitType>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUnitTypeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnitType>>> = ({ signal }) =>
    getUnitType(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnitType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUnitTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getUnitType>>>;
export type GetUnitTypeQueryError = ErrorsAPIError;

export function useGetUnitType<
  TData = Awaited<ReturnType<typeof getUnitType>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnitType>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnitType>>,
          TError,
          Awaited<ReturnType<typeof getUnitType>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUnitType<
  TData = Awaited<ReturnType<typeof getUnitType>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnitType>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnitType>>,
          TError,
          Awaited<ReturnType<typeof getUnitType>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUnitType<
  TData = Awaited<ReturnType<typeof getUnitType>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnitType>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUnitType<
  TData = Awaited<ReturnType<typeof getUnitType>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnitType>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUnitTypeQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateUnitType = (
  id: string,
  unittypesUpdateUnitTypeRequest: UnittypesUpdateUnitTypeRequest
) => {
  return customInstance<UnittypesUnitTypeResponse>({
    url: `/api/unit-types/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: unittypesUpdateUnitTypeRequest,
  });
};

export const getUpdateUnitTypeMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUnitType>>,
    TError,
    { id: string; data: UnittypesUpdateUnitTypeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUnitType>>,
  TError,
  { id: string; data: UnittypesUpdateUnitTypeRequest },
  TContext
> => {
  const mutationKey = ['updateUnitType'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUnitType>>,
    { id: string; data: UnittypesUpdateUnitTypeRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUnitType(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUnitTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateUnitType>>>;
export type UpdateUnitTypeMutationBody = UnittypesUpdateUnitTypeRequest;
export type UpdateUnitTypeMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateUnitType = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUnitType>>,
      TError,
      { id: string; data: UnittypesUpdateUnitTypeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUnitType>>,
  TError,
  { id: string; data: UnittypesUpdateUnitTypeRequest },
  TContext
> => {
  const mutationOptions = getUpdateUnitTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const createUnit = (
  id: string,
  unittypesCreateUnitRequest: UnittypesCreateUnitRequest,
  signal?: AbortSignal
) => {
  return customInstance<UnittypesUnitResponse>({
    url: `/api/unit-types/${id}/units`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unittypesCreateUnitRequest,
    signal,
  });
};

export const getCreateUnitMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUnit>>,
    TError,
    { id: string; data: UnittypesCreateUnitRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUnit>>,
  TError,
  { id: string; data: UnittypesCreateUnitRequest },
  TContext
> => {
  const mutationKey = ['createUnit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUnit>>,
    { id: string; data: UnittypesCreateUnitRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return createUnit(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof createUnit>>>;
export type CreateUnitMutationBody = UnittypesCreateUnitRequest;
export type CreateUnitMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useCreateUnit = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUnit>>,
      TError,
      { id: string; data: UnittypesCreateUnitRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createUnit>>,
  TError,
  { id: string; data: UnittypesCreateUnitRequest },
  TContext
> => {
  const mutationOptions = getCreateUnitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteUnit = (id: string, unitId: string) => {
  return customInstance<void>({ url: `/api/unit-types/${id}/units/${unitId}`, method: 'DELETE' });
};

export const getDeleteUnitMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUnit>>,
    TError,
    { id: string; unitId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUnit>>,
  TError,
  { id: string; unitId: string },
  TContext
> => {
  const mutationKey = ['deleteUnit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUnit>>,
    { id: string; unitId: string }
  > = (props) => {
    const { id, unitId } = props ?? {};

    return deleteUnit(id, unitId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUnitMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUnit>>>;

export type DeleteUnitMutationError = ErrorsAPIError;

export const useDeleteUnit = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUnit>>,
      TError,
      { id: string; unitId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUnit>>,
  TError,
  { id: string; unitId: string },
  TContext
> => {
  const mutationOptions = getDeleteUnitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateUnit = (
  id: string,
  unitId: string,
  unittypesUpdateUnitRequest: UnittypesUpdateUnitRequest
) => {
  return customInstance<UnittypesUnitResponse>({
    url: `/api/unit-types/${id}/units/${unitId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: unittypesUpdateUnitRequest,
  });
};

export const getUpdateUnitMutationOptions = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUnit>>,
    TError,
    { id: string; unitId: string; data: UnittypesUpdateUnitRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUnit>>,
  TError,
  { id: string; unitId: string; data: UnittypesUpdateUnitRequest },
  TContext
> => {
  const mutationKey = ['updateUnit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUnit>>,
    { id: string; unitId: string; data: UnittypesUpdateUnitRequest }
  > = (props) => {
    const { id, unitId, data } = props ?? {};

    return updateUnit(id, unitId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof updateUnit>>>;
export type UpdateUnitMutationBody = UnittypesUpdateUnitRequest;
export type UpdateUnitMutationError = ValidationErrorResponse | ErrorsAPIError;

export const useUpdateUnit = <
  TError = ValidationErrorResponse | ErrorsAPIError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUnit>>,
      TError,
      { id: string; unitId: string; data: UnittypesUpdateUnitRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUnit>>,
  TError,
  { id: string; unitId: string; data: UnittypesUpdateUnitRequest },
  TContext
> => {
  const mutationOptions = getUpdateUnitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiUtilitiesCategoriesIdInsights = (
  id: string,
  params?: GetApiUtilitiesCategoriesIdInsightsParams,
  signal?: AbortSignal
) => {
  return customInstance<UtilitiesInsightsResponse>({
    url: `/api/utilities/categories/${id}/insights`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetApiUtilitiesCategoriesIdInsightsQueryKey = (
  id?: string,
  params?: GetApiUtilitiesCategoriesIdInsightsParams
) => {
  return [`/api/utilities/categories/${id}/insights`, ...(params ? [params] : [])] as const;
};

export const getGetApiUtilitiesCategoriesIdInsightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiUtilitiesCategoriesIdInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiUtilitiesCategoriesIdInsightsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>> = ({
    signal,
  }) => getApiUtilitiesCategoriesIdInsights(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiUtilitiesCategoriesIdInsightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>
>;
export type GetApiUtilitiesCategoriesIdInsightsQueryError = ErrorsAPIError;

export function useGetApiUtilitiesCategoriesIdInsights<
  TData = Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params: undefined | GetApiUtilitiesCategoriesIdInsightsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
          TError,
          Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiUtilitiesCategoriesIdInsights<
  TData = Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiUtilitiesCategoriesIdInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
          TError,
          Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiUtilitiesCategoriesIdInsights<
  TData = Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiUtilitiesCategoriesIdInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiUtilitiesCategoriesIdInsights<
  TData = Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
  TError = ErrorsAPIError,
>(
  id: string,
  params?: GetApiUtilitiesCategoriesIdInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUtilitiesCategoriesIdInsights>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiUtilitiesCategoriesIdInsightsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiUtilitiesConfig = () => {
  return customInstance<UtilitiesDeleteConfigResponse>({
    url: `/api/utilities/config`,
    method: 'DELETE',
  });
};

export const getDeleteApiUtilitiesConfigMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiUtilitiesConfig>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiUtilitiesConfig>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteApiUtilitiesConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiUtilitiesConfig>>,
    void
  > = () => {
    return deleteApiUtilitiesConfig();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiUtilitiesConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiUtilitiesConfig>>
>;

export type DeleteApiUtilitiesConfigMutationError = ErrorsAPIError;

export const useDeleteApiUtilitiesConfig = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiUtilitiesConfig>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiUtilitiesConfig>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteApiUtilitiesConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiUtilitiesConfig = (signal?: AbortSignal) => {
  return customInstance<UtilitiesGetConfigResponse>({
    url: `/api/utilities/config`,
    method: 'GET',
    signal,
  });
};

export const getGetApiUtilitiesConfigQueryKey = () => {
  return [`/api/utilities/config`] as const;
};

export const getGetApiUtilitiesConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesConfig>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUtilitiesConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUtilitiesConfig>>> = ({ signal }) =>
    getApiUtilitiesConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiUtilitiesConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUtilitiesConfig>>
>;
export type GetApiUtilitiesConfigQueryError = ErrorsAPIError;

export function useGetApiUtilitiesConfig<
  TData = Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesConfig>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiUtilitiesConfig>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiUtilitiesConfig<
  TData = Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesConfig>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiUtilitiesConfig>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiUtilitiesConfig<
  TData = Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesConfig>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiUtilitiesConfig<
  TData = Awaited<ReturnType<typeof getApiUtilitiesConfig>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesConfig>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiUtilitiesConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiUtilitiesConfig = (utilitiesSaveConfigRequest: UtilitiesSaveConfigRequest) => {
  return customInstance<UtilitiesSaveConfigResponse>({
    url: `/api/utilities/config`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: utilitiesSaveConfigRequest,
  });
};

export const getPutApiUtilitiesConfigMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUtilitiesConfig>>,
    TError,
    { data: UtilitiesSaveConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUtilitiesConfig>>,
  TError,
  { data: UtilitiesSaveConfigRequest },
  TContext
> => {
  const mutationKey = ['putApiUtilitiesConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUtilitiesConfig>>,
    { data: UtilitiesSaveConfigRequest }
  > = (props) => {
    const { data } = props ?? {};

    return putApiUtilitiesConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUtilitiesConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUtilitiesConfig>>
>;
export type PutApiUtilitiesConfigMutationBody = UtilitiesSaveConfigRequest;
export type PutApiUtilitiesConfigMutationError = ErrorsAPIError;

export const usePutApiUtilitiesConfig = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUtilitiesConfig>>,
      TError,
      { data: UtilitiesSaveConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUtilitiesConfig>>,
  TError,
  { data: UtilitiesSaveConfigRequest },
  TContext
> => {
  const mutationOptions = getPutApiUtilitiesConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiUtilitiesExport = (
  utilitiesExportRequest: UtilitiesExportRequest,
  signal?: AbortSignal
) => {
  return customInstance<UtilitiesExportResponse>({
    url: `/api/utilities/export`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: utilitiesExportRequest,
    signal,
  });
};

export const getPostApiUtilitiesExportMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUtilitiesExport>>,
    TError,
    { data: UtilitiesExportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUtilitiesExport>>,
  TError,
  { data: UtilitiesExportRequest },
  TContext
> => {
  const mutationKey = ['postApiUtilitiesExport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUtilitiesExport>>,
    { data: UtilitiesExportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUtilitiesExport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUtilitiesExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUtilitiesExport>>
>;
export type PostApiUtilitiesExportMutationBody = UtilitiesExportRequest;
export type PostApiUtilitiesExportMutationError = ErrorsAPIError;

export const usePostApiUtilitiesExport = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUtilitiesExport>>,
      TError,
      { data: UtilitiesExportRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUtilitiesExport>>,
  TError,
  { data: UtilitiesExportRequest },
  TContext
> => {
  const mutationOptions = getPostApiUtilitiesExportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiUtilitiesImport = (
  utilitiesImportRequest: UtilitiesImportRequest,
  signal?: AbortSignal
) => {
  return customInstance<UtilitiesImportResponse>({
    url: `/api/utilities/import`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: utilitiesImportRequest,
    signal,
  });
};

export const getPostApiUtilitiesImportMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUtilitiesImport>>,
    TError,
    { data: UtilitiesImportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUtilitiesImport>>,
  TError,
  { data: UtilitiesImportRequest },
  TContext
> => {
  const mutationKey = ['postApiUtilitiesImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUtilitiesImport>>,
    { data: UtilitiesImportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUtilitiesImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUtilitiesImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUtilitiesImport>>
>;
export type PostApiUtilitiesImportMutationBody = UtilitiesImportRequest;
export type PostApiUtilitiesImportMutationError = ErrorsAPIError;

export const usePostApiUtilitiesImport = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUtilitiesImport>>,
      TError,
      { data: UtilitiesImportRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUtilitiesImport>>,
  TError,
  { data: UtilitiesImportRequest },
  TContext
> => {
  const mutationOptions = getPostApiUtilitiesImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiUtilitiesOverview = (
  params?: GetApiUtilitiesOverviewParams,
  signal?: AbortSignal
) => {
  return customInstance<UtilitiesOverviewResponse>({
    url: `/api/utilities/overview`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetApiUtilitiesOverviewQueryKey = (params?: GetApiUtilitiesOverviewParams) => {
  return [`/api/utilities/overview`, ...(params ? [params] : [])] as const;
};

export const getGetApiUtilitiesOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
  TError = ErrorsAPIError,
>(
  params?: GetApiUtilitiesOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesOverview>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUtilitiesOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUtilitiesOverview>>> = ({
    signal,
  }) => getApiUtilitiesOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiUtilitiesOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUtilitiesOverview>>
>;
export type GetApiUtilitiesOverviewQueryError = ErrorsAPIError;

export function useGetApiUtilitiesOverview<
  TData = Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
  TError = ErrorsAPIError,
>(
  params: undefined | GetApiUtilitiesOverviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
          TError,
          Awaited<ReturnType<typeof getApiUtilitiesOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiUtilitiesOverview<
  TData = Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
  TError = ErrorsAPIError,
>(
  params?: GetApiUtilitiesOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
          TError,
          Awaited<ReturnType<typeof getApiUtilitiesOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiUtilitiesOverview<
  TData = Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
  TError = ErrorsAPIError,
>(
  params?: GetApiUtilitiesOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiUtilitiesOverview<
  TData = Awaited<ReturnType<typeof getApiUtilitiesOverview>>,
  TError = ErrorsAPIError,
>(
  params?: GetApiUtilitiesOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUtilitiesOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiUtilitiesOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiVirtualDevices = (signal?: AbortSignal) => {
  return customInstance<VirtualdevicesListVirtualDevicesResponse>({
    url: `/api/virtual-devices`,
    method: 'GET',
    signal,
  });
};

export const getGetApiVirtualDevicesQueryKey = () => {
  return [`/api/virtual-devices`] as const;
};

export const getGetApiVirtualDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVirtualDevices>>,
  TError = ErrorsAPIError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevices>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiVirtualDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVirtualDevices>>> = ({ signal }) =>
    getApiVirtualDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVirtualDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiVirtualDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVirtualDevices>>
>;
export type GetApiVirtualDevicesQueryError = ErrorsAPIError;

export function useGetApiVirtualDevices<
  TData = Awaited<ReturnType<typeof getApiVirtualDevices>>,
  TError = ErrorsAPIError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiVirtualDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiVirtualDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiVirtualDevices<
  TData = Awaited<ReturnType<typeof getApiVirtualDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiVirtualDevices>>,
          TError,
          Awaited<ReturnType<typeof getApiVirtualDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiVirtualDevices<
  TData = Awaited<ReturnType<typeof getApiVirtualDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiVirtualDevices<
  TData = Awaited<ReturnType<typeof getApiVirtualDevices>>,
  TError = ErrorsAPIError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiVirtualDevicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiVirtualDevices = (
  virtualdevicesCreateVirtualDeviceHTTPRequest: VirtualdevicesCreateVirtualDeviceHTTPRequest,
  signal?: AbortSignal
) => {
  return customInstance<VirtualdevicesVirtualDeviceResponse>({
    url: `/api/virtual-devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: virtualdevicesCreateVirtualDeviceHTTPRequest,
    signal,
  });
};

export const getPostApiVirtualDevicesMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiVirtualDevices>>,
    TError,
    { data: VirtualdevicesCreateVirtualDeviceHTTPRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiVirtualDevices>>,
  TError,
  { data: VirtualdevicesCreateVirtualDeviceHTTPRequest },
  TContext
> => {
  const mutationKey = ['postApiVirtualDevices'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiVirtualDevices>>,
    { data: VirtualdevicesCreateVirtualDeviceHTTPRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiVirtualDevices(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiVirtualDevicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiVirtualDevices>>
>;
export type PostApiVirtualDevicesMutationBody = VirtualdevicesCreateVirtualDeviceHTTPRequest;
export type PostApiVirtualDevicesMutationError = ErrorsAPIError;

export const usePostApiVirtualDevices = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiVirtualDevices>>,
      TError,
      { data: VirtualdevicesCreateVirtualDeviceHTTPRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiVirtualDevices>>,
  TError,
  { data: VirtualdevicesCreateVirtualDeviceHTTPRequest },
  TContext
> => {
  const mutationOptions = getPostApiVirtualDevicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiVirtualDevicesId = (id: string) => {
  return customInstance<void>({ url: `/api/virtual-devices/${id}`, method: 'DELETE' });
};

export const getDeleteApiVirtualDevicesIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiVirtualDevicesId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiVirtualDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteApiVirtualDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiVirtualDevicesId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApiVirtualDevicesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiVirtualDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiVirtualDevicesId>>
>;

export type DeleteApiVirtualDevicesIdMutationError = ErrorsAPIError;

export const useDeleteApiVirtualDevicesId = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiVirtualDevicesId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiVirtualDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteApiVirtualDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiVirtualDevicesId = (id: string, signal?: AbortSignal) => {
  return customInstance<VirtualdevicesVirtualDeviceResponse>({
    url: `/api/virtual-devices/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiVirtualDevicesIdQueryKey = (id?: string) => {
  return [`/api/virtual-devices/${id}`] as const;
};

export const getGetApiVirtualDevicesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevicesId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiVirtualDevicesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVirtualDevicesId>>> = ({ signal }) =>
    getApiVirtualDevicesId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiVirtualDevicesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiVirtualDevicesId>>
>;
export type GetApiVirtualDevicesIdQueryError = ErrorsAPIError;

export function useGetApiVirtualDevicesId<
  TData = Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevicesId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiVirtualDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiVirtualDevicesId<
  TData = Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevicesId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
          TError,
          Awaited<ReturnType<typeof getApiVirtualDevicesId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiVirtualDevicesId<
  TData = Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevicesId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiVirtualDevicesId<
  TData = Awaited<ReturnType<typeof getApiVirtualDevicesId>>,
  TError = ErrorsAPIError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiVirtualDevicesId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiVirtualDevicesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiVirtualDevicesId = (
  id: string,
  virtualdevicesUpdateVirtualDeviceHTTPRequest: VirtualdevicesUpdateVirtualDeviceHTTPRequest
) => {
  return customInstance<VirtualdevicesVirtualDeviceResponse>({
    url: `/api/virtual-devices/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: virtualdevicesUpdateVirtualDeviceHTTPRequest,
  });
};

export const getPutApiVirtualDevicesIdMutationOptions = <
  TError = ErrorsAPIError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiVirtualDevicesId>>,
    TError,
    { id: string; data: VirtualdevicesUpdateVirtualDeviceHTTPRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiVirtualDevicesId>>,
  TError,
  { id: string; data: VirtualdevicesUpdateVirtualDeviceHTTPRequest },
  TContext
> => {
  const mutationKey = ['putApiVirtualDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiVirtualDevicesId>>,
    { id: string; data: VirtualdevicesUpdateVirtualDeviceHTTPRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiVirtualDevicesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiVirtualDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiVirtualDevicesId>>
>;
export type PutApiVirtualDevicesIdMutationBody = VirtualdevicesUpdateVirtualDeviceHTTPRequest;
export type PutApiVirtualDevicesIdMutationError = ErrorsAPIError;

export const usePutApiVirtualDevicesId = <TError = ErrorsAPIError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiVirtualDevicesId>>,
      TError,
      { id: string; data: VirtualdevicesUpdateVirtualDeviceHTTPRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiVirtualDevicesId>>,
  TError,
  { id: string; data: VirtualdevicesUpdateVirtualDeviceHTTPRequest },
  TContext
> => {
  const mutationOptions = getPutApiVirtualDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
